(function() {
    'use strict';

    angular
        .module('infiltrationApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ngSanitize',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'uiGmapgoogle-maps',
            'ngStorage',
            'chart.js'
        ])



        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" >{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

/**
 * Created by g9a on 9/19/16.
 */
(function () {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('InfiltrationCalculationController', InfiltrationCalculationController);

    InfiltrationCalculationController.$inject = ['$scope', '$localStorage', 'Principal', '$state', '$sce', 'InfiltrationEntry', 'InfiltrationResult', 'EnergyCalcQuery', 'EnergyCalculation', 'BuildingType', 'UnitConversion', 'MoistureTransferQuery', 'MoistureTransferCalculation'];

    function InfiltrationCalculationController ($scope, $localStorage, Principal, $state, $sce, InfiltrationEntry, InfiltrationResult, EnergyCalcQuery, EnergyCalculation, BuildingType, UnitConversion, MoistureTransferQuery, MoistureTransferCalculation) {
        var vm = this;
        var locationString = '';
        $scope.infiltrationEntry = $localStorage.infiltrationEntry;
        $scope.infiltrationResult = $localStorage.infiltrationResult;
        $scope.leakageUnitDisplayValue = _.find($localStorage.leakageUnits, { 'val': $scope.infiltrationEntry.leakageUnit}).name;
        $scope.areaUnitDisplayValue = _.find($localStorage.areaUnits, { 'val': $scope.infiltrationEntry.areaUnit}).name;
        $scope.gasCostUnitsDisplayValue = _.find($localStorage.gasCostUnitss, {'val': $scope.infiltrationEntry.gasCostUnits}).name;
        $scope.mtUnitsDisplayValue = _.find($localStorage.moistureTransferUnits, { 'val': $scope.infiltrationEntry.areaUnit}).name;
        $scope.elaUnitsDisplayValue = _.find($localStorage.elaUnits, { 'val': $scope.infiltrationEntry.areaUnit}).name;
        $scope.moistureELADisplayValue = _.find($localStorage.moistureTransferELA, { 'val': $scope.infiltrationEntry.areaUnit}).name;
        $scope.moistureTransferTotalDisplay = _.find($localStorage.moistureTransferTotal, { 'val': $scope.infiltrationEntry.areaUnit}).name;
        $scope.gasSavingsUnitsDisplayValue = "kBtu";
        $scope.gasSavingsDisplayValue = 0.0;
        $scope.gasCostSavingsDisplayValue = 0.0;
        $scope.electricCostSavingsDisplayValue = 0.0;
        $scope.electricSavingsDisplayValue = 0.0;
        $scope.totalSavingsDisplayValue = 0.0;
        $scope.totalCostSavingsDisplayValue = 0.0;
        $scope.bLeakFt = 0.0;
        $scope.rLeakFt = 0.0;

        switch ($scope.infiltrationEntry.mapLocation.country_abbrev) {
            case 'USA':
                $scope.currencyDisplayValue = "$ ";
                break;
            case 'CAN':
                $scope.currencyDisplayValue = "C$ ";
                break;
            case 'CHN':
                $scope.currencyDisplayValue = "¥ ";
                break;
        }


        var map_loc_id = $scope.infiltrationEntry.mapLocation.id;
        $scope.locationString = $scope.infiltrationEntry.mapLocation.city + ' ' + $scope.infiltrationEntry.mapLocation.state_abbrev + ' ' + $scope.infiltrationEntry.mapLocation.country_abbrev;
        var bldg_type_id = $scope.infiltrationEntry.buildingType.id;
        var buildingType = BuildingType.get({id: bldg_type_id});
        var elaArea = $localStorage.elaAreas.filter(function(e) {
            return e.id == bldg_type_id;
        });
        console.log('ela area ' + elaArea.id);

        $scope.fa = elaArea[0].fa; // meters^2
        $scope.ea = elaArea[0].ea; // meters^2
        $scope.uifa = 0.0; // meters^2
        var EnergyCalc = EnergyCalcQuery.get({map_location_id:map_loc_id, building_type_id:bldg_type_id}, function() {
            var x = EnergyCalc.xElectric;
            var x2 = EnergyCalc.x2Electric;
            var g = EnergyCalc.xGas;
            var g2 = EnergyCalc.x2Gas;
            $scope.bLeak = 0;
            $scope.rLeak = 0;
            $scope.actualAreaFt = 0;
            var electricCost = $scope.infiltrationEntry.costElectricity;
            var costGas = 0;

            if ($scope.infiltrationEntry.leakageUnit === 'CFMSQFT') {
                $scope.bLeak = parseFloat(UnitConversion.toLeakageMeters($scope.infiltrationEntry.basecaseLeakage));
                $scope.rLeak = parseFloat(UnitConversion.toLeakageMeters($scope.infiltrationEntry.retrofittedLeakage));
            }
            else {
                parseFloat($scope.bLeak = $scope.infiltrationEntry.basecaseLeakage);
                parseFloat($scope.rLeak = $scope.infiltrationEntry.retrofittedLeakage);
            }

         
            if ($scope.infiltrationEntry.areaUnit === 'M2') {
                $scope.uifa = $scope.infiltrationEntry.area;
                $scope.actualAreaFt = parseFloat(UnitConversion.toSquareFeet($scope.infiltrationEntry.area));
            } else {
                $scope.actualAreaFt = $scope.infiltrationEntry.area;
                $scope.uifa = parseFloat(UnitConversion.toMetersSquared($scope.infiltrationEntry.area));
            }
            if ($scope.infiltrationEntry.gasCostUnits === 'M3') {
                costGas = parseFloat(UnitConversion.toFeetCubed($scope.infiltrationEntry.costGas));
            } else {
                costGas = $scope.infiltrationEntry.costGas;
            }
            $scope.baseELA = (0.57719 * $scope.ea * $scope.uifa/$scope.fa * $scope.bLeak)/10000.0;
            $scope.retroELA = (0.57719 * $scope.ea * $scope.uifa/$scope.fa * $scope.rLeak)/10000.0;
            if ($scope.infiltrationEntry.areaUnit === 'SQFT') {
                $scope.baseELA = $scope. baseELA * 10.7639;
                $scope.retroELA = $scope.retroELA * 10.7639;
            }

            $scope.infiltrationResult.electricSavings = EnergyCalculation.calculateEnergySavings(x, x2, $scope.bLeak, $scope.rLeak, $scope.actualAreaFt, buildingType.floorArea);
            $scope.infiltrationResult.gasSavings = EnergyCalculation.calculateEnergySavings(g, g2, $scope.bLeak, $scope.rLeak, $scope.actualAreaFt, buildingType.floorArea);
            $scope.infiltrationResult.electricCostSavings = EnergyCalculation.costSavings($scope.infiltrationResult.electricSavings, electricCost);
            // gasCostSavings in cubic feet


            $scope.electricSavingsDisplayValue = $scope.infiltrationResult.electricSavings;
            $scope.electricCostSavingsDisplayValue = $scope.infiltrationResult.electricCostSavings;

            switch ($scope.infiltrationEntry.gasCostUnits) {
                case 'M3':
                    $scope.gasCostSavingsDisplayValue = EnergyCalculation.costSavingsGas($scope.infiltrationResult.gasSavings, costGas);
                    $scope.gasSavingsDisplayValue = parseFloat(UnitConversion.kbtuToMeterCubed($scope.infiltrationResult.gasSavings));
                    $scope.gasCostUnitsDisplayValue =  $localStorage.gasCostUnitss[1].name;
                    $scope.gasSavingsUnitsDisplayValue = $localStorage.gasCostUnitss[1].name;
                    break;
                default:
                    $scope.gasSavingsDisplayValue = parseFloat(UnitConversion.kbtuToFeetCubed($scope.infiltrationResult.gasSavings));
                    $scope.gasCostSavingsDisplayValue = EnergyCalculation.costSavingsGasFt($scope.gasSavingsDisplayValue, costGas);
                    //$scope.gasSavingsDisplayValue = $scope.infiltrationResult.gasSavings;
                    console.log("gas savings display value " + $scope.gasSavingsDisplayValue);
                    $scope.gasCostUnitsDisplayValue =  $localStorage.gasCostUnitss[0].name;
                    $scope.gasSavingsUnitsDisplayValue =  $localStorage.gasCostUnitss[0].energy;
                    break;
            }

            $scope.totalSavingsDisplayValue = $scope.gasSavingsDisplayValue + $scope.electricSavingsDisplayValue;
            $scope.totalCostSavingsDisplayValue = $scope.gasCostSavingsDisplayValue + $scope.electricCostSavingsDisplayValue;

            save();
            $scope.labels = ["Electricity", "Gas"];
            $scope.data = [$scope.electricCostSavingsDisplayValue, $scope.gasCostSavingsDisplayValue];

            $scope.gaslabels = ["Gas Saved"];
            $scope.gasdata = [$scope.gasSavingsDisplayValue];
            $scope.electricitylabels = ["Electricity Saved"];
            $scope.electricitydata = [$scope.electricSavingsDisplayValue];
            $scope.options = {
                title: {
                    display: true,
                    text: 'Cost Savings ' + $scope.currencyDisplayValue,
                    fontStyle: 'bold',
                    fontColor: '#000'
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            };
            $scope.colors = [
                {
                    backgroundColor: "rgba(218, 237, 246, 0.5)",
                    pointBackgroundColor: "rgba(218, 237, 246, 1)",
                    pointHoverBackgroundColor: "rgba(252, 255, 228, 1)",
                    borderColor: "rgba(159,204,0, 1)",
                    pointBorderColor: '#fff',
                    pointHoverBorderColor: "rgba(159,204,0, 1)"
                },
                {
                    backgroundColor: "rgba(153, 236, 233, 0.5)",
                    pointBackgroundColor: "rgba(153, 236, 233, 1)",
                    pointHoverBackgroundColor: "rgba(252, 248, 228, 1)",
                    borderColor: "rgba(159,204,0, 1)",
                    pointBorderColor: '#fff',
                    pointHoverBorderColor: "rgba(159,204,0, 1)"
                }
            ];

            var MoistureCalc = MoistureTransferQuery.get({map_location_id:map_loc_id, building_type_id: bldg_type_id}, function () {
                var ex = MoistureCalc.ex;
                var ex_2 = MoistureCalc.ex2;
                var econst = MoistureCalc.econstant;
                var bLeak2 = $scope.bLeak * $scope.bLeak;
                var rLeak2 = $scope.rLeak * $scope.rLeak;
                var elaBleak = .000057719 * $scope.bLeak * $scope.ea * 1550 ;
                var elaRleak = .000057719 * $scope.rLeak * $scope.ea * 1550 ;
                var baseresedentialELA = 0.01005 * $scope.bLeak * 1550;
                var retroresidentialELA = 0.01005 * $scope.rLeak * 1550;


                // $scope.uifa/$scope.fa * (ex_2 * bLeak2) + (ex * $scope.bLeakFt) + econst;
                // E76 *                   (F12 * E79^2)  +  (G12 * E79)           + H12)
                // Per Som email, 3/13/19
                //  Do not use the uifa/fa adjustments.

                // $scope.basecaseMoistureTransfer = $scope.uifa/$scope.fa * (ex_2 * bLeak2) + (ex * $scope.bLeak) + econst;
                // $scope.retrofittedMoistureTransfer = $scope.uifa/$scope.fa * (ex_2 * rLeak2) + (ex * $scope.rLeak) + econst;
                $scope.basecaseMoistureTransfer = (ex_2 * bLeak2) + (ex * $scope.bLeak) + econst;
                $scope.retrofittedMoistureTransfer =  (ex_2 * rLeak2) + (ex * $scope.rLeak) + econst;

//                $scope.basecaseMoistureTransfer = ex_2 * (bLeak2 + ex * $scope.bLeakFt + econst);
//                $scope.retrofittedMoistureTransfer = ex_2 * (rLeak2 + ex * $scope.rLeakFt + econst);

                if ($scope.infiltrationEntry.areaUnit === 'M2') {
                    $scope.basecaseMoistureTransfer = $scope.basecaseMoistureTransfer * 4.8824;
                    $scope.retrofittedMoistureTransfer = $scope.retrofittedMoistureTransfer * 4.8824;
                    $scope.basecaseGallonsPerYear = $scope.basecaseMoistureTransfer * $scope.ea  * 3.785412;
                    $scope.retrofittedGallonsPerYear = $scope.retrofittedMoistureTransfer * $scope.ea * 3.785412;
                    if($scope.infiltrationEntry.buildingType.shortName === "residential"){
                        $scope.basecaseperELA = $scope.basecaseGallonsPerYear/baseresedentialELA;
                        $scope.retrofittedPerELA = $scope.retrofittedGallonsPerYear/retroresidentialELA;
                    }
                    else{
                   
                    $scope.basecaseperELA = $scope.basecaseGallonsPerYear/elaBleak;
                    $scope.retrofittedPerELA = $scope.retrofittedGallonsPerYear/elaRleak;
                    }
                    
                    
                } else {
                    $scope.basecaseMoistureTransfer = $scope.basecaseMoistureTransfer/8.35;
                    $scope.retrofittedMoistureTransfer = $scope.retrofittedMoistureTransfer/8.35;
                    $scope.basecaseGallonsPerYear = $scope.basecaseMoistureTransfer * $scope.ea * 10.76391041671;
                    $scope.retrofittedGallonsPerYear = $scope.retrofittedMoistureTransfer * $scope.ea* 10.76391041671;
                    if($scope.infiltrationEntry.buildingType.shortName === "residential"){
                        $scope.basecaseperELA = $scope.basecaseGallonsPerYear/baseresedentialELA ;
                        $scope.retrofittedPerELA = $scope.retrofittedGallonsPerYear/retroresidentialELA;
                    }
                    else{
                   
                    $scope.basecaseperELA = $scope.basecaseGallonsPerYear/elaBleak;
                    $scope.retrofittedPerELA = $scope.retrofittedGallonsPerYear/elaRleak;
                    }
                } 

                $scope.reductionMoistureTransfer = $scope.basecaseMoistureTransfer - $scope.retrofittedMoistureTransfer;
                $scope.mtlabels = ["Base Case", "Retrofitted"];
                $scope.mtdata = [$scope.basecaseMoistureTransfer, $scope.retrofittedMoistureTransfer];
                $scope.mtoptions = {
                    title: {
                        display: true,
                        text: 'Moisture Transfer Reduction',
                        fontStyle: 'bold',
                        fontColor: '#000'
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            scaleLabel: {
                                display: true,
                                labelString: $scope.mtUnitsDisplayValue
                            }
                        }]
                    }
                };
                $scope.mtcolors = [
                    {
                        backgroundColor: "rgba(252, 248, 228, 0.5)",
                        pointBackgroundColor: "rgba(252, 248, 228, 1)",
                        pointHoverBackgroundColor: "rgba(252, 248, 228, 1)",
                        borderColor: "rgba(159,204,0, 1)",
                        pointBorderColor: '#fff',
                        pointHoverBorderColor: "rgba(159,204,0, 1)"
                    },
                    {
                        backgroundColor: "rgba(248, 212, 127, 0.5)",
                        pointBackgroundColor: "rgba(248, 212, 127, 1)",
                        pointHoverBackgroundColor: "rgba(252, 255, 228, 1)",
                        borderColor: "rgba(159,204,0, 1)",
                        pointBorderColor: '#fff',
                        pointHoverBorderColor: "rgba(159,204,0, 1)"
                    }
                ];
            });
        });

        //vm.save = save;

        function save() {
            vm.isSavingResult = true;
            vm.isSaving = true;
            $scope.infiltrationEntry.infiltrationResults =  [];
            $scope.infiltrationEntry.infiltrationResults.push($scope.infiltrationResult);
            if ($scope.infiltrationEntry.id !== null) {
                InfiltrationEntry.update($scope.infiltrationEntry, onSaveSuccess, onSaveError);
            } else {
                InfiltrationEntry.save($scope.infiltrationEntry, onSaveSuccess, onSaveError);
            }

            //
            // if ($scope.infiltrationResult.id !== null) {
            //     InfiltrationResult.update($scope.infiltrationResult, onSaveSuccessResult, onSaveErrorResult);
            // } else {
            //     InfiltrationResult.save($scope.infiltrationResult, onSaveSuccessResult, onSaveErrorResult);
            // }

        }

        function onSaveSuccessResult (result) {
            $scope.$emit('infiltrationApp:infiltrationResultUpdate', result);
            $localStorage.infiltrationEntry = result;
            vm.isSavingResult = false;
        }

        function onSaveErrorResult () {
            vm.isSavingResult = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:infiltrationEntryUpdate', result);
            $localStorage.infiltrationEntry = result;
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        $scope.htmlAdText = function(text){ return $sce.trustAsHtml(text); };
    }



})();

/**
 * Created by g9a on 2/5/16.
 */
(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('infiltration', {
                parent: 'app',
                url: '/infiltration',
                // data: {
                //     authorities: ['ROLE_ADMIN', 'ROLE_USER']
                // },
                views: {
                    'content@': {
                        templateUrl: 'app/infiltration/infiltration.html',
                        controller: 'InfiltrationController',
                        controllerAs: 'vm'
                    }
                }
            });
        $stateProvider.state('infiltrationcalculation', {
            parent: 'app',
            url: '/infiltrationcalculation',
            // data: {
            //     authorities: ['ROLE_ADMIN', 'ROLE_USER']
            // },
            views: {
                'content@': {
                    templateUrl: 'app/infiltration/infiltrationcalculation.html',
                    controller: 'InfiltrationCalculationController',
                    controllerAs: 'vm'
                }
            }
        })
    }
})();

/**
 * Created by g9a on 2/5/16.
 */
(function () {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('InfiltrationController', InfiltrationController);

    InfiltrationController.$inject = ['$scope', '$localStorage', '$sce', 'Principal', '$state', 'LoginService', 'BuildingType', 'InfiltrationEntry', 'UnitConversion'];

    function InfiltrationController($scope, $localStorage, $sce, Principal, $state, LoginService, BuildingType, InfiltrationEntry, UnitConversion) {
        var vm = this;
        $scope.buildingTypes = [];

        $scope.infiltrationEntry = $localStorage.infiltrationEntry;
        $scope.infiltrationResult = $localStorage.infiltrationResult;

        $scope.markers = $localStorage.markers;
        $scope.marker = $scope.markers[0];
        $scope.costElectricity = $scope.marker.cost_electricity;
        $scope.costGas = $scope.marker.cost_gas;
        $scope.retrofitLeakage = 2.0;
        $scope.basecaseLeakage = 5.42;

        $scope.areaUnits = $localStorage.areaUnits;
        $scope.areaUnit = $scope.areaUnits[0];
        $scope.leakageUnits = $localStorage.leakageUnits;
        $scope.leakageUnit = $scope.leakageUnits[0];
        $scope.gasCostUnitss = $localStorage.gasCostUnitss;
        $scope.gasCostUnits = $scope.gasCostUnitss[0];
        initMap();
        loadBuildingTypes();

        $scope.map = {
            zoom: 2.8,
            key: 'AIzaSyC559Prz4D31xzlAdoxx4aue5b1rXwnrzE',
            center: {
               // latitude: $scope.marker.coords.latitude,
                latitude: 50.4419,
                longitude: -100.1419
               // longitude: $scope.marker.coords.longitude
            }
        };

        $scope.onMarkerClick = function (mkr, even, obj) {
            $scope.marker = obj;
            $scope.infiltrationEntry.mapLocation = $scope.marker;
            $scope.costElectricity = $scope.marker.cost_electricity;
            $scope.costGas = $scope.marker.cost_gas;
            var currentCenter = Object.create($scope.marker.coords);
            $scope.map.center = currentCenter;
            $scope.map.zoom = 5;
        };

        Principal.identity().then(function (account) {
            $scope.account = account;
            $scope.isAuthenticated = Principal.isAuthenticated;
        });

        $scope.submit = function () {
            $scope.infiltrationEntry.mapLocation = $scope.marker;
            $scope.infiltrationEntry.basecaseLeakage = $scope.basecaseLeakage;
            $scope.infiltrationEntry.area = $scope.floorArea;
            $scope.infiltrationEntry.costElectricity = $scope.costElectricity;
            $scope.infiltrationEntry.costGas = $scope.costGas;
            $scope.infiltrationEntry.retrofittedLeakage = $scope.retrofitLeakage;
            $scope.infiltrationEntry.buildingType = $scope.buildingType;
            $scope.infiltrationEntry.areaUnit = $scope.areaUnit.val;
            $scope.infiltrationEntry.leakageUnit = $scope.leakageUnit.val;
            $scope.infiltrationEntry.gasCostUnits = $scope.gasCostUnits.val;
            $scope.savingsResults = true;
            save();
        };

        function save() {
            $scope.isSaving = true;
            if (!angular.isUndefined($scope.infiltrationEntry.id)) {
                InfiltrationEntry.update($scope.infiltrationEntry, onUpdateSuccess, onUpdateError);
            } else {
                InfiltrationEntry.save($scope.infiltrationEntry, onSaveSuccess, onUpdateError);
            }
        }

        function onUpdateSuccess (result) {
            $scope.$emit('infiltrationApp:infiltrationEntryUpdate', result);
            $scope.infiltrationEntry.id = result.id;
            $localStorage.infiltrationEntry = result;
            $scope.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:infiltrationEntrySave', result);
            $scope.infiltrationEntry.id = result.id;
            $localStorage.infiltrationEntry = result;
            $scope.isSaving = false;
        }

        function onSaveError () {
            console.log('On Save Error');
            $scope.isSaving = false;
        }

        function onUpdateError () {
            console.log('On Update Error');
            $scope.isSaving = false;
        }


        $scope.changeSelectedMarker = function (geolocation) {
            $scope.marker = geolocation;
            $scope.costElectricity = $scope.marker.cost_electricity;
            $scope.costGas = $scope.marker.cost_gas;
            $scope.map.center = $scope.marker.coords;
            $scope.map.zoom = 5;
        };

        $scope.changeBuildingType = function (buildingType) {
            // $scope.floorArea = $scope.buildingType.floorArea;
            // $scope.basecaseLeakage = parseFloat($scope.buildingType.leakageRate);
//            if (!$scope.hasOwnProperty('infiltrationEntry')) {
                if(buildingType.shortName === "residential"){
                    $scope.infiltrationEntry.leakageUnit = 'ACH50';
                    $scope.basecaseLeakage = $scope.buildingType.leakageRate;
                    $scope.leakageUnit = $localStorage.leakageUnits[2];
                }
                if ($scope.areaUnit.val === "M2") {
                    $scope.infiltrationEntry.areaUnit = 'M2';
                    $scope.floorArea = parseFloat($scope.buildingType.descriptionText);
                    $scope.areaUnit = $localStorage.areaUnits[1];
                } else {
                    $scope.infiltrationEntry.areaUnit = 'SQFT';
                    $scope.floorArea = parseFloat($scope.buildingType.floorArea);
                    $scope.areaUnit = $localStorage.areaUnits[0];
                }
                if ($scope.leakageUnit.val === "CFMSQFT") {
                    $scope.infiltrationEntry.leakageUnit = "CFMSQFT";
                    $scope.basecaseLeakage = parseFloat($scope.buildingType.altLeakageRate);
                    $scope.leakageUnit = $scope.leakageUnits[1]
                } else if ($scope.leakageUnit.val === "LPERSECM2") {
                    $scope.infiltrationEntry.leakageUnit = "LPERSECM2";
                    $scope.basecaseLeakage = parseFloat($scope.buildingType.leakageRate);
                    $scope.leakageUnit = $localStorage.leakageUnits[0];
                } else if ($scope.leakageUnit.val === "ACH50") {
                    $scope.infiltrationEntry.leakageUnit = "ACH50";
                    $scope.basecaseLeakage = parseFloat($scope.buildingType.leakageRate);
                    $scope.leakageUnit = $localStorage.leakageUnits[2];
                }


//            }
//            ;
        };

        function initMap (){
            if ($scope.hasOwnProperty('infiltrationEntry')) {
                if ($scope.infiltrationEntry.hasOwnProperty('mapLocation')) {
                    $scope.marker = _.find($scope.markers, {'id': $scope.infiltrationEntry.mapLocation.id});
                }
            }
        };
        function loadBuildingTypes () {
            BuildingType.query(function (result) {
                $scope.buildingTypes = result;
                $scope.buildingType = $scope.buildingTypes[0];
                $scope.floorArea = $scope.buildingType.floorArea;
                $scope.basecaseLeakage = parseFloat($scope.buildingType.leakageRate);
                $scope.areaUnit = $localStorage.areaUnits[0];
                $scope.leakageUnit = $localStorage.leakageUnits[0];

                $scope.gasCostUnits = $localStorage.gasCostUnitss[0];

            });
        };
        function initInfiltrationValues () {
            // if ($scope.hasOwnProperty('infiltrationEntry')) {
            //     if ($scope.infiltrationEntry.hasOwnProperty('buildingType')) {
            //         $scope.buildingType = $scope.infiltrationEntry.buildingType;
            //     }
            //     if ($scope.infiltrationEntry.hasOwnProperty('area')) {
            //         $scope.floorArea = $scope.infiltrationEntry.area;
            //     }
            //     if ($scope.infiltrationEntry.hasOwnProperty('basecaseLeakage')) {
            //         $scope.basecaseLeakage = $scope.infiltrationEntry.basecaseLeakage;
            //     }
            //     if ($scope.infiltrationEntry.hasOwnProperty('costElectricity')) {
            //         $scope.costElectricity = $scope.infiltrationEntry.costElectricity;
            //     }
            //     if ($scope.infiltrationEntry.hasOwnProperty('costGas')) {
            //         $scope.costGas = $scope.infiltrationEntry.costGas;
            //     }
            //     if ($scope.infiltrationEntry.hasOwnProperty('retrofittedLeakage')) {
            //         $scope.retrofitLeakage = $scope.infiltrationEntry.retrofittedLeakage;
            //     }
            //     if ($scope.infiltrationEntry.hasOwnProperty('leakageUnit')) {
            //         $scope.leakageUnit = _.find($scope.leakageUnits, { 'val': $scope.infiltrationEntry.leakageUnit});
            //     }
            //     if ($scope.infiltrationEntry.hasOwnProperty('areaUnit')) {
            //         $scope.areaUnit = _.find($scope.areaUnits, { 'val': $scope.infiltrationEntry.areaUnit});
            //     }
            //     if ($scope.infiltrationEntry.hasOwnProperty('gasCostUnits')) {
            //         $scope.gasCostUnits = _.find($scope.gasCostUnitss, { 'val': $scope.infiltrationEntry.gasCostUnits});
            //     }
            // }
        }

        initInfiltrationValues();

        $scope.changeGasCostUnits = function(obj) {
            if (obj.val === "M3") {
                $scope.infiltrationEntry.gasCostUnits = 'M3';
                $scope.costGas = parseFloat(UnitConversion.toMetersCubed($scope.costGas));
            } else {
                $scope.infiltrationEntry.gasCostUnits = 'FT3';
                $scope.costGas = parseFloat(UnitConversion.toFeetCubed($scope.costGas));
            }
        };
        $scope.changeLeakageUnits = function(obj) {
            if (obj.val === "CFMSQFT") {
                $scope.infiltrationEntry.leakageUnit = "CFMSQFT";
                $scope.basecaseLeakage = parseFloat(UnitConversion.toLeakageFeet($scope.basecaseLeakage));
                $scope.retrofitLeakage = parseFloat(UnitConversion.toLeakageFeet($scope.retrofitLeakage));
                $scope.leakageUnit = $scope.leakageUnits[1];
            } else if (obj.val === "LPERSECM2"){
                $scope.infiltrationEntry.leakageUnit = "LPERSECM2";
                $scope.basecaseLeakage = parseFloat(UnitConversion.toLeakageMeters($scope.basecaseLeakage));
                $scope.retrofitLeakage = parseFloat(UnitConversion.toLeakageMeters($scope.retrofitLeakage));
                $scope.leakageUnit = $scope.leakageUnits[0];
            } else if (obj.val === "ACH50"){
                $scope.infiltrationEntry.leakageUnit = "ACH50";
                $scope.basecaseLeakage = $scope.buildingType.leakageRate;
                $scope.retrofitLeakage = $scope.retrofitLeakage;
                $scope.leakageUnit = $scope.leakageUnits[2];
            }


        };
        $scope.changeAreaUnits = function(obj) {
            if (obj.val === "M2") {
                $scope.infiltrationEntry.areaUnit = "M2";
                $scope.floorArea = parseFloat(UnitConversion.toMetersSquared($scope.floorArea));
            } else {
                $scope.infiltrationEntry.areaUnit = "SQFT";
                $scope.floorArea = parseFloat(UnitConversion.toSquareFeet($scope.floorArea));
            }

        };
        $scope.htmlAdText = function(text){ return $sce.trustAsHtml(text); };

    }

})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$localStorage', 'Principal', 'LoginService', '$state', 'User'];

    function HomeController($scope, $localStorage, Principal, LoginService, $state, user) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.$storage = $localStorage;
        vm.register = register;
        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if (angular.isObject(vm.account)) {
                    initMarkers();
                    if (!vm.$storage.hasOwnProperty('infiltrationEntry')) {
                        // Initialize the wall
                        initInfiltrationEntry();
                    }
                    // if (!vm.$storage.hasOwnProperty('markers')) {
                    //     initMarkers();
                    // }
                    if (!vm.$storage.hasOwnProperty('infiltrationResult')) {
                        initInfiltrationResult();
                    }
//                    if (!vm.$storage.hasOwnProperty('areaUnits')) {
                        initUnits();
//                    }
                }
            });
        }

        function register() {
            $state.go('register');
        }

        function initInfiltrationEntry() {
            vm.$storage.infiltrationEntry = {};
        }

        function initInfiltrationResult() {
            vm.$storage.infiltrationResult = {};
        }

        function initMarkers() {
            vm.$storage.markers =

                [

                    {
                        "id": 1,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 1,
                        "state_abbrev": "AL",
                        "state_name": "Alabama",
                        "city_state": "Birmingham, AL",
                        "city": "Birmingham",
                        "coords": {
                            "latitude": 33.527444,
                            "longitude": -86.799047
                        },
                        "cost_electricity": 0.11,
                        "cost_gas": 11.03
                    },

                    {
                        "id": 9,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 2,
                        "state_abbrev": "AK",
                        "state_name": "Alaska",
                        "city_state": "Fairbanks, AK",
                        "city": "Fairbanks",
                        "coords": {
                            "latitude": 64.836531,
                            "longitude": -147.651745
                        },
                        "cost_electricity": 0.18,
                        "cost_gas": 8.01
                    },

                    {
                        "id": 19,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 3,
                        "state_abbrev": "AZ",
                        "state_name": "Arizona",
                        "city_state": "Phoenix, AZ",
                        "city": "Phoenix",
                        "coords": {
                            "latitude": 33.572154,
                            "longitude": -112.090132
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 10.53
                    },

                    {
                        "id": 29,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 5,
                        "state_abbrev": "CA",
                        "state_name": "California",
                        "city_state": "Los Angeles, CA",
                        "city": "Los Angeles",
                        "coords": {
                            "latitude": 34.019394,
                            "longitude": -118.410825
                        },
                        "cost_electricity": 0.14,
                        "cost_gas": 7.98
                    },

                    {
                        "id": 30,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 5,
                        "state_abbrev": "CA",
                        "state_name": "California",
                        "city_state": "Sacramento, CA",
                        "city": "Sacramento",
                        "coords": {
                            "latitude": 38.566592,
                            "longitude": -121.468632
                        },
                        "cost_electricity": 0.14,
                        "cost_gas": 7.98
                    },

                    {
                        "id": 32,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 5,
                        "state_abbrev": "CA",
                        "state_name": "California",
                        "city_state": "San Francisco, CA",
                        "city": "San Francisco",
                        "coords": {
                            "latitude": 37.727239,
                            "longitude": -123.032229
                        },
                        "cost_electricity": 0.14,
                        "cost_gas": 7.98
                    },

                    {
                        "id": 34,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 6,
                        "state_abbrev": "CO",
                        "state_name": "Colorado",
                        "city_state": "Boulder, CO",
                        "city": "Boulder",
                        "coords": {
                            "latitude": 40.027443,
                            "longitude": -105.25174
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 8.15
                    },

                    {
                        "id": 46,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 9,
                        "state_abbrev": "FL",
                        "state_name": "Florida",
                        "city_state": "Miami, FL",
                        "city": "Miami",
                        "coords": {
                            "latitude": 25.775163,
                            "longitude": -80.208615
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 10.74
                    },

                    {
                        "id": 48,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 9,
                        "state_abbrev": "FL",
                        "state_name": "Florida",
                        "city_state": "Tampa, FL",
                        "city": "Tampa",
                        "coords": {
                            "latitude": 27.970086,
                            "longitude": -82.479673
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 10.74
                    },

                    {
                        "id": 51,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 10,
                        "state_abbrev": "GA",
                        "state_name": "Georgia",
                        "city_state": "Atlanta, GA",
                        "city": "Atlanta",
                        "coords": {
                            "latitude": 33.762909,
                            "longitude": -84.422675
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 8.49
                    },

                    {
                        "id": 60,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 13,
                        "state_abbrev": "ID",
                        "state_name": "Idaho",
                        "city_state": "Boise, ID",
                        "city": "Boise",
                        "coords": {
                            "latitude": 43.599335,
                            "longitude": -116.229817
                        },
                        "cost_electricity": 0.08,
                        "cost_gas": 7.61
                    },

                    {
                        "id": 62,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 14,
                        "state_abbrev": "IL",
                        "state_name": "Illinois",
                        "city_state": "Chicago, IL",
                        "city": "Chicago",
                        "coords": {
                            "latitude": 41.837551,
                            "longitude": -87.681844
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 7.26
                    },

                    {
                        "id": 69,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 15,
                        "state_abbrev": "IN",
                        "state_name": "Indiana",
                        "city_state": "Indianapolis, IN",
                        "city": "Indianapolis",
                        "coords": {
                            "latitude": 39.776664,
                            "longitude": -86.145935
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 7.58
                    },

                    {
                        "id": 78,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 15,
                        "state_abbrev": "KS",
                        "state_name": "Kansas",
                        "city_state": "Wichita, KS",
                        "city": "Wichita",
                        "coords": {
                            "latitude": 37.690694,
                            "longitude": -97.342678
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 8.83
                    },

                    {
                        "id": 81,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 16,
                        "state_abbrev": "KY",
                        "state_name": "Kentucky",
                        "city_state": "Louisville, KY",
                        "city": "Louisville",
                        "coords": {
                            "latitude": 38.225371,
                            "longitude": -85.741613
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 8.8
                    },

                    {
                        "id": 85,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 17,
                        "state_abbrev": "LA",
                        "state_name": "Louisiana",
                        "city_state": "New Orleans, LA",
                        "city": "New Orleans",
                        "coords": {
                            "latitude": 30.05342,
                            "longitude": -89.934502
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 7.93
                    },

                    {
                        "id": 88,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 18,
                        "state_abbrev": "ME",
                        "state_name": "Maine",
                        "city_state": "Portland, ME",
                        "city": "Portland",
                        "coords": {
                            "latitude": 43.633192,
                            "longitude": -70.185644
                        },
                        "cost_electricity": 0.12,
                        "cost_gas": 14.4
                    },

                    {
                        "id": 89,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 19,
                        "state_abbrev": "MD",
                        "state_name": "Maryland",
                        "city_state": "Baltimore, MD",
                        "city": "Baltimore",
                        "coords": {
                            "latitude": 39.300032,
                            "longitude": -76.610476
                        },
                        "cost_electricity": 0.11,
                        "cost_gas": 10
                    },

                    {
                        "id": 90,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 20,
                        "state_abbrev": "MA",
                        "state_name": "Massachusetts",
                        "city_state": "Boston, MA",
                        "city": "Boston",
                        "coords": {
                            "latitude": 42.33196,
                            "longitude": -71.020173
                        },
                        "cost_electricity": 0.15,
                        "cost_gas": 12.48
                    },

                    {
                        "id": 93,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 21,
                        "state_abbrev": "MI",
                        "state_name": "Michigan",
                        "city_state": "Detroit, MI",
                        "city": "Detroit",
                        "coords": {
                            "latitude": 42.383037,
                            "longitude": -83.102237
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 7.49
                    },

                    {
                        "id": 100,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 21,
                        "state_abbrev": "MI",
                        "state_name": "Michigan",
                        "city_state": "Traverse City, MI",
                        "city": "Traverse City",
                        "coords": {
                            "latitude": 44.754309,
                            "longitude": -85.603011
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 7.49
                    },

                    {
                        "id": 101,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 22,
                        "state_abbrev": "MN",
                        "state_name": "Minnesota",
                        "city_state": "Duluth, MN",
                        "city": "Duluth",
                        "coords": {
                            "latitude": 46.783229,
                            "longitude": -92.11871
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 7.3
                    },

                    {
                        "id": 103,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 22,
                        "state_abbrev": "MN",
                        "state_name": "Minnesota",
                        "city_state": "Minneapolis, MN",
                        "city": "Minneapolis",
                        "coords": {
                            "latitude": 44.963324,
                            "longitude": -93.26832
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 7.3
                    },

                    {
                        "id": 110,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 24,
                        "state_abbrev": "MO",
                        "state_name": "Missouri",
                        "city_state": "St. Louis, MO",
                        "city": "St. Louis",
                        "coords": {
                            "latitude": 38.635699,
                            "longitude": -90.244582
                        },
                        "cost_electricity": 0.08,
                        "cost_gas": 9.1
                    },

                    {
                        "id": 116,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 25,
                        "state_abbrev": "MT",
                        "state_name": "Montana",
                        "city_state": "Helena, MT",
                        "city": "Helena",
                        "coords": {
                            "latitude": 46.595465,
                            "longitude": -112.018746
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 7.82
                    },

                    {
                        "id": 124,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 26,
                        "state_abbrev": "NE",
                        "state_name": "Nebraska",
                        "city_state": "Omaha, NE",
                        "city": "Omaha",
                        "coords": {
                            "latitude": 41.263765,
                            "longitude": -96.041638
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 6.54
                    },

                    {
                        "id": 128,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 27,
                        "state_abbrev": "NV",
                        "state_name": "Nevada",
                        "city_state": "Las Vegas, NV",
                        "city": "Las Vegas",
                        "coords": {
                            "latitude": 36.229214,
                            "longitude": -115.260082
                        },
                        "cost_electricity": 0.08,
                        "cost_gas": 8.66
                    },

                    {
                        "id": 129,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 27,
                        "state_abbrev": "NV",
                        "state_name": "Nevada",
                        "city_state": "Reno, NV",
                        "city": "Reno",
                        "coords": {
                            "latitude": 39.549098,
                            "longitude": -119.849905
                        },
                        "cost_electricity": 0.08,
                        "cost_gas": 8.66
                    },

                    {
                        "id": 135,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 30,
                        "state_abbrev": "NM",
                        "state_name": "New Mexico",
                        "city_state": "Albuquerque, NM",
                        "city": "Albuquerque",
                        "coords": {
                            "latitude": 35.105552,
                            "longitude": -106.647388
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 7.87
                    },

                    {
                        "id": 141,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 31,
                        "state_abbrev": "NY",
                        "state_name": "New York",
                        "city_state": "New York City, NY",
                        "city": "New York City",
                        "coords": {
                            "latitude": 40.664274,
                            "longitude": -73.9385
                        },
                        "cost_electricity": 0.13,
                        "cost_gas": 6.89
                    },

                    {
                        "id": 143,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 31,
                        "state_abbrev": "NY",
                        "state_name": "New York",
                        "city_state": "Syracuse, NY",
                        "city": "Syracuse",
                        "coords": {
                            "latitude": 43.040998,
                            "longitude": -76.143554
                        },
                        "cost_electricity": 0.13,
                        "cost_gas": 6.89
                    },

                    {
                        "id": 145,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 32,
                        "state_abbrev": "NC",
                        "state_name": "North Carolina",
                        "city_state": "Charlotte, NC",
                        "city": "Charlotte",
                        "coords": {
                            "latitude": 35.208707,
                            "longitude": -80.830739
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 9.12
                    },

                    {
                        "id": 150,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 33,
                        "state_abbrev": "ND",
                        "state_name": "North Dakota",
                        "city_state": "Bismarck, ND",
                        "city": "Bismarck",
                        "coords": {
                            "latitude": 46.812084,
                            "longitude": -100.770099
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 6.7
                    },

                    {
                        "id": 154,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 34,
                        "state_abbrev": "OH",
                        "state_name": "Ohio",
                        "city_state": "Cleveland, OH",
                        "city": "Cleveland",
                        "coords": {
                            "latitude": 41.478462,
                            "longitude": -81.679435
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 6.62
                    },

                    {
                        "id": 161,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 35,
                        "state_abbrev": "OK",
                        "state_name": "Oklahoma",
                        "city_state": "Tulsa, OK",
                        "city": "Tulsa",
                        "coords": {
                            "latitude": 36.127949,
                            "longitude": -95.902316
                        },
                        "cost_electricity": 0.07,
                        "cost_gas": 8.22
                    },

                    {
                        "id": 168,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 36,
                        "state_abbrev": "OR",
                        "state_name": "Oregon",
                        "city_state": "Portland, OR",
                        "city": "Portland",
                        "coords": {
                            "latitude": 45.536951,
                            "longitude": -122.649971
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 9.44
                    },

                    {
                        "id": 169,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 36,
                        "state_abbrev": "OR",
                        "state_name": "Oregon",
                        "city_state": "Redmond, OR",
                        "city": "Redmond",
                        "coords": {
                            "latitude": 44.262753,
                            "longitude": -121.180137
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 9.44
                    },

                    {
                        "id": 175,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 37,
                        "state_abbrev": "PA",
                        "state_name": "Pennsylvania",
                        "city_state": "Philadelphia, PA",
                        "city": "Philadelphia",
                        "coords": {
                            "latitude": 40.009376,
                            "longitude": -75.133346
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 10.13
                    },

                    {
                        "id": 176,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 37,
                        "state_abbrev": "PA",
                        "state_name": "Pennsylvania",
                        "city_state": "Pittsburgh, PA",
                        "city": "Pittsburgh",
                        "coords": {
                            "latitude": 40.439753,
                            "longitude": -79.976592
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 10.13
                    },

                    {
                        "id": 180,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 39,
                        "state_abbrev": "SC",
                        "state_name": "South Carolina",
                        "city_state": "Charleston, SC",
                        "city": "Charleston",
                        "coords": {
                            "latitude": 32.81793,
                            "longitude": -79.95896
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 8.37
                    },

                    {
                        "id": 185,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 41,
                        "state_abbrev": "SD",
                        "state_name": "South Dakota",
                        "city_state": "Rapid City, SD",
                        "city": "Rapid City",
                        "coords": {
                            "latitude": 44.071071,
                            "longitude": -103.217924
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 6.11
                    },

                    {
                        "id": 191,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 42,
                        "state_abbrev": "TN",
                        "state_name": "Tennessee",
                        "city_state": "Nashville, TN",
                        "city": "Nashville",
                        "coords": {
                            "latitude": 36.1718,
                            "longitude": -86.785002
                        },
                        "cost_electricity": 0.1,
                        "cost_gas": 8.46
                    },

                    {
                        "id": 198,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 43,
                        "state_abbrev": "TX",
                        "state_name": "Texas",
                        "city_state": "Fort Worth, TX",
                        "city": "Fort Worth",
                        "coords": {
                            "latitude": 32.781518,
                            "longitude": -97.346746
                        },
                        "cost_electricity": 0.08,
                        "cost_gas": 8.26
                    },

                    {
                        "id": 204,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 43,
                        "state_abbrev": "TX",
                        "state_name": "Texas",
                        "city_state": "San Antonio, TX",
                        "city": "San Antonio",
                        "coords": {
                            "latitude": 29.472403,
                            "longitude": -98.525142
                        },
                        "cost_electricity": 0.08,
                        "cost_gas": 8.26
                    },

                    {
                        "id": 209,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 44,
                        "state_abbrev": "UT",
                        "state_name": "Utah",
                        "city_state": "Salt Lake City, UT",
                        "city": "Salt Lake City",
                        "coords": {
                            "latitude": 40.778996,
                            "longitude": -111.93263
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 7.97
                    },

                    {
                        "id": 210,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 45,
                        "state_abbrev": "VT",
                        "state_name": "Vermont",
                        "city_state": "Burlington, VT",
                        "city": "Burlington",
                        "coords": {
                            "latitude": 44.491927,
                            "longitude": -73.238882
                        },
                        "cost_electricity": 0.14,
                        "cost_gas": 9.13
                    },

                    {
                        "id": 213,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 46,
                        "state_abbrev": "VA",
                        "state_name": "Virginia",
                        "city_state": "Richmond, VA",
                        "city": "Richmond",
                        "coords": {
                            "latitude": 37.531399,
                            "longitude": -77.476009
                        },
                        "cost_electricity": 0.08,
                        "cost_gas": 8.11
                    },

                    {
                        "id": 218,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 47,
                        "state_abbrev": "WA",
                        "state_name": "Washington",
                        "city_state": "Seattle, WA",
                        "city": "Seattle",
                        "coords": {
                            "latitude": 47.620499,
                            "longitude": -122.350876
                        },
                        "cost_electricity": 0.08,
                        "cost_gas": 9.14
                    },

                    {
                        "id": 219,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 47,
                        "state_abbrev": "WA",
                        "state_name": "Washington",
                        "city_state": "Spokane, WA",
                        "city": "Spokane",
                        "coords": {
                            "latitude": 47.666935,
                            "longitude": -117.433322
                        },
                        "cost_electricity": 0.08,
                        "cost_gas": 9.14
                    },

                    {
                        "id": 223,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 48,
                        "state_abbrev": "WV",
                        "state_name": "West Virginia",
                        "city_state": "Huntington, WV",
                        "city": "Huntington",
                        "coords": {
                            "latitude": 38.410651,
                            "longitude": -82.434689
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 9.15
                    },

                    {
                        "id": 227,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 49,
                        "state_abbrev": "WI",
                        "state_name": "Wisconsin",
                        "city_state": "Madison, WI",
                        "city": "Madison",
                        "coords": {
                            "latitude": 43.087815,
                            "longitude": -89.429856
                        },
                        "cost_electricity": 0.11,
                        "cost_gas": 8.74
                    },

                    {
                        "id": 230,
                        "country_id": 1,
                        "country": "United States",
                        "country_abbrev": "USA",
                        "state_id": 50,
                        "state_abbrev": "WY",
                        "state_name": "Wyoming",
                        "city_state": "Cheyenne, WY",
                        "city": "Cheyenne",
                        "coords": {
                            "latitude": 41.143657,
                            "longitude": -104.792833
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 7.69
                    },

                    {
                        "id": 235,
                        "country_id": 2,
                        "country": "Canada",
                        "country_abbrev": "CAN",
                        "state_id": 53,
                        "state_abbrev": "BC",
                        "state_name": "British Columbia",
                        "city_state": "Vancouver, BC",
                        "city": "Vancouver",
                        "coords": {
                            "latitude": 49.25,
                            "longitude": -123.1
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 7.69
                    },

                    {
                        "id": 236,
                        "country_id": 2,
                        "country": "Canada",
                        "country_abbrev": "CAN",
                        "state_id": 54,
                        "state_abbrev": "MB",
                        "state_name": "Manitoba",
                        "city_state": "Winnipeg, MB",
                        "city": "Winnipeg",
                        "coords": {
                            "latitude": 49.9,
                            "longitude": -97.13555556
                        },
                        "cost_electricity": 0.07,
                        "cost_gas": 6.51
                    },

                    {
                        "id": 237,
                        "country_id": 2,
                        "country": "Canada",
                        "country_abbrev": "CAN",
                        "state_id": 55,
                        "state_abbrev": "NS",
                        "state_name": "Nova Scotia",
                        "city_state": "Halifax, NS",
                        "city": "Halifax",
                        "coords": {
                            "latitude": 44.36,
                            "longitude": -63.32
                        },
                        "cost_electricity": 0.07,
                        "cost_gas": 14.45
                    },

                    {
                        "id": 238,
                        "country_id": 2,
                        "country": "Canada",
                        "country_abbrev": "CAN",
                        "state_id": 56,
                        "state_abbrev": "ON",
                        "state_name": "Ontario",
                        "city_state": "Toronto, ON",
                        "city": "Toronto",
                        "coords": {
                            "latitude": 43.652612,
                            "longitude": -79.380833
                        },
                        "cost_electricity": 0.13,
                        "cost_gas": 6.38
                    },

                    {
                        "id": 240,
                        "country_id": 2,
                        "country": "Canada",
                        "country_abbrev": "CAN",
                        "state_id": 57,
                        "state_abbrev": "QC",
                        "state_name": "Quebec",
                        "city_state": "Montreal, QC",
                        "city": "Montreal",
                        "coords": {
                            "latitude": 45.516274,
                            "longitude": -73.569235
                        },
                        "cost_electricity": 0.09,
                        "cost_gas": 11.92
                    },


                    /*{
                        "id": 242,
                        "country_id": 3,
                        "country": "China",
                        "country_abbrev": "CHN",
                        "state_id": 58,
                        "state_abbrev": "BJ",
                        "state_name": "Beijing",
                        "city_state": "Beijing",
                        "city": "Beijing",
                        "coords": {
                            "latitude": 39.913818,
                            "longitude": 116.363625
                        },
                        "cost_electricity": 0.78,
                        "cost_gas": 103.4
                    },

                    {
                        "id": 243,
                        "country_id": 3,
                        "country": "China",
                        "country_abbrev": "CHN",
                        "state_id": 59,
                        "state_abbrev": "SH",
                        "state_name": "Shanghai",
                        "city_state": "Shanghai",
                        "city": "Shanghai",
                        "coords": {
                            "latitude": 31.234614,
                            "longitude": 121.467104
                        },
                        "cost_electricity": 0.78,
                        "cost_gas": 103.4
                    },

                    {
                        "id": 244,
                        "country_id": 3,
                        "country": "China",
                        "country_abbrev": "CHN",
                        "state_id": 60,
                        "state_abbrev": "GD",
                        "state_name": "Guangdong",
                        "city_state": "Guangzhou",
                        "city": "Guangzhou",
                        "coords": {
                            "latitude": 23.14303,
                            "longitude": 113.259391
                        },
                        "cost_electricity": 0.78,
                        "cost_gas": 103.4
                    },

                    {
                        "id": 245,
                        "country_id": 3,
                        "country": "China",
                        "country_abbrev": "CHN",
                        "state_id": 61,
                        "state_abbrev": "HL",
                        "state_name": "Heilongjiang",
                        "city_state": "Harbin",
                        "city": "Harbin",
                        "coords": {
                            "latitude": 45.809339,
                            "longitude": 126.543524
                        },
                        "cost_electricity": 0.78,
                        "cost_gas": 103.4
                    },

                    {
                        "id": 246,
                        "country_id": 3,
                        "country": "China",
                        "country_abbrev": "CHN",
                        "state_id": 62,
                        "state_abbrev": "JL",
                        "state_name": "Jilin",
                        "city_state": "Changchun",
                        "city": "Changchun",
                        "coords": {
                            "latitude": 43.817727,
                            "longitude": 125.325875
                        },
                        "cost_electricity": 0.78,
                        "cost_gas": 103.4
                    }, */

                ]

        }

        function htmlDecode(input) {
            var e = document.createElement('div');
            e.innerHTML = input;
            return e.childNodes[0].nodeValue;
        }

        function initUnits() {
            vm.$storage.areaUnits = [
                {
                    id: 1, name: htmlDecode("ft&sup2;"), val: "SQFT"
                },
                {
                    id: 2, name: htmlDecode("m&sup2;"), val: "M2"
                }
            ];

            vm.$storage.leakageUnits = [
                {
                    id: 1, name: htmlDecode("L/s/m&sup2;"), val: "LPERSECM2"
                },
                {
                    id: 2, name: htmlDecode("CFM/ft&sup2;"), val: "CFMSQFT"
                },
                {
                    id: 3, name: "ACH", val: "ACH50"
                }
            ];

            vm.$storage.gasCostUnitss = [
                {
                    id: 1, name: htmlDecode("1000 ft&sup3;"), val: "FT3", energy: htmlDecode("ft&sup3;")
                },
                {
                    id: 2, name: htmlDecode("m&sup3;"), val: "M3"
                }
            ];
            vm.$storage.moistureTransferUnits = [
                {
                    id: 1, name: htmlDecode("L/m&sup2;/year"), val: "M2"
                },
                {
                    id: 2, name: htmlDecode("gal/ft&sup2;/year"), val: "SQFT"
                }
            ];
            vm.$storage.elaUnits = [
                {
                    id: 1, name: htmlDecode("m&sup2;"), val: "M2"
                },
                {
                    id: 2, name: htmlDecode("ft&sup2;"), val: "SQFT"
                }

            ];

            vm.$storage.moistureTransferELA = [
                {
                    id: 1, name: htmlDecode("L/cm&sup2;/year"), val: "M2"
                },
                {
                    id: 2, name: htmlDecode("gal/in&sup2;/year"), val: "SQFT"
                }
            ];

            vm.$storage.moistureTransferTotal = [
                {
                    id: 1, name: ("L/year"), val: "M2"
                },
                {
                    id: 2, name:("gal/year"), val: "SQFT"
                }
            ];
            vm.$storage.elaAreas  = [
                { id: 1, fa: 2294, ea: 3471 }, // standalone retail
                { id: 2, fa: 3131, ea: 2326 }, // mid rise apt
                { id: 3, fa: 4980, ea: 3640 }, // office medium
                { id: 4, fa: 7837, ea: 4639 }, // hi rise apt
                { id: 5, fa: 22428, ea: 9089 }, // hospital
                { id: 6, fa: 11346, ea: 6005 }, // large hotel
                { id: 7, fa: 19593, ea: 17871 }, // secondary school
                { id: 8, fa: 22500, ea: 3274 }, // strip mall
                {id: 9, fa: 73958, ea: 9383}, //Primary School
                {id: 10, fa: 221, ea: 441} //resedential
            ]
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('UsStateDialogController', UsStateDialogController);

    UsStateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'UsState'];

    function UsStateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, UsState) {
        var vm = this;

        vm.usState = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.usState.id !== null) {
                UsState.update(vm.usState, onSaveSuccess, onSaveError);
            } else {
                UsState.save(vm.usState, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:usStateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('UsStateDetailController', UsStateDetailController);

    UsStateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'UsState'];

    function UsStateDetailController($scope, $rootScope, $stateParams, previousState, entity, UsState) {
        var vm = this;

        vm.usState = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('infiltrationApp:usStateUpdate', function(event, result) {
            vm.usState = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('UsStateDeleteController',UsStateDeleteController);

    UsStateDeleteController.$inject = ['$uibModalInstance', 'entity', 'UsState'];

    function UsStateDeleteController($uibModalInstance, entity, UsState) {
        var vm = this;

        vm.usState = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UsState.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('us-state', {
            parent: 'entity',
            url: '/us-state',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'UsStates'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/us-state/us-states.html',
                    controller: 'UsStateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('us-state-detail', {
            parent: 'entity',
            url: '/us-state/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'UsState'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/us-state/us-state-detail.html',
                    controller: 'UsStateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'UsState', function($stateParams, UsState) {
                    return UsState.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'us-state',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('us-state-detail.edit', {
            parent: 'us-state-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/us-state/us-state-dialog.html',
                    controller: 'UsStateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UsState', function(UsState) {
                            return UsState.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('us-state.new', {
            parent: 'us-state',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/us-state/us-state-dialog.html',
                    controller: 'UsStateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                stateId: null,
                                stateName: null,
                                stateAbbrev: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('us-state', null, { reload: 'us-state' });
                }, function() {
                    $state.go('us-state');
                });
            }]
        })
        .state('us-state.edit', {
            parent: 'us-state',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/us-state/us-state-dialog.html',
                    controller: 'UsStateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UsState', function(UsState) {
                            return UsState.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('us-state', null, { reload: 'us-state' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('us-state.delete', {
            parent: 'us-state',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/us-state/us-state-delete-dialog.html',
                    controller: 'UsStateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UsState', function(UsState) {
                            return UsState.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('us-state', null, { reload: 'us-state' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('UsState', UsState);

    UsState.$inject = ['$resource'];

    function UsState ($resource) {
        var resourceUrl =  'api/us-states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('UsStateController', UsStateController);

    UsStateController.$inject = ['$scope', '$state', 'UsState'];

    function UsStateController ($scope, $state, UsState) {
        var vm = this;
        
        vm.usStates = [];

        loadAll();

        function loadAll() {
            UsState.query(function(result) {
                vm.usStates = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('RawDataDialogController', RawDataDialogController);

    RawDataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RawData', 'BuildingType'];

    function RawDataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RawData, BuildingType) {
        var vm = this;

        vm.rawData = entity;
        vm.clear = clear;
        vm.save = save;
        vm.buildingtypes = BuildingType.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rawData.id !== null) {
                RawData.update(vm.rawData, onSaveSuccess, onSaveError);
            } else {
                RawData.save(vm.rawData, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:rawDataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('RawDataDetailController', RawDataDetailController);

    RawDataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RawData', 'BuildingType'];

    function RawDataDetailController($scope, $rootScope, $stateParams, previousState, entity, RawData, BuildingType) {
        var vm = this;

        vm.rawData = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('infiltrationApp:rawDataUpdate', function(event, result) {
            vm.rawData = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('RawDataDeleteController',RawDataDeleteController);

    RawDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'RawData'];

    function RawDataDeleteController($uibModalInstance, entity, RawData) {
        var vm = this;

        vm.rawData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RawData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('raw-data', {
            parent: 'entity',
            url: '/raw-data',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RawData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/raw-data/raw-data.html',
                    controller: 'RawDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('raw-data-detail', {
            parent: 'entity',
            url: '/raw-data/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RawData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/raw-data/raw-data-detail.html',
                    controller: 'RawDataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RawData', function($stateParams, RawData) {
                    return RawData.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'raw-data',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('raw-data-detail.edit', {
            parent: 'raw-data-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/raw-data/raw-data-dialog.html',
                    controller: 'RawDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RawData', function(RawData) {
                            return RawData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('raw-data.new', {
            parent: 'raw-data',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/raw-data/raw-data-dialog.html',
                    controller: 'RawDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                srnum: null,
                                country: null,
                                stateName: null,
                                city: null,
                                ebase: null,
                                ebase1: null,
                                ebase2: null,
                                ebase3: null,
                                gbase: null,
                                gbase1: null,
                                gbase2: null,
                                gbase3: null,
                                ex2: null,
                                ex: null,
                                gx2: null,
                                gx: null,
                                econstant: null,
                                gconstant: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('raw-data', null, { reload: 'raw-data' });
                }, function() {
                    $state.go('raw-data');
                });
            }]
        })
        .state('raw-data.edit', {
            parent: 'raw-data',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/raw-data/raw-data-dialog.html',
                    controller: 'RawDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RawData', function(RawData) {
                            return RawData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('raw-data', null, { reload: 'raw-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('raw-data.delete', {
            parent: 'raw-data',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/raw-data/raw-data-delete-dialog.html',
                    controller: 'RawDataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RawData', function(RawData) {
                            return RawData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('raw-data', null, { reload: 'raw-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('RawData', RawData);

    RawData.$inject = ['$resource'];

    function RawData ($resource) {
        var resourceUrl =  'api/raw-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('RawDataController', RawDataController);

    RawDataController.$inject = ['$scope', '$state', 'RawData'];

    function RawDataController ($scope, $state, RawData) {
        var vm = this;
        
        vm.rawData = [];

        loadAll();

        function loadAll() {
            RawData.query(function(result) {
                vm.rawData = result;
            });
        }
    }
})();

/**
 * Created by g9a on 9/22/16.
 */
(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('MoistureTransferQuery', MoistureTransferQuery);

    MoistureTransferQuery.$inject = ['$resource'];

    function MoistureTransferQuery ($resource) {
        var resourceUrl =  'api/moisture-transfer/map_location_id/:map_location_id/building_type_id/:building_type_id';

        return $resource(resourceUrl, {map_location_id: '@map_location_id', building_type_id: '@building_type_id'}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('MoistureTransferDialogController', MoistureTransferDialogController);

    MoistureTransferDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MoistureTransfer', 'BuildingType', 'MapLocation'];

    function MoistureTransferDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MoistureTransfer, BuildingType, MapLocation) {
        var vm = this;

        vm.moistureTransfer = entity;
        vm.clear = clear;
        vm.save = save;
        vm.buildingtypes = BuildingType.query();
        vm.maplocations = MapLocation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.moistureTransfer.id !== null) {
                MoistureTransfer.update(vm.moistureTransfer, onSaveSuccess, onSaveError);
            } else {
                MoistureTransfer.save(vm.moistureTransfer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:moistureTransferUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('MoistureTransferDetailController', MoistureTransferDetailController);

    MoistureTransferDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MoistureTransfer', 'BuildingType', 'MapLocation'];

    function MoistureTransferDetailController($scope, $rootScope, $stateParams, previousState, entity, MoistureTransfer, BuildingType, MapLocation) {
        var vm = this;

        vm.moistureTransfer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('infiltrationApp:moistureTransferUpdate', function(event, result) {
            vm.moistureTransfer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('MoistureTransferDeleteController',MoistureTransferDeleteController);

    MoistureTransferDeleteController.$inject = ['$uibModalInstance', 'entity', 'MoistureTransfer'];

    function MoistureTransferDeleteController($uibModalInstance, entity, MoistureTransfer) {
        var vm = this;

        vm.moistureTransfer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MoistureTransfer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('moisture-transfer', {
            parent: 'entity',
            url: '/moisture-transfer',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'MoistureTransfers'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/moisture-transfer/moisture-transfers.html',
                    controller: 'MoistureTransferController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('moisture-transfer-detail', {
            parent: 'entity',
            url: '/moisture-transfer/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'MoistureTransfer'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/moisture-transfer/moisture-transfer-detail.html',
                    controller: 'MoistureTransferDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MoistureTransfer', function($stateParams, MoistureTransfer) {
                    return MoistureTransfer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'moisture-transfer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('moisture-transfer-detail.edit', {
            parent: 'moisture-transfer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moisture-transfer/moisture-transfer-dialog.html',
                    controller: 'MoistureTransferDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MoistureTransfer', function(MoistureTransfer) {
                            return MoistureTransfer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('moisture-transfer.new', {
            parent: 'moisture-transfer',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moisture-transfer/moisture-transfer-dialog.html',
                    controller: 'MoistureTransferDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ex2: null,
                                ex: null,
                                econstant: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('moisture-transfer', null, { reload: 'moisture-transfer' });
                }, function() {
                    $state.go('moisture-transfer');
                });
            }]
        })
        .state('moisture-transfer.edit', {
            parent: 'moisture-transfer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moisture-transfer/moisture-transfer-dialog.html',
                    controller: 'MoistureTransferDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MoistureTransfer', function(MoistureTransfer) {
                            return MoistureTransfer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('moisture-transfer', null, { reload: 'moisture-transfer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('moisture-transfer.delete', {
            parent: 'moisture-transfer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moisture-transfer/moisture-transfer-delete-dialog.html',
                    controller: 'MoistureTransferDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MoistureTransfer', function(MoistureTransfer) {
                            return MoistureTransfer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('moisture-transfer', null, { reload: 'moisture-transfer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('MoistureTransfer', MoistureTransfer);

    MoistureTransfer.$inject = ['$resource'];

    function MoistureTransfer ($resource) {
        var resourceUrl =  'api/moisture-transfers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('MoistureTransferController', MoistureTransferController);

    MoistureTransferController.$inject = ['$scope', '$state', 'MoistureTransfer'];

    function MoistureTransferController ($scope, $state, MoistureTransfer) {
        var vm = this;
        
        vm.moistureTransfers = [];

        loadAll();

        function loadAll() {
            MoistureTransfer.query(function(result) {
                vm.moistureTransfers = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('MapLocationDialogController', MapLocationDialogController);

    MapLocationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MapLocation'];

    function MapLocationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MapLocation) {
        var vm = this;

        vm.mapLocation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.mapLocation.id !== null) {
                MapLocation.update(vm.mapLocation, onSaveSuccess, onSaveError);
            } else {
                MapLocation.save(vm.mapLocation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:mapLocationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('MapLocationDetailController', MapLocationDetailController);

    MapLocationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MapLocation'];

    function MapLocationDetailController($scope, $rootScope, $stateParams, previousState, entity, MapLocation) {
        var vm = this;

        vm.mapLocation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('infiltrationApp:mapLocationUpdate', function(event, result) {
            vm.mapLocation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('MapLocationDeleteController',MapLocationDeleteController);

    MapLocationDeleteController.$inject = ['$uibModalInstance', 'entity', 'MapLocation'];

    function MapLocationDeleteController($uibModalInstance, entity, MapLocation) {
        var vm = this;

        vm.mapLocation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MapLocation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('map-location', {
            parent: 'entity',
            url: '/map-location',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'MapLocations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-location/map-locations.html',
                    controller: 'MapLocationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('map-location-detail', {
            parent: 'entity',
            url: '/map-location/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'MapLocation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/map-location/map-location-detail.html',
                    controller: 'MapLocationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MapLocation', function($stateParams, MapLocation) {
                    return MapLocation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'map-location',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('map-location-detail.edit', {
            parent: 'map-location-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/map-location/map-location-dialog.html',
                    controller: 'MapLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MapLocation', function(MapLocation) {
                            return MapLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('map-location.new', {
            parent: 'map-location',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/map-location/map-location-dialog.html',
                    controller: 'MapLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                countryId: null,
                                country: null,
                                countryAbbrev: null,
                                stateId: null,
                                stateName: null,
                                stateAbbrev: null,
                                city: null,
                                latitude: null,
                                longitude: null,
                                climateZoneName: null,
                                ieccClimateType: null,
                                ieccClimateZone: null,
                                hdd65: null,
                                cdd65: null,
                                cityState: null,
                                combinedIecc: null,
                                czNumber: null,
                                costElectricity: null,
                                costGas: null,
                                isActive: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('map-location', null, { reload: 'map-location' });
                }, function() {
                    $state.go('map-location');
                });
            }]
        })
        .state('map-location.edit', {
            parent: 'map-location',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/map-location/map-location-dialog.html',
                    controller: 'MapLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MapLocation', function(MapLocation) {
                            return MapLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('map-location', null, { reload: 'map-location' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('map-location.delete', {
            parent: 'map-location',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/map-location/map-location-delete-dialog.html',
                    controller: 'MapLocationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MapLocation', function(MapLocation) {
                            return MapLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('map-location', null, { reload: 'map-location' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('MapLocation', MapLocation);

    MapLocation.$inject = ['$resource'];

    function MapLocation ($resource) {
        var resourceUrl =  'api/map-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('MapLocationController', MapLocationController);

    MapLocationController.$inject = ['$scope', '$state', 'MapLocation'];

    function MapLocationController ($scope, $state, MapLocation) {
        var vm = this;
        
        vm.mapLocations = [];

        loadAll();

        function loadAll() {
            MapLocation.query(function(result) {
                vm.mapLocations = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('InfiltrationResultDialogController', InfiltrationResultDialogController);

    InfiltrationResultDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InfiltrationResult', 'InfiltrationEntry'];

    function InfiltrationResultDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InfiltrationResult, InfiltrationEntry) {
        var vm = this;

        vm.infiltrationResult = entity;
        vm.clear = clear;
        vm.save = save;
        vm.infiltrationentries = InfiltrationEntry.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.infiltrationResult.id !== null) {
                InfiltrationResult.update(vm.infiltrationResult, onSaveSuccess, onSaveError);
            } else {
                InfiltrationResult.save(vm.infiltrationResult, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:infiltrationResultUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('InfiltrationResultDetailController', InfiltrationResultDetailController);

    InfiltrationResultDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InfiltrationResult', 'InfiltrationEntry'];

    function InfiltrationResultDetailController($scope, $rootScope, $stateParams, previousState, entity, InfiltrationResult, InfiltrationEntry) {
        var vm = this;

        vm.infiltrationResult = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('infiltrationApp:infiltrationResultUpdate', function(event, result) {
            vm.infiltrationResult = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('InfiltrationResultDeleteController',InfiltrationResultDeleteController);

    InfiltrationResultDeleteController.$inject = ['$uibModalInstance', 'entity', 'InfiltrationResult'];

    function InfiltrationResultDeleteController($uibModalInstance, entity, InfiltrationResult) {
        var vm = this;

        vm.infiltrationResult = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InfiltrationResult.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('infiltration-result', {
            parent: 'entity',
            url: '/infiltration-result',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfiltrationResults'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/infiltration-result/infiltration-results.html',
                    controller: 'InfiltrationResultController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('infiltration-result-detail', {
            parent: 'entity',
            url: '/infiltration-result/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfiltrationResult'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/infiltration-result/infiltration-result-detail.html',
                    controller: 'InfiltrationResultDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InfiltrationResult', function($stateParams, InfiltrationResult) {
                    return InfiltrationResult.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'infiltration-result',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('infiltration-result-detail.edit', {
            parent: 'infiltration-result-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infiltration-result/infiltration-result-dialog.html',
                    controller: 'InfiltrationResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfiltrationResult', function(InfiltrationResult) {
                            return InfiltrationResult.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('infiltration-result.new', {
            parent: 'infiltration-result',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infiltration-result/infiltration-result-dialog.html',
                    controller: 'InfiltrationResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                electricUse: null,
                                gasUse: null,
                                electricCostSavings: null,
                                gasCostSavings: null,
                                totalCostSavings: null,
                                totalSavings: null,
                                electricSavings: null,
                                gasSavings: null,
                                descriptionText: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('infiltration-result', null, { reload: 'infiltration-result' });
                }, function() {
                    $state.go('infiltration-result');
                });
            }]
        })
        .state('infiltration-result.edit', {
            parent: 'infiltration-result',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infiltration-result/infiltration-result-dialog.html',
                    controller: 'InfiltrationResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfiltrationResult', function(InfiltrationResult) {
                            return InfiltrationResult.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('infiltration-result', null, { reload: 'infiltration-result' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('infiltration-result.delete', {
            parent: 'infiltration-result',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infiltration-result/infiltration-result-delete-dialog.html',
                    controller: 'InfiltrationResultDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InfiltrationResult', function(InfiltrationResult) {
                            return InfiltrationResult.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('infiltration-result', null, { reload: 'infiltration-result' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('InfiltrationResult', InfiltrationResult);

    InfiltrationResult.$inject = ['$resource'];

    function InfiltrationResult ($resource) {
        var resourceUrl =  'api/infiltration-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('InfiltrationResultController', InfiltrationResultController);

    InfiltrationResultController.$inject = ['$scope', '$state', 'InfiltrationResult'];

    function InfiltrationResultController ($scope, $state, InfiltrationResult) {
        var vm = this;
        
        vm.infiltrationResults = [];

        loadAll();

        function loadAll() {
            InfiltrationResult.query(function(result) {
                vm.infiltrationResults = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('InfiltrationEntryDialogController', InfiltrationEntryDialogController);

    InfiltrationEntryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InfiltrationEntry', 'InfiltrationResult', 'BuildingType', 'MapLocation'];

    function InfiltrationEntryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InfiltrationEntry, InfiltrationResult, BuildingType, MapLocation) {
        var vm = this;

        vm.infiltrationEntry = entity;
        vm.clear = clear;
        vm.save = save;
        vm.infiltrationresults = InfiltrationResult.query();
        vm.buildingtypes = BuildingType.query();
        vm.maplocations = MapLocation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.infiltrationEntry.id !== null) {
                InfiltrationEntry.update(vm.infiltrationEntry, onSaveSuccess, onSaveError);
            } else {
                InfiltrationEntry.save(vm.infiltrationEntry, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:infiltrationEntryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('InfiltrationEntryDetailController', InfiltrationEntryDetailController);

    InfiltrationEntryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InfiltrationEntry', 'InfiltrationResult', 'BuildingType', 'MapLocation'];

    function InfiltrationEntryDetailController($scope, $rootScope, $stateParams, previousState, entity, InfiltrationEntry, InfiltrationResult, BuildingType, MapLocation) {
        var vm = this;

        vm.infiltrationEntry = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('infiltrationApp:infiltrationEntryUpdate', function(event, result) {
            vm.infiltrationEntry = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('InfiltrationEntryDeleteController',InfiltrationEntryDeleteController);

    InfiltrationEntryDeleteController.$inject = ['$uibModalInstance', 'entity', 'InfiltrationEntry'];

    function InfiltrationEntryDeleteController($uibModalInstance, entity, InfiltrationEntry) {
        var vm = this;

        vm.infiltrationEntry = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InfiltrationEntry.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('infiltration-entry', {
            parent: 'entity',
            url: '/infiltration-entry',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfiltrationEntries'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/infiltration-entry/infiltration-entries.html',
                    controller: 'InfiltrationEntryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('infiltration-entry-detail', {
            parent: 'entity',
            url: '/infiltration-entry/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfiltrationEntry'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/infiltration-entry/infiltration-entry-detail.html',
                    controller: 'InfiltrationEntryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InfiltrationEntry', function($stateParams, InfiltrationEntry) {
                    return InfiltrationEntry.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'infiltration-entry',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('infiltration-entry-detail.edit', {
            parent: 'infiltration-entry-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infiltration-entry/infiltration-entry-dialog.html',
                    controller: 'InfiltrationEntryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfiltrationEntry', function(InfiltrationEntry) {
                            return InfiltrationEntry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('infiltration-entry.new', {
            parent: 'infiltration-entry',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infiltration-entry/infiltration-entry-dialog.html',
                    controller: 'InfiltrationEntryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                area: null,
                                basecaseLeakage: null,
                                retrofittedLeakage: null,
                                costElectricity: null,
                                costGas: null,
                                areaUnit: null,
                                leakageUnit: null,
                                gasCostUnits: null,
                                descriptionText: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('infiltration-entry', null, { reload: 'infiltration-entry' });
                }, function() {
                    $state.go('infiltration-entry');
                });
            }]
        })
        .state('infiltration-entry.edit', {
            parent: 'infiltration-entry',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infiltration-entry/infiltration-entry-dialog.html',
                    controller: 'InfiltrationEntryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfiltrationEntry', function(InfiltrationEntry) {
                            return InfiltrationEntry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('infiltration-entry', null, { reload: 'infiltration-entry' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('infiltration-entry.delete', {
            parent: 'infiltration-entry',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infiltration-entry/infiltration-entry-delete-dialog.html',
                    controller: 'InfiltrationEntryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InfiltrationEntry', function(InfiltrationEntry) {
                            return InfiltrationEntry.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('infiltration-entry', null, { reload: 'infiltration-entry' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('InfiltrationEntry', InfiltrationEntry);

    InfiltrationEntry.$inject = ['$resource'];

    function InfiltrationEntry ($resource) {
        var resourceUrl =  'api/infiltration-entries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('InfiltrationEntryController', InfiltrationEntryController);

    InfiltrationEntryController.$inject = ['$scope', '$state', 'InfiltrationEntry'];

    function InfiltrationEntryController ($scope, $state, InfiltrationEntry) {
        var vm = this;
        
        vm.infiltrationEntries = [];

        loadAll();

        function loadAll() {
            InfiltrationEntry.query(function(result) {
                vm.infiltrationEntries = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

/**
 * Created by g9a on 9/22/16.
 */
(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('EnergyCalcQuery', EnergyCalcQuery);

    EnergyCalcQuery.$inject = ['$resource'];

    function EnergyCalcQuery ($resource) {
        var resourceUrl =  'api/energy-calc/map_location_id/:map_location_id/building_type_id/:building_type_id';

        return $resource(resourceUrl, {map_location_id: '@map_location_id', building_type_id: '@building_type_id'}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('EnergyCalcDialogController', EnergyCalcDialogController);

    EnergyCalcDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EnergyCalc', 'MapLocation', 'BuildingType'];

    function EnergyCalcDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EnergyCalc, MapLocation, BuildingType) {
        var vm = this;

        vm.energyCalc = entity;
        vm.clear = clear;
        vm.save = save;
        vm.maplocations = MapLocation.query();
        vm.buildingtypes = BuildingType.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.energyCalc.id !== null) {
                EnergyCalc.update(vm.energyCalc, onSaveSuccess, onSaveError);
            } else {
                EnergyCalc.save(vm.energyCalc, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:energyCalcUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('EnergyCalcDetailController', EnergyCalcDetailController);

    EnergyCalcDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EnergyCalc', 'MapLocation', 'BuildingType'];

    function EnergyCalcDetailController($scope, $rootScope, $stateParams, previousState, entity, EnergyCalc, MapLocation, BuildingType) {
        var vm = this;

        vm.energyCalc = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('infiltrationApp:energyCalcUpdate', function(event, result) {
            vm.energyCalc = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('EnergyCalcDeleteController',EnergyCalcDeleteController);

    EnergyCalcDeleteController.$inject = ['$uibModalInstance', 'entity', 'EnergyCalc'];

    function EnergyCalcDeleteController($uibModalInstance, entity, EnergyCalc) {
        var vm = this;

        vm.energyCalc = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EnergyCalc.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('energy-calc', {
            parent: 'entity',
            url: '/energy-calc',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'EnergyCalcs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/energy-calc/energy-calcs.html',
                    controller: 'EnergyCalcController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('energy-calc-detail', {
            parent: 'entity',
            url: '/energy-calc/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'EnergyCalc'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/energy-calc/energy-calc-detail.html',
                    controller: 'EnergyCalcDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'EnergyCalc', function($stateParams, EnergyCalc) {
                    return EnergyCalc.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'energy-calc',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('energy-calc-detail.edit', {
            parent: 'energy-calc-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/energy-calc/energy-calc-dialog.html',
                    controller: 'EnergyCalcDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EnergyCalc', function(EnergyCalc) {
                            return EnergyCalc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('energy-calc.new', {
            parent: 'energy-calc',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/energy-calc/energy-calc-dialog.html',
                    controller: 'EnergyCalcDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                xElectric: null,
                                x2Electric: null,
                                xGas: null,
                                x2Gas: null,
                                descriptionText: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('energy-calc', null, { reload: 'energy-calc' });
                }, function() {
                    $state.go('energy-calc');
                });
            }]
        })
        .state('energy-calc.edit', {
            parent: 'energy-calc',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/energy-calc/energy-calc-dialog.html',
                    controller: 'EnergyCalcDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EnergyCalc', function(EnergyCalc) {
                            return EnergyCalc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('energy-calc', null, { reload: 'energy-calc' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('energy-calc.delete', {
            parent: 'energy-calc',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/energy-calc/energy-calc-delete-dialog.html',
                    controller: 'EnergyCalcDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EnergyCalc', function(EnergyCalc) {
                            return EnergyCalc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('energy-calc', null, { reload: 'energy-calc' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('EnergyCalc', EnergyCalc);

    EnergyCalc.$inject = ['$resource'];

    function EnergyCalc ($resource) {
        var resourceUrl =  'api/energy-calcs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('EnergyCalcController', EnergyCalcController);

    EnergyCalcController.$inject = ['$scope', '$state', 'EnergyCalc'];

    function EnergyCalcController ($scope, $state, EnergyCalc) {
        var vm = this;
        
        vm.energyCalcs = [];

        loadAll();

        function loadAll() {
            EnergyCalc.query(function(result) {
                vm.energyCalcs = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('BuildingTypeDialogController', BuildingTypeDialogController);

    BuildingTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BuildingType'];

    function BuildingTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BuildingType) {
        var vm = this;

        vm.buildingType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.buildingType.id !== null) {
                BuildingType.update(vm.buildingType, onSaveSuccess, onSaveError);
            } else {
                BuildingType.save(vm.buildingType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:buildingTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('BuildingTypeDetailController', BuildingTypeDetailController);

    BuildingTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BuildingType'];

    function BuildingTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, BuildingType) {
        var vm = this;

        vm.buildingType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('infiltrationApp:buildingTypeUpdate', function(event, result) {
            vm.buildingType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('BuildingTypeDeleteController',BuildingTypeDeleteController);

    BuildingTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'BuildingType'];

    function BuildingTypeDeleteController($uibModalInstance, entity, BuildingType) {
        var vm = this;

        vm.buildingType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BuildingType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('building-type', {
            parent: 'entity',
            url: '/building-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'BuildingTypes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/building-type/building-types.html',
                    controller: 'BuildingTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('building-type-detail', {
            parent: 'entity',
            url: '/building-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'BuildingType'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/building-type/building-type-detail.html',
                    controller: 'BuildingTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'BuildingType', function($stateParams, BuildingType) {
                    return BuildingType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'building-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('building-type-detail.edit', {
            parent: 'building-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/building-type/building-type-dialog.html',
                    controller: 'BuildingTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BuildingType', function(BuildingType) {
                            return BuildingType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('building-type.new', {
            parent: 'building-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/building-type/building-type-dialog.html',
                    controller: 'BuildingTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                longName: null,
                                shortName: null,
                                sortOrder: null,
                                leakageRate: null,
                                altLeakageRate: null,
                                floorArea: null,
                                descriptionText: null,
                                isDefault: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('building-type', null, { reload: 'building-type' });
                }, function() {
                    $state.go('building-type');
                });
            }]
        })
        .state('building-type.edit', {
            parent: 'building-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/building-type/building-type-dialog.html',
                    controller: 'BuildingTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BuildingType', function(BuildingType) {
                            return BuildingType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('building-type', null, { reload: 'building-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('building-type.delete', {
            parent: 'building-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/building-type/building-type-delete-dialog.html',
                    controller: 'BuildingTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BuildingType', function(BuildingType) {
                            return BuildingType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('building-type', null, { reload: 'building-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('BuildingType', BuildingType);

    BuildingType.$inject = ['$resource'];

    function BuildingType ($resource) {
        var resourceUrl =  'api/building-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('BuildingTypeController', BuildingTypeController);

    BuildingTypeController.$inject = ['$scope', '$state', 'BuildingType'];

    function BuildingTypeController ($scope, $state, BuildingType) {
        var vm = this;
        
        vm.buildingTypes = [];

        loadAll();

        function loadAll() {
            BuildingType.query(function(result) {
                vm.buildingTypes = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('BuildingDialogController', BuildingDialogController);

    BuildingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Building'];

    function BuildingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Building) {
        var vm = this;

        vm.building = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.building.id !== null) {
                Building.update(vm.building, onSaveSuccess, onSaveError);
            } else {
                Building.save(vm.building, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('infiltrationApp:buildingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('BuildingDetailController', BuildingDetailController);

    BuildingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Building'];

    function BuildingDetailController($scope, $rootScope, $stateParams, previousState, entity, Building) {
        var vm = this;

        vm.building = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('infiltrationApp:buildingUpdate', function(event, result) {
            vm.building = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('BuildingDeleteController',BuildingDeleteController);

    BuildingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Building'];

    function BuildingDeleteController($uibModalInstance, entity, Building) {
        var vm = this;

        vm.building = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Building.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('building', {
            parent: 'entity',
            url: '/building',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Buildings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/building/buildings.html',
                    controller: 'BuildingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('building-detail', {
            parent: 'entity',
            url: '/building/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Building'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/building/building-detail.html',
                    controller: 'BuildingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Building', function($stateParams, Building) {
                    return Building.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'building',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('building-detail.edit', {
            parent: 'building-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/building/building-dialog.html',
                    controller: 'BuildingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Building', function(Building) {
                            return Building.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('building.new', {
            parent: 'building',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/building/building-dialog.html',
                    controller: 'BuildingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sqft: null,
                                basecaseLeakageRate: null,
                                retrofitLeakageRate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('building', null, { reload: 'building' });
                }, function() {
                    $state.go('building');
                });
            }]
        })
        .state('building.edit', {
            parent: 'building',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/building/building-dialog.html',
                    controller: 'BuildingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Building', function(Building) {
                            return Building.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('building', null, { reload: 'building' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('building.delete', {
            parent: 'building',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/building/building-delete-dialog.html',
                    controller: 'BuildingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Building', function(Building) {
                            return Building.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('building', null, { reload: 'building' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('infiltrationApp')
        .factory('Building', Building);

    Building.$inject = ['$resource'];

    function Building ($resource) {
        var resourceUrl =  'api/buildings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('BuildingController', BuildingController);

    BuildingController.$inject = ['$scope', '$state', 'Building'];

    function BuildingController ($scope, $state, Building) {
        var vm = this;
        
        vm.buildings = [];

        loadAll();

        function loadAll() {
            Building.query(function(result) {
                vm.buildings = result;
            });
        }
    }
})();

/**
 * Created by g9a on 9/12/16.
 */
(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('UnitConversion', UnitConversion)
        .constant("Constants", {
            CurrencyType: {
                USD: 1,
                CAD: 1.29,
                CNY: 6.64
            },
            ConversionFactor: 0.2034,
            FeetKbtuConversionFactor: 1.021,
            MeterKbtuConversionFactor: 35.314667
        });


    UnitConversion.$inject = ['Constants'];

    function UnitConversion () {

        // Natural gas costs: $/m^3 or $/1000ft^3


        var service = {
            // For Floor area
            toSquareFeet: toSquareFeet,
            toMetersSquared: toMetersSquared,
            toMetersCubed: toMetersCubed,
            toFeetCubed: toFeetCubed,
            // For leakage
            toLeakageMeters : toLeakageMeters,
            toLeakageFeet : toLeakageFeet,
            // For gas savings
            kbtuToFeetCubed : kbtuToFeetCubed,
            kbtuToMeterCubed : kbtuToMeterCubed,
            toCny: toCny,
            toUsd: toUsd,
            toCad: toCad
        };

        return service;

        function kbtuToMeterCubed (input) {
            // This is to convert the result that has been calculated as kbtu to a savings by m^3
            //var retVal = (input * 0.0277344 * 1000).toFixed(2);
            var retVal = (input / 35.31742)/1.021;
            console.log("gas savings to meters cubed: input ", input, " output ", retVal);
            return retVal;
        }

        function kbtuToFeetCubed (input) {
            // This is to convert the result that has been calculated as kbtu to a savings by 1000ft^3
            var retVal = (input * 0.97943).toFixed(2);
            console.log("gas savings to 1000 feet cubed: input ", input, " output ", retVal);
            return retVal;
        }

        function toSquareFeet (input) {
            // from m^2 to ft^2
            var retVal = (input / 0.09290304).toFixed(2);
            console.log("to square feet: input ", input, " output ", retVal);
            return retVal;
        }

        function toMetersSquared (input) {
            // from ft^2 to m^2
            var retVal = (input * 0.09290304).toFixed(2);
            console.log("to meters squared: input ", input, " output ", retVal);
            return retVal;
        }

        function toMetersCubed (input) {
            // from ft^3 to m^3
            //var retVal = (input / 35.315) / 1000;
            var retVal = (input / 28.3168).toFixed(2);
            console.log("to meters cubed: input ", input, " output ", retVal);
            return retVal;
        }

        function toFeetCubed (input) {
            // from m^3 to ft^3
            //var retVal = (input * 35.315) / 1000;
            var retVal = (input * 28.3168).toFixed(2);
            console.log("to feet cubed: input ", input, " output ", retVal);
            return retVal;
        }

        function toLeakageFeet (input) {
            // From  L/sec*m^2 to CFM/ft^2
            var output = (input * 0.19685).toFixed(2);
            console.log("to leakage feet: input ", input, " output ", output);
            return output;
        }

        function toLeakageMeters (input) {
            // From CFM/ft^2 to L/sec*m^2
            var output = (input/0.19685).toFixed(2);
            console.log("to leakage meters: input ", input, " output ", output);
            return output;
        }

        // Below is not used at all

        function toUsd (input, fromUnit) {
            // To United States Dollar
            var output = (input * fromUnit).toFixed(2);
            return output;
        }

        function toCad (input, fromUnit) {
            // To Canadian Dollars
            var output = toUsd(fromUnit)/Constants.CurrencyType.CAD;
            return output;
        }

        function toCny (input, fromUnit) {
            // To Chinese Yuan
            var output = toUsd(fromUnit)/Constants.CurrencyType.CNY;
            return output;
        }
    }
})();

/**
 * Created by g9a on 7/27/16.
 *
 * From angular-ui v 0.0.0 https://github.com/angular-ui/angular-ui-OLDREPO
 *
 *
 *
 * The MIT License

 Copyright (c) 2012 the AngularUI Team, http://angular-ui.github.com

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 *
 */
(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .filter('unique', unique);

    function unique() {
        return function (items, filterOn) {

            if (filterOn === false) {
                return items;
            }

            if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                var hashCheck = {}, newItems = [];

                var extractValueToCompare = function (item) {
                    if (angular.isObject(item) && angular.isString(filterOn)) {
                        return item[filterOn];
                    } else {
                        return item;
                    }
                };

                angular.forEach(items, function (item) {
                    var valueToCheck, isDuplicate = false;

                    for (var i = 0; i < newItems.length; i++) {
                        if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                            isDuplicate = true;
                            break;
                        }
                    }
                    if (!isDuplicate) {
                        newItems.push(item);
                    }

                });
                items = newItems;
            }
            return items;
        };    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('MoistureTransferCalculation', MoistureTransferCalculation);

    function MoistureTransferCalculation() {
        var service = {
        };
        return service;
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('infiltrationApp')
        .component('jhiItemCount', jhiItemCount);
})();

/**
 * Created by g9a on 9/21/16.
 */
(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('EnergyCalculation', EnergyCalculation);

    function EnergyCalculation () {

        var service = {
            wholeHouseSavings : wholeHouseSavings,
            floorAreaSavings : floorAreaSavings,
            costSavings: costSavings,
            costSavingsGas: costSavingsGas,
            costSavingsGasFt: costSavingsGasFt,
            calculateEnergySavings: calculateEnergySavings,
            calculate: calculateCostSavings,
            calculateOnlyCostSavings: calculateOnlyCostSavings
        };

        return service;

        /*
         Whole House
         Electric savings = xElectric * (basecaseLeakage - retrofittedLeakage) + x2Electric * (basecaseLeakage^2 - retrofittedLeakage^2)
         Gas savings = xGas * (basecaseLeakage - retrofittedLeakage) + x2Gas * (basecaseLeakage^2 - retrofittedLeakage^2)

         User Specified Floor Area savings
         Electric savings = Whole House Electric * (sqft / BuildingType.floorArea);
         Gas savings = Whole House Gas * (sqft / BuildingType.floorArea);

         Dollar Savings
         Electric = Electric savings * costElectricity;
         Gas = Gas savings * costGas;

         */

        function floorAreaSavings (wholeHouse, actualSqft, buildingTypeFloorArea) {
            // Calculate floor area savings from whole house, adjust for squarefootage
            var output = wholeHouse * (actualSqft / buildingTypeFloorArea);
            return output;
        }

        function wholeHouseSavings (x, x2, basecaseLeakage, retrofittedLeakage) {
            // Calculate whole house savings
            // Math.pow did not give expected result, resorted to simply manually squaring
            var output = x * (basecaseLeakage - retrofittedLeakage) + x2 * ((basecaseLeakage * basecaseLeakage) - (retrofittedLeakage * retrofittedLeakage));
            return output;
        }

        function costSavings (savings, cost) {
            // To United States Dollar per thousand cubic feet
            var output = savings * cost;
            return output;
        }

        function costSavingsGas (savingskBtu, cost) {
            // To United States Dollar per thousand cubic feet
            var savingsft3 = savingskBtu/1.021;
            var output = (savingsft3/1000.0) * cost;
            return output;
        }

        function costSavingsGasFt(savingskBtu, cost) {
            var output = cost * savingskBtu/1000.0;
            return output;
        }

        function calculateEnergySavings (x, x2, basecaseLeakage, retrofittedLeakage, actualSqft, buildingTypeFloorArea) {
            // Perform all calculations
            var wholeHouse = wholeHouseSavings(x, x2, basecaseLeakage, retrofittedLeakage);
            var floorArea = floorAreaSavings(wholeHouse, actualSqft, buildingTypeFloorArea);

            return floorArea;
        }

        function calculateCostSavings (floorAreaSavings, cost) {
            return floorArea * cost;
        }

        function calculateOnlyCostSavings (x, x2, basecaseLeakage, retrofittedLeakage, actualSqft, buildingTypeFloorArea, cost) {
            // Perform all calculations
            var wholeHouse = wholeHouseSavings(x, x2, basecaseLeakage, retrofittedLeakage);
            var floorArea = floorAreaSavings(wholeHouse, actualSqft, buildingTypeFloorArea);
            var costSavings = floorArea * cost;
            return costSavings;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('infiltrationApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('infiltrationApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-infiltrationApp-error');
                var entityKey = httpResponse.headers('X-infiltrationApp-params');
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('infiltrationApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-infiltrationApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-infiltrationApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('infiltrationApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'infiltration' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('infiltrationApp')
        .constant('VERSION', "1.0-BETA")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'infiltration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('infiltrationApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('infiltrationApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('infiltrationApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak>\n    <div class="row">\n        <div class="col-lg-12">\n            <h2>Welcome to the</h2>\n            <h1>Energy Savings and Moisture Transfer Calculator</h1>\n        </div>\n    </div>\n    <div >\n        <div class="row">\n            <div class="col-lg-12 lead text-justify">\n                <br>\n                <p>Uncontrolled heat, air, and moisture transfer through the building envelope has a significant impact on energy usage.  A comprehensive strategy for concurrently regulating these factors will have a major impact on reducing energy consumption.  The <a href="http://energy.gov/sites/prod/files/2014/02/f8/BTO_windows_and_envelope_report_3.pdf" target="_blank">DOE Windows and Building Envelope Research and Development Roadmap for Emerging Technologies</a> shows that in 2010, infiltration was responsible for 4 quads of space conditioning primary energy use in the residential and commercial sectors.  In aggregate, infiltration accounted for greater energy losses than any other component of the building envelope, including fenestration and is responsible for over 4 % of all the energy used in the United States. Furthermore, the Roadmap shows that the addition of air barrier systems would have a payback that is much less than 5 years.\n                </p><p>The Roadmap further states that \u201Ccomputational tools are critically important for the design of commercial buildings with energy efficient envelope materials.  As new technologies are developed, models and simulation tools must be updated to account for increased performance.\u201D  An impediment for the wider adoption of air barrier systems into buildings is the lack of a simple credible tool that can be employed by building architects, designers, and owners that accurately estimates the energy savings that could be expected if an air barrier system was added to the design.  This calculator fills this void, is based on the best science available, and is easy to use.            </p>\n            </div>\n            <!--<div class="col-lg-4">-->\n                <!--<span class="tools_home img-responsive img-rounded"></span>-->\n            <!--</div>-->\n        </div>\n        <div class="row">\n            <!--<div class="col-lg-3 text-center">-->\n                <!--<button type="button" class="btn btn-info" ui-sref="about">About EMMES</button>-->\n            <!--</div>-->\n            <div class="col-lg-3 text-center">\n                <button type="button" class="btn btn-info" ui-sref="infiltration">Start your calculation</button>\n            </div>\n            <div class="col-lg-1"><span>OR</span></div>\n            <div class="col-lg-3 text-center" >\n                <!--The site is currently down for testing. Logins will be disabled until testing is completed on the new features: moisture transfer and equivalent leakage area.-->\n                <button type="button" class="btn btn-info" ng-click="vm.login()">Sign In</button>\n            </div>\n            <div class="col-lg-6"></div>\n<!--            <div class="col-lg-1">Or</div>-->\n<!--            <div class="col-lg-4">-->\n<!--            &lt;!&ndash;The site is currently down for testing. Logins will be disabled until testing is completed on the new features: moisture transfer and equivalent leakage area.&ndash;&gt;-->\n<!--            <button type="button" class="btn btn-info" ng-click="vm.login()">Sign In</button>-->\n<!--            </div>-->\n        </div>\n       <div class="row">\n<!--        <div class="col-lg-3 text-center" >-->\n<!--            &lt;!&ndash;The site is currently down for testing. Logins will be disabled until testing is completed on the new features: moisture transfer and equivalent leakage area.&ndash;&gt;-->\n<!--            <button type="button" class="btn btn-info" ng-click="vm.login()">Sign In</button>-->\n<!--        </div>-->\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/infiltration/infiltration.html','<div ng-cloak>\n    <div class="row">\n        <div class="col-md-12">\n            <div>\n                <h2>Infiltration Calculator</h2>\n                <jh-alert></jh-alert>\n                <div class="container">\n\n                    <form class="form-horizontal">\n                        <div class="row" ng-cloak>\n                            <div class="col-xs-11">\n                                <ui-gmap-google-map center=\'map.center\' zoom=\'map.zoom\' options="map.options"\n                                                    control="googlemap" click="mapClick">\n                                    <ui-gmap-markers models="markers" idkey="\'id\'"\n                                                     coords="\'coords\'" click="onMarkerClick">\n                                    </ui-gmap-markers>\n                                </ui-gmap-google-map>\n                            </div>\n                        </div>\n                        <div class="form-group row">\n                            <label class="control-label col-xs-2">Location:\n                                <button type="button" ng-init="hideIt1 = true" ng-click="hideIt1 = !hideIt1"\n                                        class="glyphicon glyphicon-question-sign"\n                                        aria-hidden="true"></button>\n                            </label>\n                            <div class="col-xs-3"><select id="infcountry" class="form-control"\n                                                          ng-model="marker"\n                                                          ng-options="marker.country for marker in markers  | unique: \'country_id\' track by marker.country_id"\n                                                          ng-change="changeSelectedMarker(marker)"></select>\n                            </div>\n                            <div class="col-xs-3"><select id="infstate" class="form-control"\n                                                          ng-model="marker"\n                                                          ng-options="marker.state_name for marker in markers  | unique: \'state_id\' | filter: { country_id : marker.country_id }:true track by marker.state_id"\n                                                          ng-change="changeSelectedMarker(marker)"></select>\n                            </div>\n                            <div class="col-xs-3"><select id="infcity" class="form-control"\n                                                          ng-model="marker"\n                                                          ng-options="marker.city for marker in markers  | unique: \'id\' |  filter: { state_id : marker.state_id }:true track by marker.id"\n                                                          ng-change="changeSelectedMarker(marker)"></select>\n                            </div>\n                        </div>\n                        <div class="row" ng-hide="hideIt1">\n                            <div class="col-xs-10 well bg-info text-muted">\n                                <h4>Location</h4>\n                                <p>The first phase in the development of the calculator analyzes the energy benefits of\n                                    improving building envelope airtightness in 52 cities in the US, 5 cities in Canada,\n                                    and 5 cities in China. Selecting the country unlocks the states or provinces where\n                                    the benefits of improving building envelope airtightness have been determined.\n                                    Choosing the state or province unlocks the cities within that state that have been\n                                    evaluated. The selection of US cities was based on a reasonable distribution of\n                                    major metropolitan areas throughout the US; therefore not every state or province is\n                                    represented. If the specific city for which you are interested in obtaining results\n                                    does not appear on the list, select a city that has similar meteorological\n                                    conditions (wind, temperature, solar radiation, and rain). This is not always the\n                                    city geographically closest to your target city. Cities in Canada and China were\n                                    recommended by our Canadian and Chinese partners.\n                                </p>\n                            </div>\n                        </div>\n\n                        <hr>\n\n                        <div class="form-group row">\n                            <label class="control-label col-xs-2">Building Type:\n                                <button type="button" ng-init="hideIt2 = true" ng-click="hideIt2 = !hideIt2"\n                                        class="glyphicon glyphicon-question-sign"\n                                        aria-hidden="true"></button>\n                            </label>\n                            <div class="col-xs-3">\n                                <select class="form-control" id="field_buildingType" name="buildingType"\n                                        ng-model="buildingType"\n                                        ng-options="buildingType.longName for buildingType in buildingTypes track by buildingType.id"\n                                        ng-change="changeBuildingType(buildingType)"></select>\n                            </div>\n                            <label class="control-label col-xs-2">Floor Area: <select ng-model="areaUnit"\n                                                                                      ng-options="areaUnit.name for areaUnit in areaUnits track by areaUnit.id"\n                                                                                      ng-change="changeAreaUnits(areaUnit)"></select></label>\n                            <div class="col-xs-3">\n                                <input id="buildingSqFt" type="text" onkeyup="this.value = this.value.replace(/[^0-9\\.]/g, \'\').split(/\\./).slice(0, 2).join(\'.\')"\n                                        class="form-control"\n                                       ng-model="floorArea">\n                            </div>\n                        </div>\n\n                        <div class="row" ng-hide="hideIt2">\n                            <div class="col-xs-10 well bg-info text-muted">\n                                <h4>Building Types</h4>\n                                <p>In order to cover a large percentage of the common building types in the\n                                    U.S., the calculator uses the DOE commercial prototype building models (<a\n                                        href="https://www.energycodes.gov/commercial-prototype-building-models">DOEa\n                                        2016</a>). These prototypes were derived from the DOE commercial\n                                    reference building models (<a\n                                        href="http://energy.gov/eere/buildings/commercial-reference-buildings">DOEb\n                                        2016</a>) and represent about 80% of new construction. Moreover, these\n                                    prototypes include 16 commercial building types, including mid- and high-rise\n                                    residential buildings in 17 climate locations defined in ASHRAE Standard 90.1-2013.\n                                    The parameters that are prescribed in these models include building envelope\n                                    components, HVAC equipment types and efficiency, and occupancy schedules. As ASHRAE\n                                    Standard 90.1 evolves, Pacific Northwest National Laboratory modifies these models\n                                    with input from the ASHRAE 90.1 Standing Standard Project Committee members and\n                                    building industry experts. Features of the building models and a detailed\n                                    description of their development are provided by (Goel et al. 2014) and the Building\n                                    Energy Codes Program website (<a\n                                        href="https://www.energycodes.gov/development/commercial/prototype_models">DOEa\n                                        2016</a>). </p>\n                                <p>The first phase in the development of the calculator includes three prototype\n                                    building models: standalone retail, medium office, and mid-rise apartment. Models\n                                    that represent typical commercial buildings in Canada and China are not available in\n                                    the public domain; therefore, the DOE prototypes are also used in these two\n                                    countries.</p>\n                                <p>References:</p>\n                                <p>Goel, S., Athalye, R., Wang, W., Zhang, J., Rosenberg, M., Xie, Y., Hart, R.,\n                                    and V. Mendon. 2014. Enhancements to ASHRAE Standard 90.1 Prototype Building\n                                    Models. PNNL-23269.</p>\n                                <h4>Floor Area</h4>\n                                <p>The air leakage calculations have been performed on a building whose size is\n                                    defined by the DOE commercial prototype building models (<a\n                                        href="https://www.energycodes.gov/commercial-prototype-building-models">DOEa\n                                        2016</a>). However, the energy and monetary savings associated with improved\n                                    airtightness was calculated on a per unit floor area basis. To determine the annual\n                                    savings of your particular building, the actual floor area can be input into this\n                                    window in lieu of the default floor area from the prototype building. As the\n                                    differences between the prototype and actual buildings increase, the uncertainty in\n                                    the energy savings increases as well.\n                                </p>\n                            </div>\n                        </div>\n\n                        <div class="row">\n                            <div class="col-xs-10 text-center">\n                                <div ng-switch on="buildingType.shortName">\n                                    <div ng-switch-when="standalone_retail">\n                                        <span class="center-block standalone_retail img-responsive"/>\n                                    </div>\n                                    <div ng-switch-when="midrise_apt">\n                                        <span class="center-block midrise_apt img-responsive"/>\n                                    </div>\n                                    <div ng-switch-when="office_medium">\n                                        <span class="center-block office_medium img-responsive"/>\n                                    </div>\n                                    <div ng-switch-when="hirise_apt">\n                                        <span class="center-block hirise_apt img-responsive"/>\n                                    </div>\n                                    <div ng-switch-when="hospital">\n                                        <span class="center-block hospital img-responsive"/>\n                                    </div>\n                                    <div ng-switch-when="hotel_large">\n                                        <span class="center-block hotel_large img-responsive"/>\n                                    </div>\n                                    <div ng-switch-when="school_secondary">\n                                        <span class="center-block school_secondary img-responsive"/>\n                                    </div>\n                                    <div ng-switch-when="strip_mall">\n                                        <span class="center-block strip_mall img-responsive"/>\n                                    </div>\n                                    <div ng-switch-when="primary_school">\n                                        <span class="center-block primary_school img-responsive"/>\n                                    </div>\n                                    <div ng-switch-when="residential">\n                                        <span class="center-block residential img-responsive"/>\n                                </div>\n\n                            </div>\n                        </div>\n                        <hr>\n\n                        <div ng-switch on="buildingType.shortName">\n                        <div ng-switch-when="residential">\n                        <div class="row">\n                            <div class="col-xs-10 text-center">\n                                <h4 style="display: inline-block">Leakage Rates:</h4>&nbsp;&nbsp;\n\n                                    <label\n                                class="control-label" >\n                                <select id="leakUnitsRes"\n                                        name="leakUnits"\n                                        ng-model="leakageUnit"\n                                        ng-init="leakageUnit =\'ACH50\'">\n\n                                        <option value="ACH50">ACH</option>\n                                </select>\n                                    </label>\n                                <button type="button" ng-click="hideIt4 = !hideIt4"\n                                        class="glyphicon glyphicon-question-sign"\n                                        aria-hidden="true">\n                                </button>\n                                </div>\n                                </div>\n\n                                <div class="row" ng-init="hideIt4 = true">\n                                    <div class="col-xs-10 " >\n                                        <div  ng-hide="hideIt4">\n                                            <div class="well bg-info text-muted" >\n                                                <h4>Air Leakage Rates</h4>\n                                                <p> The user has the option to either select one of the default values listed\n                                                    below or to input their own air leakage rate if they have that information\n                                                    available or want to evaluate the potential energy savings from an improved\n                                                    airtightness level.</p>\n                                                <p>The following table lists the four levels of airtightness that were assumed\n                                                    in the simulations for residential buildings. The leakage rate is expressed\n                                                    as air changes hour (ACH) values for the building including air changes from\n                                                    6-sided envelopes that does not include attic and crawl space. The baseline value\n                                                    of infiltration of 13 ACH at 50 Pa is derived from the case where no air barrier\n                                                    is present in the building in commercial buildings (Emmerich, McDowell, and Anis 2005).</p>\n\n                                                <p>The table also lists three target levels for improved airtightness at 50 Pa,\n                                                     8.5 ACH is the air tightness of calculated based on infiltration of 2012\n                                                     vintage of DOE prototype building (DOE 2019) ; 5 ACH is the minimum air\n                                                     tightness for buildings at climate zone 1 to 2 as per IECC 2012 (IECC 2012) ;\n                                                      0.6 ACH is the airtightness achieved by passive house (Passive House Institute\n                                                      US 2019).The tool will interpolate between the baseline air leakage rate of 13\n                                                      ACH at 50 pa and tightest level of 0.6 ACH at 50 Pa. No extrapolation is enabled at this time.</p>\n                                                <hr>\n\n                                                <table class="table">\n                                                    <thead>\n                                                    <tr>\n                                                        <th>Case</th>\n                                                        <th>ACH at 75 Pa</th>\n                                                        <th>ACH at 50 Pa</th>\n                                                        <th>Source</th>\n                                                    </tr>\n                                                    </thead>\n                                                    <tbody>\n                                                    <tr>\n                                                        <td>Baseline</td>\n                                                        <td>16.9</td>\n                                                        <td>13</td>\n                                                        <td>(Emmerich, McDowell, and Anis 2005)</td>\n                                                    </tr>\n                                                    <tr>\n                                                        <td>1</td>\n                                                        <td>11.1</td>\n                                                        <td>8.5</td>\n                                                        <td>(DOE 2019)</td>\n                                                    </tr>\n                                                    <tr>\n                                                        <td>2</td>\n                                                        <td>6.5</td>\n                                                        <td>5</td>\n                                                        <td>(IECC 2012)</td>\n                                                    </tr>\n                                                    <tr>\n                                                        <td>3</td>\n                                                        <td>0.5</td>\n                                                        <td>0.6</td>\n                                                        <td>(Passive House Institute US 2019)                                                        </td>\n                                                    </tr>\n                                                    </tbody>\n                                                </table>\n                                                <hr>\n                                                <p>References</p>\n                                                <p>DOE. 2019. \u201CResidential Prototype Building Models.\u201D 2019.\n                                                     https://www.energycodes.gov/prototype-building-models. </p>\n\n                                                <p>Emmerich, Steven J, Timothy P McDowell, and Wagdy Anis. 2005.\n                                                    \u201CInvestigation of the Impact of Commercial Building Envelope\n                                                    Airtightness on HVAC Energy Use.\u201D Technology 7238: 48.\n                                                    http://www.regie-energie.qc.ca/audiences/3677-08/RepDDRInterv_3677-08/C-3-8_GRAME_Rep-Annex4-vsDDR1-HQD_3677_19nov08.pdf.</p>\n                                                <p>IECC. 2012. \u201C2012 International Energy Conservation Code (IECC).\n                                                    \u201D https://codes.iccsafe.org/content/IECC2012.</p>\n                                                <p> DOE. 2014. Windows and Building Envelope Research and\n                                                    Development: Roadmap for Emerging Technologies. Washington DC:\n                                                    US Department of Energy.</p>\n                                                <p>Passive House Institute US. 2019. \u201CPHIUS+ 2018 Passive Building Standard Certification Guidebook.\n                                                    \u201D https://www.phius.org/PHIUS+2018/PHIUS+ Certification Guidebook v2.0_final.pdf.\n                                                </p>\n\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                                <div ng-switch-default>\n                                <div class="row">\n                                <div class="col-xs-10 text-center">\n                                <h4 style="display: inline-block">Leakage Rates:</h4>&nbsp;&nbsp;\n                                <label\n                                class="control-label" ><select id="leakUnits"\n                                                              name="leakUnits"\n                                                              ng-model="leakageUnit"\n                                                              ng-options=  "leakageUnit.name for leakageUnit in leakageUnits | filter : { name: \'M\' } track by leakageUnit.id "\n                                                              ng-change="changeLeakageUnits(leakageUnit)"></select></label>\n                                <button type="button" ng-click="hideIt3 = !hideIt3"\n                                        class="glyphicon glyphicon-question-sign"\n                                        aria-hidden="true"></button>\n                                    </div>\n                                </div>\n                                                <div class="row" ng-init="hideIt3 = true">\n                                                    <div class="col-xs-10">\n                                                        <div ng-hide="hideIt3">\n                                                            <div class="well bg-info text-muted"  >\n                                                                <h4>Air Leakage Rates</h4>\n                                                                <p>The user has the option to either select one of the default values listed\n                                                                    below or to input their own air leakage rate if they have that information\n                                                                    available or want to evaluate the potential energy savings from an improved\n                                                                    airtightness level.</p>\n                                                                <p>The following table lists the four levels of airtightness that\n                                                                    were assumed in the simulations. These include the slab and\n                                                                    below-grade envelope area in the normalization of the air\n                                                                    leakage rate, which is why they are referred to as 6-sided\n                                                                    envelopes, as well as the assumption that the air leakage is\n                                                                    equally distributed over all exterior surfaces. The 6-sided\n                                                                    value is used in many building codes and standards; however, the\n                                                                    CONTAM and EnergyPlus models assume no air leakage through the\n                                                                    exterior envelope that is not exposed to ambient air. The\n                                                                    baseline value in the table was calculated using the average\n                                                                    leakage rate for commercial buildings reported by Emmerich et al.\n                                                                    (2005) of 9 L/sm<sup>2</sup>(1.77 CFM/ft<sup>2</sup>) at 75 Pa\n                                                                    for a 5-sided envelope. The baseline of 5.4 L/sm<sup>2</sup>\n                                                                    (1.06 CFM/ft<sup>2</sup>) at 75\xA0Pa was obtained by multiplying\n                                                                    the average leakage rate by the 5-sided to 6-sided envelope area\n                                                                    ratio of the standalone retail building prototype. The table\n                                                                    also lists three target levels for improved airtightness at 75\n                                                                    Pa: 2 L/sm<sup>2</sup>(0.39 CFM/ft<sup>2</sup>) is the most\n                                                                    stringent of three options in the 2015 International Energy\n                                                                    Conservation Code (IECC 2015) because it involves a blower door\n                                                                    test while the other two options are based on laboratory tests\n                                                                    per ASTM E2357 and ASTM E2178; 1.25 L/sm<sup>2</sup>(0.25\n                                                                    CFM/ft<sup>2</sup>)\n                                                                    is the airtightness required by the U.S. Army Corps of Engineers\n                                                                    (USACE 2012); and 0.25 L/sm<sup>2</sup> (0.049\n                                                                    CFM/ft<sup>2</sup> is the leakage rate targeted by the DOE\n                                                                    Buildings Envelope Roadmap (<a\n                                                                        href="http://energy.gov/sites/prod/files/2014/02/f8/BTO_windows_and_envelope_report_3.pdf">DOE\n                                                                        2014</a>). Emmerich and Persily (2014) analyzed the NIST\n                                                                    U.S. commercial building air leakage database and found that the\n                                                                    79 buildings categorized as having an air barrier had an average\n                                                                    6-sided leakage of 1.39 L/sm<sup>2</sup>(0.27 CFM/ft<sup>2</sup>)\n                                                                    at 75 Pa, which was 70% below the average leakage of the 290\n                                                                    buildings without an air barrier (i.e., 4.33 L/sm<sup>2</sup> or\n                                                                    0.85 CFM/ft<sup>2</sup>at 75 Pa) and is similar to the second\n                                                                    target level above. Zhivov (2013) reported the average 6-sided\n                                                                    leakage for a set of 285 new and retrofitted military buildings\n                                                                    constructed to the USACE specifications to be 0.9\n                                                                    L/sm<sup>2</sup>(0.18 CFM/ft<sup>2</sup>).</p>\n                                                                <p>The tool will interpolate between the baseline 6-sided air leakage rates (5.4\n                                                                    L/s.m<sup>2</sup> (1.06 CFM/ft<sup>2</sup>) for standalone retail, 6.2 L/s.m<sup>2</sup>\n                                                                    (1.22 CFM/ft<sup>2</sup>) for medium office, 6.7 L/s.m<sup>2</sup> (1.33\n                                                                    CFM/ft<sup>2</sup>) for mid-rise apartment), 7.7 L/s.m<sup>2</sup> (1.5 CFM/ft<sup>2</sup>)\n                                                                    for hospital, 6.4 L/s.m<sup>2</sup> (1.3 CFM/ft<sup>2</sup>) for large hotel,\n                                                                    and 5.5 L/s.m<sup>2</sup> (1.1 CFM/ft<sup>2</sup>) for secondary school\n                                                                    and the tightest level of 0.25\n                                                                    L/s.m<sup>2</sup> (0.049 CFM/ft<sup>2</sup>) at 75\xA0Pa. No extrapolation is\n                                                                    enabled at this time.</p>\n                                                                <hr>\n                                                                <h4 class="text-center">Assumed Building Envelope Airtightness\n                                                                    Levels for a 6-Sided Envelope for Standalone Retail\n                                                                    Building</h4>\n                                                                <table class="table">\n                                                                    <thead>\n                                                                    <tr>\n                                                                        <th>Case</th>\n                                                                        <th>Air Leakage Rate at 75 Pa (L/sm<sup>2</sup>)</th>\n                                                                        <th>Air Leakage Rate at 75 Pa (CFM/ft<sup>2</sup>)</th>\n                                                                        <th>Source</th>\n                                                                    </tr>\n                                                                    </thead>\n                                                                    <tbody>\n                                                                    <tr>\n                                                                        <td>Baseline</td>\n                                                                        <td>5.4</td>\n                                                                        <td>1.06</td>\n                                                                        <td>Emmerich et al. (2005)</td>\n                                                                    </tr>\n                                                                    <tr>\n                                                                        <td>1</td>\n                                                                        <td>2.0</td>\n                                                                        <td>0.39</td>\n                                                                        <td>IECC (2015)</td>\n                                                                    </tr>\n                                                                    <tr>\n                                                                        <td>2</td>\n                                                                        <td>1.25</td>\n                                                                        <td>0.25</td>\n                                                                        <td>USACE (2012)</td>\n                                                                    </tr>\n                                                                    <tr>\n                                                                        <td>3</td>\n                                                                        <td>0.25</td>\n                                                                        <td>0.049</td>\n                                                                        <td>DOE (2014)</td>\n                                                                    </tr>\n                                                                    </tbody>\n                                                                </table>\n                                                                <hr>\n                                                                <p>References</p>\n                                                                <p>Emmerich, S.J., McDowell, T.P., and W. Anis. 2005. Investigation\n                                                                    of the Impact of Commercial Building Envelope Airtightness on\n                                                                    HVAC Energy Use. Gaithersburg, MD: National Institute of\n                                                                    Standards and Technology. NISTIR 7238. </p>\n                                                                <p>Emmerich, S.J. and A.K. Persily. 2014. Analysis of U.S Commercial\n                                                                    Building Envelope Air Leakage Database to Support Sustainable\n                                                                    Building Design. The International Journal of Ventilation, Vol\n                                                                    12, March 2014</p>\n                                                                <p>IECC. 2015. International Energy Conservation Code. Illinois:\n                                                                    International Code Council. USACE. 2012. Air Leakage Test\n                                                                    Protocol for Building Envelopes. US Army Corps of Engineers.</p>\n                                                                <p> DOE. 2014. Windows and Building Envelope Research and\n                                                                    Development: Roadmap for Emerging Technologies. Washington DC:\n                                                                    US Department of Energy.</p>\n                                                                <p><a\n                                                                    href="http://energy.gov/sites/prod/files/2014/02/f8/BTO_windows_and_envelope_report_3.pdf">http://energy.gov/sites/prod/files/2014/02/f8/BTO_windows_and_envelope_report_3.pdf. </a>\n                                                                </p>\n                                                                <p>Zhivov, A., Herron, D., Durston, J.L., Heron, M., and Lea G.\n                                                                    2013. Air Tightness in New and Retrofitted US Army Buildings.\n                                                                    AIVC Workshop.</p>\n                                                            </div>\n                                                        </div>\n                                        </div>\n                                         </div>\n                            </div>\n                        </div>\n                        <div>\n                            <div class="form-group row">\n                                <label class="control-label col-xs-2">Base case:</label>\n                                <div class="col-xs-3">\n                                    <input id="basecaseLeakage" type="number"\n                                           class="form-control" ng-model="basecaseLeakage"\n                                           ng-value="basecaseLeakage">\n                                </div>\n                                <label class="control-label col-xs-3">Retrofitted building:</label>\n                                <div class="col-xs-3">\n                                    <input id="retrofitLeakage" type="number" class="form-control"\n                                           ng-model="retrofitLeakage" ng-value="retrofitLeakage">\n                                </div>\n\n                            </div>\n                        </div>\n\n                        <hr>\n                        <div class="row">\n                            <div class="col-xs-10 text-center">\n                                <h4 style="display: inline-block">Energy Costs:</h4>&nbsp;&nbsp;<button\n                                type="button" ng-init="hideIt4 = true" ng-click="hideIt4 = !hideIt4"\n                                class="glyphicon glyphicon-question-sign"\n                                aria-hidden="true"></button>\n\n                            </div>\n                        </div>\n                        <div class="form-group row">\n                            <div ng-switch on="marker.country_abbrev">\n                                <label ng-switch-when="USA" class="control-label col-xs-2">Electricity:\n                                    ($/kWh)</label>\n                                <label ng-switch-when="CAN" class="control-label col-xs-2">Electricity:\n                                    (C$/kWh)</label>\n                                <label ng-switch-when="CHN" class="control-label col-xs-2">Electricity:\n                                    (\xA5/kWh)</label>\n                            </div>\n                            <div class="col-xs-3">\n                                <input id="electricCost" type="text" class="form-control"\n                                       ng-model="costElectricity">\n                            </div>\n                            <div ng-switch on="marker.country_abbrev">\n                                <label class="control-label col-xs-3">Natural Gas: <span\n                                    ng-switch-when="USA">$</span><span ng-switch-when="CAN">C$</span><span\n                                    ng-switch-when="CHN">\xA5</span>/<select ng-model="gasCostUnits"\n                                                                          ng-options="gasCostUnits.name for gasCostUnits in gasCostUnitss track by gasCostUnits.id"\n                                                                          ng-change="changeGasCostUnits(gasCostUnits)"></select>\n                                </label>\n                            </div>\n                            <div class="col-xs-3">\n                                <input id="costGasid" type="text" class="form-control" ng-model="costGas">\n                            </div>\n                        </div>\n                        <div ng-hide="hideIt4" class="row">\n                            <div class="col-xs-10 well bg-info text-muted">\n                                <h4>Energy Costs</h4>\n                                <p>The user has the option to either select the default value for energy\n                                    prices from the following references or to input their own\n                                    electricity and natural gas prices.</p>\n                                <p>Electricity and natural gas prices were collected from numerous sources. Prices for\n                                    electricity for US cities are maintained by the U.S. Energy Information\n                                    Administration and 2016 year-to-date average prices for commercial customers were\n                                    used in the calculations (<a\n                                        href="http://www.eia.gov/electricity/sales_revenue_price/">EIA,\n                                        2016a</a>). For natural gas, average 2015 prices for commercial\n                                    customers were obtained (<a\n                                        href="http://www.eia.gov/dnav/ng/ng_sum_lsum_a_EPG0_PCS_DMcf_a.htm">EIA,\n                                        2016b</a>). Energy prices for Canada were taken from the rates\n                                    used to develop the National Energy Code of Canada for Buildings\n                                    2011(<a\n                                        href="http://www.nrc-cnrc.gc.ca/eng/publications/codes_centre/2011_national_energy_code_buildings.html">NECB\n                                        2011</a>). 2015 electricity costs for China were obtained from\n                                    <a href="http://news.asean168.com/a/20150413/5318.html">here</a> and\n                                    Chinese 2016 natural gas prices were obtained from <a\n                                        href="http://gas.gold600.com/">this website</a>. The calculator\n                                    does not account for demand charges. </p>\n                            </div>\n                        </div>\n\n\n                        <div class="form-submit-section">\n                            <div class="col-xs-10 text-center">\n                                <button type="button" id="submit" ng-click="submit()"\n                                        ui-sref="infiltrationcalculation"\n                                        class="btn btn-primary">Calculate >>\n                                </button>&nbsp;&nbsp;\n                                <button type="button" ng-init="hideIt5 = true" ng-click="hideIt5 = !hideIt5"\n                                        class="glyphicon glyphicon-question-sign"\n                                        aria-hidden="true"></button>\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n                    <div ng-hide="hideIt5" class="row">\n                        <div class="col-xs-10 well bg-info text-muted">\n                            <h4>Calculator</h4>\n                            <p>The following figure describes the general steps to calculate the energy and monetary\n                                savings associated with improved airtightness. The tool uses a database of EnergyPlus\n                                pre-run simulation results for the DOE commercial prototype buildings. The main\n                                difference between this online calculator and the procedure followed in the DOE\n                                prototypes is that the calculator utilizes CONTAM-calculated hourly air changes per hour\n                                (ACH) or infiltration rates as inputs while the prototypes make simplified assumptions.\n                                CONTAM (Dols and Polidoro 2015) is a multizone airflow and contaminant transport\n                                analysis software developed at NIST and validated by multiple studies, such as Haghighat\n                                and Megri (1996), Chung (1996), Emmerich (2001), and Emmerich et al. (2004). This\n                                software takes into account multiple variables, such as weather conditions, envelope\n                                airtightness and HVAC system operation, to calculate infiltration rates through the\n                                building enclosure. The CONTAM-calculated hourly infiltration rates were imported into\n                                DOE\u2019s whole-building energy simulation software EnergyPlus (DOEa 2016) with the CONTAM\n                                Results Export Tool (Polidoro et al. 2016). EnergyPlus was then used to calculate the\n                                effect of infiltration on energy consumption. </p>\n                            <hr>\n                            <figure class="text-center">\n                                <div class="calculation img-responsive"/>\n                                <figcaption>General procedure to estimate potential energy costs for different levels of\n                                    envelope airtightness in DOE commercial prototype buildings.\n                                </figcaption>\n                            </figure>\n                            <hr>\n                            <p>References:</p>\n\n                            <p>Dols, W.S. and B. Polidoro. 2015. CONTAM User Guide and Program Documentation.\n                                Gaithersburg, MD: National Institute of Standards and Technology. Technical Note\n                                1887.</p>\n                            <p>Haghighat, F., and A.C. Megri. 1996. A Comprehensive Validation of Two Airflow Models \u2013\n                                COMIS and CONTAM. <i>Indoor Air</i> 6:278-288.</p>\n                            <p>Chung, K.C. 1996. Development and Validation of a Multizone Model for Overall Indoor Air\n                                Environment Prediction. <i>HVAC&R Res</i> 2:376-385.</p>\n                            <p>Emmerich, S.J. 2001. Validation of Multizone IAQ Modeling of Residential-Scale Buildings:\n                                A Review. <i>ASHRAE Transactions 107</i>.<br></p>\n                            <p>Emmerich, S.J., Nabinger, S.J., Gupte, A., and C. Howard-Reed. 2004. Validation of\n                                Multizone IAQ Model Predictions for Tracer Gas in a Townhouse. <i>Building Services\n                                    Engineering Research and Technology</i> 25:305-316.<br></p>\n                            <p>DOEa. EnergyPlus. Retrieved February 2016 from <a href="https://energyplus.net">https://energyplus.net</a>.<br>\n                            </p>\n                            <p>Polidoro, B., Ng, L.C., and W.S. Dols. 2016. CONTAM Results Export Tool. Gaithersburg,\n                                MD: National Institute of Standards and Technology. Technical Note 1912.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<!-- Google Analytics: uncomment and change UA-XXXXX-X to be your site\'s ID. -->\n<script>\n    (function (b, o, i, l, e, r) {\n        b.GoogleAnalyticsObject = l;\n        b[l] || (b[l] =\n            function () {\n                (b[l].q = b[l].q || []).push(arguments)\n            });\n        b[l].l = +new Date;\n        e = o.createElement(i);\n        r = o.getElementsByTagName(i)[0];\n        e.src = \'//www.google-analytics.com/analytics.js\';\n        r.parentNode.insertBefore(e, r)\n    }(window, document, \'script\', \'ga\'));\n    ga(\'create\', \'UA-89971121-1\');\n    ga(\'send\', \'pageview\');\n</script>\n');
$templateCache.put('app/infiltration/infiltrationcalculation.html','<div ng-cloak>\n\n\n    <div class="row">\n        <div class="col-12 text-left"><h1>Infiltration Calculator Results</h1></div>\n    </div>\n    <div class="row">\n        <div class="col-md-7">\n            <table class="table table-bordered table-responsive">\n                <tbody>\n                    <tr>\n                        <th class="success">Building Type</th>\n                        <td>{{ infiltrationEntry.buildingType.longName }}</td>\n                    </tr>\n                    <tr>\n                        <th class="success">Location</th>\n                        <td>{{ locationString }}</td>\n                    </tr>\n                    <tr>\n                        <th class="success">Floor Area</th>\n                        <td>{{ infiltrationEntry.area }} {{ areaUnitDisplayValue}}</td>\n                    </tr>\n                    <tr>\n                        <th class="success">Energy Price</th>\n                        <td>Electricity {{infiltrationEntry.costElectricity | number: 2 }}{{currencyDisplayValue}}/kWh, Natural Gas {{ infiltrationEntry.costGas  | number: 2 }}{{currencyDisplayValue}}/{{gasCostUnitsDisplayValue}}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class="col-md-4">\n            <div ng-switch on="infiltrationEntry.buildingType.shortName">\n                <div ng-switch-when="standalone_retail">\n                    <span class="center-block standalone_retail img-responsive"/>\n                </div>\n                <div ng-switch-when="midrise_apt">\n                    <span class="center-block midrise_apt img-responsive"/>\n                </div>\n                <div ng-switch-when="office_medium">\n                    <span class="center-block office_medium img-responsive"/>\n                </div>\n                <div ng-switch-when="hirise_apt">\n                    <span class="center-block hirise_apt img-responsive"/>\n                </div>\n                <div ng-switch-when="hospital">\n                    <span class="center-block hospital img-responsive"/>\n                </div>\n                <div ng-switch-when="hotel_large">\n                    <span class="center-block hotel_large img-responsive"/>\n                </div>\n                <div ng-switch-when="school_secondary">\n                    <span class="center-block school_secondary img-responsive"/>\n                </div>\n                <div ng-switch-when="strip_mall">\n                    <span class="center-block strip_mall img-responsive"/>\n                </div>\n                <div ng-switch-when="primary_school">\n                    <span class="center-block primary_school img-responsive"/>\n                </div>\n                <div ng-switch-when="residential">\n                    <span class="center-block residential img-responsive"/>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-12">\n            <table class="table table-bordered table-responsive">\n                <thead>\n                    <tr>\n                        <th class="success text-center" colspan="2">Leakage Rate</th>\n                        <th class="success text-center" colspan="2">Equivalent Leakage Area</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr>\n                        <th class="success text-center">Base Case</th>\n                        <th class="success text-center">Retrofitted Building</th>\n                        <th class="success text-center">Base Case</th>\n                        <th class="success text-center">Retrofitted Building</th>\n                    </tr>\n                    <tr>\n                        <td class="text-center">{{infiltrationEntry.basecaseLeakage  | number: 2 }} {{leakageUnitDisplayValue}} at {{infiltrationEntry.buildingType.shortName === \'residential\' ? 50 : 75 }} Pa</td>\n                        <td class="text-center">{{infiltrationEntry.retrofittedLeakage  | number: 2 }} {{leakageUnitDisplayValue}} at {{infiltrationEntry.buildingType.shortName === \'residential\' ? 50 : 75 }} Pa</td>\n                        <td class="text-center">{{ baseELA | number: 2 }} {{ elaUnitsDisplayValue }}</td>\n                        <td class="text-center">{{ retroELA | number: 2 }} {{ elaUnitsDisplayValue }}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n\n\n    <div class="row">\n        <div class="col-md-8">\n            <table class="table table-responsive table-bordered top-margin-10">\n                <thead>\n                    <tr>\n                        <th class="text-center info">Predicted Annual Savings</th>\n                        <th class="text-center info">Electricity</th>\n                        <th class="text-center info">Natural Gas</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr>\n                        <th class="text-center info">Energy</th>\n                        <td class="text-center">{{electricSavingsDisplayValue | number: 0}} kWh</td>\n                        <td class="text-center">{{gasSavingsDisplayValue | number: 0}} {{gasSavingsUnitsDisplayValue}}</td>\n                    </tr>\n                    <tr>\n                        <th class="text-center info">Cost</th>\n                        <td class="text-center">{{currencyDisplayValue}}{{electricCostSavingsDisplayValue | number: 2}}</td>\n                        <td class="text-center">{{currencyDisplayValue}}{{gasCostSavingsDisplayValue | number: 2}}</td>\n                    </tr>\n                    <tr>\n                        <th class="text-center info">Total Cost Savings</th>\n                        <td class="text-center" colspan="2">{{currencyDisplayValue}}{{totalCostSavingsDisplayValue | number: 2}}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class="col-md-4">\n            <canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-options="options" chart-colors="colors">\n            </canvas>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-md-8">\n            <table class="table table-responsive table-bordered top-margin-10">\n                <thead>\n                    <tr>\n                        <th colspan="3" class="text-center warning">Moisture Transfer through the Wall Assembly due to Air Leakage</th>\n                    </tr>\n                    <tr>\n                        <th class="text-center warning">Description</th>\n                        <th class="text-center warning">Base Case</th>\n                        <th class="text-center warning">Retrofitted Building</th>\n\n\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr>\n                        <td class="text-center warning">Total Moisture transfer</td>\n                        <td class="text-center">{{ basecaseGallonsPerYear | number: 0 }} {{moistureTransferTotalDisplay}}</td>\n                        <td class="text-center">{{ retrofittedGallonsPerYear | number: 0 }} {{moistureTransferTotalDisplay}}</td>\n\n                    </tr>\n\n                    <tr>\n                        <td class="text-center warning">Moisture transfer per envelope area</td>\n                        <td class="text-center">{{ basecaseMoistureTransfer | number: 2 }} {{ mtUnitsDisplayValue }}</td>\n                        <td class="text-center">{{ retrofittedMoistureTransfer | number: 2 }} {{ mtUnitsDisplayValue }}</td>\n                    </tr>\n<!--                    <tr>-->\n<!--                        <td class="text-center warning">Moisture transfer per effective leakage area (ELA)</td>-->\n<!--                        <td class="text-center">{{ basecaseperELA | number: 2 }} {{ moistureELADisplayValue }}</td>-->\n<!--                        <td class="text-center">{{ retrofittedPerELA | number: 2 }} {{ moistureELADisplayValue }}</td>-->\n\n<!--                    </tr>-->\n\n\n                </tbody>\n            </table>\n        </div>\n        <div class="col-md-4">\n            <canvas id="barm" class="chart chart-bar" chart-data="mtdata" chart-labels="mtlabels" chart-options="mtoptions" chart-colors="mtcolors">\n            </canvas>\n        </div>\n    </div>\n\n    <!--<div class="row">-->\n        <!--&lt;!&ndash;<div class="col-md-1">&ndash;&gt;-->\n            <!--&lt;!&ndash;<span class="user-results img-responsive"/>&ndash;&gt;-->\n        <!--&lt;!&ndash;</div>&ndash;&gt;-->\n        <!--<div class="col-md-12">-->\n            <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n                <!--&lt;!&ndash;<div class="col-md-8">&ndash;&gt;-->\n                    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-4 btn-success btn">Predicted Savings</div>&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-4 btn-success btn">Electricity</div>&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-4 btn-success btn">Natural Gas</div>&ndash;&gt;-->\n                    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n                    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-4 btn-success btn">Energy</div>&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-4 btn-default btn">{{electricSavingsDisplayValue | number: 0}} kWh</div>&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-4 btn-default btn">{{gasSavingsDisplayValue | number: 0}} {{gasSavingsUnitsDisplayValue}}</div>&ndash;&gt;-->\n                    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n                    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-4 btn-success btn">Cost</div>&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-4 btn-default btn">{{currencyDisplayValue}}{{electricCostSavingsDisplayValue | number: 2}}</div>&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-4 btn-default btn">{{currencyDisplayValue}}{{gasCostSavingsDisplayValue | number: 2}}</div>&ndash;&gt;-->\n                    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n                    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-4 btn-success btn">Total Cost Savings</div>&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-8 btn-default btn">{{currencyDisplayValue}}{{totalCostSavingsDisplayValue | number: 2}}</div>&ndash;&gt;-->\n                    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n                <!--&lt;!&ndash;</div>&ndash;&gt;-->\n                <!--&lt;!&ndash;<div class="col-md-4">&ndash;&gt;-->\n                    <!--&lt;!&ndash;<canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-options="options">&ndash;&gt;-->\n                    <!--&lt;!&ndash;</canvas>&ndash;&gt;-->\n                <!--&lt;!&ndash;</div>&ndash;&gt;-->\n            <!--&lt;!&ndash;</div>&ndash;&gt;-->\n            <!--<div class="row">-->\n                <!--<div class="col-md-8">-->\n                    <!--<div class="row">-->\n                        <!--<div class="col-md-12 btn-success btn">Moisture Transfer into the Space Due to the Air Leakage</div>-->\n                    <!--</div>-->\n                    <!--<div class="row">-->\n                        <!--<div class="col-md-6 btn-success btn">Base Case</div>-->\n                        <!--<div class="col-md-6 btn-success btn">Retrofitted Building</div>-->\n                    <!--</div>-->\n                    <!--<div class="row">-->\n                        <!--<div class="col-md-6 btn-default btn">{{ basecaseMoistureTransfer | number: 2 }} {{ mtUnitsDisplayValue }}</div>-->\n                        <!--<div class="col-md-6 btn-default btn">{{ retrofittedMoistureTransfer | number: 2 }} {{ mtUnitsDisplayValue }}</div>-->\n                    <!--</div>-->\n                <!--</div>-->\n                <!--<div class="col-md-4">-->\n                    <!--<canvas id="barm" class="chart chart-bar" chart-data="mtdata" chart-labels="mtlabels" chart-options="mtoptions" chart-colors="colors">-->\n                    <!--</canvas>-->\n                <!--</div>-->\n            <!--</div>-->\n\n\n        <!--</div>-->\n    <!--</div>-->\n\n    <!--<div class="row">-->\n        <!--<div class="col-md-12">-->\n            <!--<div>-->\n                <!--<h1>Predicted Savings</h1>-->\n                <!--<jh-alert></jh-alert>-->\n                <!--<div class="container">-->\n                    <!--<div class="row">-->\n                        <!--<div class="col-md-11">-->\n                            <!--<table class="table">-->\n                                <!--<thead>-->\n                                <!--<tr>-->\n                                    <!--<th colspan="2" class="text-center">Energy</th><th colspan="3" class="text-center">Cost</th>-->\n                                <!--</tr>-->\n                                <!--<tr><th>Electricity</th><th>Natural Gas</th><th>Electricity</th><th>Natural Gas</th><th>Total</th></tr>-->\n                                <!--</thead>-->\n                                <!--<tbody>-->\n                                    <!--<tr>-->\n                                        <!--<td>{{electricSavingsDisplayValue | number: 0}} kWh</td>-->\n                                        <!--<td>{{gasSavingsDisplayValue | number: 0}} {{gasSavingsUnitsDisplayValue}}</td>-->\n                                        <!--<td>{{currencyDisplayValue}}{{electricCostSavingsDisplayValue | number: 2}}</td>-->\n                                        <!--<td>{{currencyDisplayValue}}{{gasCostSavingsDisplayValue | number: 2}}</td>-->\n                                        <!--<td>{{currencyDisplayValue}}{{totalCostSavingsDisplayValue | number: 2}}</td>-->\n                                    <!--</tr>-->\n                                <!--</tbody>-->\n                            <!--</table>-->\n                        <!--</div>-->\n                    <!--</div>-->\n                    <!--<div class="row">-->\n                        <!--<div class="col-md-10">-->\n                            <!--<canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-options="options">-->\n                            <!--</canvas>-->\n                        <!--</div>-->\n                        <!--&lt;!&ndash;<div class="col-md-3">&ndash;&gt;-->\n                            <!--&lt;!&ndash;<canvas id="electricitybar" class="chart chart-bar" chart-data="electricitydata" chart-labels="electricitylabels" chart-options="options">&ndash;&gt;-->\n                            <!--&lt;!&ndash;</canvas>&ndash;&gt;-->\n                        <!--&lt;!&ndash;</div>&ndash;&gt;-->\n                        <!--&lt;!&ndash;<div class="col-md-3">&ndash;&gt;-->\n                            <!--&lt;!&ndash;<canvas id="gasbar" class="chart chart-bar" chart-data="gasdata" chart-labels="gaslabels" chart-options="options">&ndash;&gt;-->\n                            <!--&lt;!&ndash;</canvas>&ndash;&gt;-->\n                        <!--&lt;!&ndash;</div>&ndash;&gt;-->\n\n                    <!--</div>-->\n                <!--</div>-->\n            <!--</div>-->\n        <!--</div>-->\n    <!--</div>-->\n\n    <!--<div class="row">-->\n    <!--<div class="col-md-12">-->\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-2">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-12 text-center"><h1>Infiltration</h1></div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-12 alert alert-success state-warning-text">Building Type</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-12 btn btn-primary">Location</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-12 btn btn-primary">Floor Area</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-12 btn btn-primary">Energy Price</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-5">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-12 text-left"><h1>Calculator</h1></div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-12 btn btn-default">{{ infiltrationEntry.buildingType.longName }}</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-12 btn btn-default">{{ locationString }}</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-12 btn btn-default">{{ infiltrationEntry.area }} {{ areaUnitDisplayValue}}</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-12 btn btn-default">Electricity {{infiltrationEntry.costElectricity | number: 2 }}{{currencyDisplayValue}}/kWh, Natural Gas {{ infiltrationEntry.costGas  | number: 2 }}{{currencyDisplayValue}}/{{gasCostUnitsDisplayValue}}</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div class="col-md-4">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div ng-switch on="infiltrationEntry.buildingType.shortName">&ndash;&gt;-->\n    <!--&lt;!&ndash;<div ng-switch-when="standalone_retail">&ndash;&gt;-->\n    <!--&lt;!&ndash;<span class="center-block standalone_retail img-responsive"/>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div ng-switch-when="midrise_apt">&ndash;&gt;-->\n    <!--&lt;!&ndash;<span class="center-block midrise_apt img-responsive"/>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div ng-switch-when="office_medium">&ndash;&gt;-->\n    <!--&lt;!&ndash;<span class="center-block office_medium img-responsive"/>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div ng-switch-when="hirise_apt">&ndash;&gt;-->\n    <!--&lt;!&ndash;<span class="center-block hirise_apt img-responsive"/>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div ng-switch-when="hospital">&ndash;&gt;-->\n    <!--&lt;!&ndash;<span class="center-block hospital img-responsive"/>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div ng-switch-when="hotel_large">&ndash;&gt;-->\n    <!--&lt;!&ndash;<span class="center-block hotel_large img-responsive"/>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;<div ng-switch-when="school_secondary">&ndash;&gt;-->\n    <!--&lt;!&ndash;<span class="center-block school_secondary img-responsive"/>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--&lt;!&ndash;</div>&ndash;&gt;-->\n    <!--<div class="row">-->\n    <!--<div class="col-md-8 btn btn-primary">Leakage Rate</div>-->\n    <!--<div class="col-md-4 btn btn-primary">Equivalent Leakage Area</div>-->\n    <!--</div>-->\n    <!--<div class="row">-->\n    <!--<div class="col-md-8">-->\n    <!--<div class="row">-->\n    <!--<div class="col-md-6 btn btn-default">Base Case</div>-->\n    <!--<div class="col-md-6 btn btn-default">Retrofitted Building</div>-->\n    <!--</div>-->\n    <!--<div class="row">-->\n    <!--<div class="col-md-6 btn btn-default">{{infiltrationEntry.basecaseLeakage  | number: 2 }} {{leakageUnitDisplayValue}} at 75 Pa</div>-->\n    <!--<div class="col-md-6 btn btn-default">{{infiltrationEntry.retrofittedLeakage  | number: 2 }} {{leakageUnitDisplayValue}} at 75 Pa</div>-->\n    <!--</div>-->\n    <!--</div>-->\n    <!--<div class="col-md-4">-->\n    <!--<div class="row">-->\n    <!--<div class="col-md-6 btn btn-default">Base Case</div>-->\n    <!--<div class="col-md-6 btn btn-default">Retrofitted Building</div>-->\n    <!--</div>-->\n    <!--<div class="row">-->\n    <!--<div class="col-md-6 btn btn-default">{{ baseELA | number: 2 }} {{ elaUnitsDisplayValue }}</div>-->\n    <!--<div class="col-md-6 btn btn-default">{{ retroELA | number: 2 }} {{ elaUnitsDisplayValue }}</div>-->\n    <!--</div>-->\n    <!--</div>-->\n    <!--</div>-->\n    <!--</div>-->\n\n    <!--</div>-->\n    <!--<hr/>-->\n\n</div>\n<!-- Google Analytics: uncomment and change UA-XXXXX-X to be your site\'s ID. -->\n<script>\n    (function(b,o,i,l,e,r){b.GoogleAnalyticsObject=l;b[l]||(b[l]=\n        function(){(b[l].q=b[l].q||[]).push(arguments)});b[l].l=+new Date;\n        e=o.createElement(i);r=o.getElementsByTagName(i)[0];\n        e.src=\'//www.google-analytics.com/analytics.js\';\n        r.parentNode.insertBefore(e,r)}(window,document,\'script\',\'ga\'));\n    ga(\'create\',\'UA-89971121-1\');ga(\'send\',\'pageview\');\n</script>\n');
$templateCache.put('app/account/activate/activate.html','<div>\n    <div class="row">\n        <div class="col-md-8 col-md-offset-2">\n            <h1>Activation</h1>\n\n            <div class="alert alert-success" ng-show="vm.success">\n                <strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.error">\n                <strong>Your user could not be activated.</strong> Please use the registration form to sign up.\n            </div>\n\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/account/password/password.html','<div>\n    <div class="row">\n        <div class="col-md-8 col-md-offset-2">\n            <h2>Password for [<b>{{vm.account.login}}</b>]</h2>\n\n            <div class="alert alert-success" ng-show="vm.success">\n                <strong>Password changed!</strong>\n            </div>\n            <div class="alert alert-danger" ng-show="vm.error" >\n                <strong>An error has occurred!</strong> The password could not be changed.\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.doNotMatch">\n                The password and its confirmation do not match!\n            </div>\n\n            <form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation>\n\n                <div class="form-group">\n                    <label class="control-label" for="password">New password</label>\n                    <input type="password" class="form-control" id="password" name="password" placeholder="New password"\n                           ng-model="vm.password" ng-minlength=4 ng-maxlength=50 required>\n                    <div ng-show="form.password.$dirty && form.password.$invalid">\n                        <p class="help-block"\n                           ng-show="form.password.$error.required">\n                            Your password is required.\n                        </p>\n                        <p class="help-block"\n                           ng-show="form.password.$error.minlength">\n                            Your password is required to be at least 4 characters.\n                        </p>\n                        <p class="help-block"\n                           ng-show="form.password.$error.maxlength">\n                            Your password cannot be longer than 50 characters.\n                        </p>\n                    </div>\n                    <password-strength-bar password-to-check="vm.password"></password-strength-bar>\n                </div>\n                <div class="form-group">\n                    <label class="control-label" for="confirmPassword">New password confirmation</label>\n                    <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password"\n                           ng-model="vm.confirmPassword" ng-minlength=4 ng-maxlength=50 required>\n                    <div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid">\n                        <p class="help-block"\n                           ng-show="form.confirmPassword.$error.required">\n                            Your confirmation password is required.\n                        </p>\n                        <p class="help-block"\n                           ng-show="form.confirmPassword.$error.minlength">\n                            Your confirmation password is required to be at least 4 characters.\n                        </p>\n                        <p class="help-block"\n                           ng-show="form.confirmPassword.$error.maxlength">\n                            Your confirmation password cannot be longer than 50 characters.\n                        </p>\n                    </div>\n                </div>\n\n                <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button>\n            </form>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/account/settings/settings.html','<div>\n    <div class="row">\n        <div class="col-md-8 col-md-offset-2">\n            <h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2>\n\n            <div class="alert alert-success" ng-show="vm.success">\n                <strong>Settings saved!</strong>\n            </div>\n\n           <jhi-alert-error></jhi-alert-error>\n\n            <form name="form" role="form" novalidate ng-submit="vm.save()" show-validation>\n\n                <div class="form-group">\n                    <label class="control-label" for="firstName">First Name</label>\n                    <input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name"\n                           ng-model="vm.settingsAccount.firstName" ng-minlength=1 ng-maxlength=50 required maxlength="50">\n                    <div ng-show="form.firstName.$dirty && form.firstName.$invalid">\n                        <p class="help-block"\n                               ng-show="form.firstName.$error.required">\n                            Your first name is required.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.firstName.$error.minlength">\n                            Your first name is required to be at least 1 character.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.firstName.$error.maxlength">\n                            Your first name cannot be longer than 50 characters.\n                        </p>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="control-label" for="lastName">Last Name</label>\n                    <input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name"\n                           ng-model="vm.settingsAccount.lastName" ng-minlength=1 ng-maxlength=50 required maxlength="50">\n                    <div ng-show="form.lastName.$dirty && form.lastName.$invalid">\n                        <p class="help-block"\n                               ng-show="form.lastName.$error.required">\n                            Your last name is required.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.lastName.$error.minlength">\n                            Your last name is required to be at least 1 character.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.lastName.$error.maxlength">\n                            Your last name cannot be longer than 50 characters.\n                        </p>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="control-label" for="email">E-mail</label>\n                    <input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail"\n                           ng-model="vm.settingsAccount.email" ng-minlength=5 ng-maxlength=100 required maxlength="100">\n                    <div ng-show="form.email.$dirty && form.email.$invalid">\n                        <p class="help-block"\n                               ng-show="form.email.$error.required">\n                            Your e-mail is required.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.email.$error.email">\n                            Your e-mail is invalid.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.email.$error.minlength">\n                            Your e-mail is required to be at least 5 characters.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.email.$error.maxlength">\n                            Your e-mail cannot be longer than 100 characters.\n                        </p>\n                    </div>\n                </div>\n\n                <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button>\n            </form>\n        </div>\n    </div>\n\n</div>\n');
$templateCache.put('app/account/register/register.html','<div>\n    <div class="row">\n        <div class="col-md-8 col-md-offset-2">\n            <h1>Registration</h1>\n\n            <div class="alert alert-success" ng-show="vm.success">\n                <strong>Registration saved!</strong> Please check your email for confirmation.\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.error">\n                <strong>Registration failed!</strong> Please try again later.\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.errorUserExists">\n                <strong>Login name already registered!</strong> Please choose another one.\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.errorEmailExists">\n                <strong>E-mail is already in use!</strong> Please choose another one.\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.doNotMatch">\n                The password and its confirmation do not match!\n            </div>\n        </div>\n        <div class="col-md-8 col-md-offset-2">\n            <form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation>\n\n                <div class="form-group">\n                    <label class="control-label" for="login">Username</label>\n                    <input type="text" class="form-control" id="login" name="login" placeholder="Your username"\n                           ng-model="vm.registerAccount.login" ng-minlength=1 ng-maxlength=50 ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required>\n                    <div ng-show="form.login.$dirty && form.login.$invalid">\n                        <p class="help-block"\n                               ng-show="form.login.$error.required">\n                            Your username is required.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.login.$error.minlength">\n                            Your username is required to be at least 1 character.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.login.$error.maxlength">\n                            Your username cannot be longer than 50 characters.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.login.$error.pattern">\n                            Your username can only contain lower-case letters and digits.\n                    </p>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="control-label" for="email">E-mail</label>\n                    <input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail"\n                           ng-model="vm.registerAccount.email" ng-minlength=5 ng-maxlength=100 required>\n                    <div ng-show="form.email.$dirty && form.email.$invalid">\n                        <p class="help-block"\n                               ng-show="form.email.$error.required">\n                            Your e-mail is required.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.email.$error.email">\n                            Your e-mail is invalid.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.email.$error.minlength">\n                            Your e-mail is required to be at least 5 characters.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.email.$error.maxlength">\n                            Your e-mail cannot be longer than 100 characters.\n                        </p>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="control-label" for="password">New password</label>\n                    <input type="password" class="form-control" id="password" name="password" placeholder="New password"\n                           ng-model="vm.registerAccount.password" ng-minlength=4 ng-maxlength=50 required>\n                    <div ng-show="form.password.$dirty && form.password.$invalid">\n                        <p class="help-block"\n                               ng-show="form.password.$error.required">\n                            Your password is required.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.password.$error.minlength">\n                            Your password is required to be at least 4 characters.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.password.$error.maxlength">\n                            Your password cannot be longer than 50 characters.\n                        </p>\n                    </div>\n                    <password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar>\n                </div>\n                <div class="form-group">\n                    <label class="control-label" for="confirmPassword">New password confirmation</label>\n                    <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password"\n                           ng-model="vm.confirmPassword" ng-minlength=4 ng-maxlength=50 required>\n                    <div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid">\n                        <p class="help-block"\n                               ng-show="form.confirmPassword.$error.required">\n                            Your confirmation password is required.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.confirmPassword.$error.minlength">\n                            Your confirmation password is required to be at least 4 characters.\n                        </p>\n                        <p class="help-block"\n                               ng-show="form.confirmPassword.$error.maxlength">\n                            Your confirmation password cannot be longer than 50 characters.\n                        </p>\n                    </div>\n                </div>\n\n                <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Register</button>\n            </form>\n            <!-- <div class="alert alert-warning">\n                If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default account:<br/>- User (login="user" and password="user").\n            </div> -->\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/login/login.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n            ng-click="vm.cancel()">&times;</button>\n    <h4 class="modal-title">Sign in</h4>\n</div>\n<div class="modal-body">\n    <div class="row">\n        <div class="col-md-4 col-md-offset-4">\n            <h1>Sign in</h1>\n        </div>\n        <div class="col-md-8 col-md-offset-2">\n            <div class="alert alert-danger" ng-show="vm.authenticationError">\n                <strong>Failed to sign in!</strong> Please check your credentials and try again.\n            </div>\n        </div>\n        <div class="col-md-8 col-md-offset-2">\n            <form class="form" role="form" ng-submit="vm.login($event)">\n                <div class="form-group">\n                    <label for="username">Login</label>\n                    <input type="text" class="form-control" id="username" placeholder="Your username" ng-model="vm.username">\n                </div>\n                <div class="form-group">\n                    <label for="password">Password</label>\n                    <input type="password" class="form-control" id="password" placeholder="Your password"\n                           ng-model="vm.password">\n                </div>\n                <div class="form-group">\n                    <label for="rememberMe">\n                        <input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked>\n                        <span>Remember me</span>\n                    </label>\n                </div>\n                <button type="submit" class="btn btn-primary">Sign in</button>\n            </form>\n            <p></p>\n            <div class="alert alert-warning">\n                <a class="alert-link" href="" ng-click="vm.requestResetPassword()">Did you forget your password?</a>\n            </div>\n            <div class="alert alert-warning">\n                You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0"\n        width="100%" height="900" scrolling="auto" target=\'_top\'></iframe>\n');
$templateCache.put('app/admin/audits/audits.html','<div>\n    <h2>Audits</h2>\n\n    <div class="row">\n        <div class="col-md-5">\n            <h4>Filter by date</h4>\n            <p class="input-group">\n                <span class="input-group-addon">from</span>\n                <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required/>\n                <span class="input-group-addon">to</span>\n                <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required/>\n            </p>\n        </div>\n    </div>\n\n\n    <table class="table table-condensed table-striped table-bordered table-responsive">\n        <thead>\n        <tr>\n            <th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th>\n            <th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th>\n            <th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th>\n            <th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th>\n        </tr>\n        </thead>\n\n        <tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered">\n            <td><span>{{audit.timestamp| date:\'medium\'}}</span></td>\n            <td><small>{{audit.principal}}</small></td>\n            <td>{{audit.type}}</td>\n            <td>\n                <span ng-show="audit.data.message">{{audit.data.message}}</span>\n                <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span>\n            </td>\n        </tr>\n    </table>\n\n    <div class="text-center">\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination>\n    </div>\n</div>\n');
$templateCache.put('app/admin/configuration/configuration.html','<div>\n    <h2>Configuration</h2>\n\n    <span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control">\n    <label ng-hide="filteredConfig.length == 0">Spring configuration</label>\n    <table class="table table-condensed table-striped table-bordered table-responsive"\n        style="table-layout:fixed" ng-hide="filteredConfig.length == 0">\n        <thead>\n        <tr>\n            <th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th>\n            <th class="col-sm-8">Properties</th>\n        </tr>\n        </thead>\n\n        <tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)">\n            <td><span>{{entry.prefix}}</span></td>\n            <td>\n                <div class="row" ng-repeat="(key, value) in entry.properties">\n                    <div class="col-md-4">{{key}}</div>\n                    <div class="col-md-8">\n                        <span class="pull-right label label-default break">{{value}}</span>\n                    </div>\n                </div>\n            </td>\n        </tr>\n    </table>\n    <div ng-repeat="(key, value) in vm.allConfiguration">\n        <label ng-hide="filtered.length == 0"><span>{{key}}</span></label>\n        <table class="table table-condensed table-striped table-bordered table-responsive"\n               style="table-layout:fixed" ng-hide="filtered.length == 0">\n            <thead>\n            <tr>\n                <th class="col-sm-4">Property</th>\n                <th class="col-sm-8">Value</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="item in filtered = (value | filter:filter)">\n                <td class="break">{{item.key}}</td>\n                <td class="break">\n                    <span class="pull-right label label-default break">{{item.val}}</span>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/admin/health/health.html','<div>\n    <h2>Health Checks</h2>\n\n    <p>\n        <button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span>\n        </button>\n    </p>\n\n    <table id="healthCheck" class="table table-striped">\n        <thead>\n            <tr>\n                <th class="col-md-7">Service Name</th>\n                <th class="col-md-2 text-center">Status</th>\n                <th class="col-md-2 text-center">Details</th>\n\n            </tr>\n        </thead>\n        <tbody>\n            <tr ng-repeat="health in vm.healthData">\n                <td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td>\n                <td class="text-center">\n                    <span class="label" ng-class="vm.getLabelClass(health.status)">\n                        {{ health.status }}\n                    </span>\n                </td>\n                <td class="text-center">\n                    <a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error">\n                        <i class="glyphicon glyphicon-eye-open"></i>\n                    </a>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header">\n    <button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span>\n    </button>\n    <h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span>\n        {{vm.subSystemName(vm.currentHealth.name)}}\n    </h4>\n</div>\n<div class="modal-body pad">\n    <div ng-show="vm.currentHealth.details">\n        <h4>Properties</h4>\n        <table class="table table-striped">\n            <thead>\n                <tr>\n                    <th class="col-md-6 text-left">Name</th>\n                    <th class="col-md-6 text-left">Value</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="(k,v) in vm.currentHealth.details">\n                    <td class="col-md-6 text-left">{{k}}</td>\n                    <td class="col-md-6 text-left">{{v}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div ng-show="vm.currentHealth.error">\n        <h4>Error</h4>\n            <pre>{{vm.currentHealth.error}}</pre>\n    </div>\n</div>\n<div class="modal-footer">\n    <button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button>\n</div>\n');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive">\n    <h2>Logs</h2>\n\n    <p>There are {{ vm.loggers.length }} loggers.</p>\n\n    <span>Filter</span> <input type="text" ng-model="filter" class="form-control">\n\n    <table class="table table-condensed table-striped table-bordered">\n        <thead>\n        <tr title="click to order">\n            <th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th>\n            <th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th>\n        </tr>\n        </thead>\n\n        <tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse">\n            <td><small>{{logger.name | characters:140}}</small></td>\n            <td>\n                <button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button>\n                <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button>\n                <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button>\n                <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button>\n                <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button>\n            </td>\n        </tr>\n    </table>\n</div>\n');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title">Confirm delete operation</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <p>Are you sure you want to delete this User?</p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" class="btn btn-danger">\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div>\n    <h2><span>User</span> "{{vm.user.login}}"</h2>\n    <dl class="dl-horizontal">\n        <dt><span>Login</span></dt>\n        <dd><span>{{vm.user.login}}</span></dd>\n        <dt><span>First Name</span></dt>\n        <dd>{{vm.user.firstName}}</dd>\n        <dt><span>Last Name</span></dt>\n        <dd>{{vm.user.lastName}}</dd>\n        <dt><span>Email</span></dt>\n        <dd>{{vm.user.email}}</dd>\n        <dt><span>Activated</span></dt>\n        <dd>{{vm.user.activated}}</dd>\n        <dt><span>Created By</span></dt>\n        <dd>{{vm.user.createdBy}}</dd>\n        <dt><span>Created Date</span></dt>\n        <dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd>\n        <dt><span>Last Modified By</span></dt>\n        <dd>{{vm.user.lastModifiedBy}}</dd>\n        <dt><span>Last Modified Date</span></dt>\n        <dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd>\n        <dt><span>Profiles</span></dt>\n        <dd>\n            <ul class="list-unstyled">\n                <li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li>\n            </ul>\n        </dd>\n    </dl>\n    <button type="submit"\n            ui-sref="user-management"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\n    </button>\n</div>\n');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myUserLabel">\n            Create or edit a User</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group">\n            <label>ID</label>\n            <input type="text" class="form-control" name="id"\n                   ng-model="vm.user.id" readonly>\n        </div>\n\n        <div class="form-group">\n            <label class="control-label">Login</label>\n            <input type="text" class="form-control" name="login"\n                   ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength=1 ng-maxlength=50 ng-pattern="/^[_\'.@A-Za-z0-9-]*$/">\n\n            <div ng-show="editForm.login.$invalid">\n                <p class="help-block"\n                   ng-show="editForm.login.$error.required">\n                    This field is required.\n                </p>\n\n                <p class="help-block"\n                   ng-show="editForm.login.$error.maxlength"\n                  >\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="control-label">First Name</label>\n            <input type="text" class="form-control" name="firstName"\n                   ng-model="vm.user.firstName" ng-maxlength="50">\n\n            <div ng-show="editForm.firstName.$invalid">\n                <p class="help-block"\n                   ng-show="editForm.firstName.$error.maxlength"\n                  >\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label>Last Name</label>\n            <input type="text" class="form-control" name="lastName"\n                   ng-model="vm.user.lastName" ng-maxlength="50">\n\n            <div ng-show="editForm.lastName.$invalid">\n                <p class="help-block"\n                   ng-show="editForm.lastName.$error.maxlength"\n                  >\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="control-label">Email</label>\n            <input type="email" class="form-control" name="email"\n                   ng-model="vm.user.email" required ng-maxlength="100">\n\n            <div ng-show="editForm.email.$invalid">\n                <p class="help-block"\n                   ng-show="editForm.email.$error.required">\n                    This field is required.\n                </p>\n\n                <p class="help-block"\n                   ng-show="editForm.email.$error.maxlength"\n                  >\n                    This field cannot be longer than 100 characters.\n                </p>\n\t\t\t\t<p class="help-block"\n                   ng-show="editForm.email.$error.email">\n                    Your e-mail is invalid.\n                 </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label for="activated">\n                <input ng-disabled="vm.user.id === null" type="checkbox" id="activated" ng-model="vm.user.activated">\n                <span>Activated</span>\n            </label>\n        </div>\n\n        <div class="form-group">\n            <label>Profiles</label>\n            <select class="form-control" multiple name="authority" ng-model="vm.user.authorities"\n                    ng-options="authority for authority in vm.authorities">\n            </select>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span\n           >Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/admin/user-management/user-management.html','<div>\n    <h2>Users</h2>\n    <jhi-alert></jhi-alert>\n    <div class="row">\n      <div class="col-md-4">\n          <button class="btn btn-primary" ui-sref="user-management.new">\n              <span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span>\n          </button>\n      </div>\n    </div>\n    <div class="table-responsive">\n        <table class="table table-striped">\n            <thead>\n            <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                <th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th>\n                <th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th>\n                <th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th>\n                <th></th>\n                                <th><span>Profiles</span></th>                <th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th>\n                <th jh-sort-by="lastModifiedBy"><span>Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th>\n                <th jh-sort-by="lastModifiedDate"><span>Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="user in vm.users track by user.id">\n                <td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td>\n                <td>{{user.login}}</td>\n                <td>{{user.email}}</td>\n                <td>\n                    <span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated"\n                          style="cursor: pointer;">Deactivated</span>\n                    <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated"\n                          style="cursor: pointer;">Activated</span>\n                </td>\n                \n                <td>\n                    <div ng-repeat="authority in user.authorities">\n                        <span class="label label-info">{{ authority }}</span>\n                    </div>\n                </td>\n                <td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td>\n                <td>{{user.lastModifiedBy}}</td>\n                <td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td>\n                <td class="text-right">\n                    <div class="btn-group flex-btn-group-container">\n                        <button type="submit"\n                                ui-sref="user-management-detail({login:user.login})"\n                                class="btn btn-info btn-sm">\n                            <span class="glyphicon glyphicon-eye-open"></span>\n                            <span class="hidden-xs hidden-sm"></span>\n                        </button>\n                        <button type="submit"\n                                ui-sref="user-management.edit({login:user.login})"\n                                class="btn btn-primary btn-sm">\n                            <span class="glyphicon glyphicon-pencil"></span>\n                            <span class="hidden-xs hidden-sm"></span>\n                        </button>\n                        <button type="submit"\n                                ui-sref="user-management.delete({login:user.login})"\n                                class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login">\n                            <span class="glyphicon glyphicon-remove-circle"></span>\n                            <span class="hidden-xs hidden-sm"></span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class="text-center">\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\n    </div>\n</div>\n');
$templateCache.put('app/admin/metrics/metrics.html','<div>\n    <h2>Application Metrics</h2>\n    <p>\n        <button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button>\n    </p>\n\n    <h3>JVM Metrics</h3>\n    <div class="row" ng-hide="vm.updatingMetrics">\n        <div class="col-md-4">\n            <b>Memory</b>\n            <p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p>\n            <uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success">\n                <span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value  | number:0}}%</span>\n            </uib-progressbar>\n            <p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p>\n            <uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success">\n                <span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value  | number:0}}%</span>\n            </uib-progressbar>\n            <p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p>\n            <uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success">\n                <span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value  | number:0}}%</span>\n            </uib-progressbar>\n        </div>\n        <div class="col-md-4">\n            <b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a>\n            <p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p>\n            <uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success">\n                <span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span>\n            </uib-progressbar>\n            <p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p>\n            <uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning">\n                <span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span>\n            </uib-progressbar>\n            <p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p>\n            <uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning">\n                <span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span>\n            </uib-progressbar>\n            <p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p>\n            <uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success">\n                <span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span>\n            </uib-progressbar>\n        </div>\n        <div class="col-md-4">\n            <b>Garbage collections</b>\n            <div class="row">\n                <div class="col-md-9">Mark Sweep count</div>\n                <div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div>\n            </div>\n            <div class="row">\n                <div class="col-md-9">Mark Sweep time</div>\n                <div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div>\n            </div>\n            <div class="row">\n                <div class="col-md-9">Scavenge count</div>\n                <div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div>\n            </div>\n            <div class="row">\n                <div class="col-md-9">Scavenge time</div>\n                <div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div>\n            </div>\n        </div>\n    </div>\n    <div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div>\n\n    <h3>HTTP requests (events per second)</h3>\n        <p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p>\n    <div class="table-responsive">\n        <table class="table table-striped">\n            <thead>\n            <tr>\n                <th>Code</th>\n                <th>Count</th>\n                <th class="text-right">Mean</th>\n                <th class="text-right"><span>Average</span> (1 min)</th>\n                <th class="text-right"><span>Average</span> (5 min)</th>\n                <th class="text-right"><span>Average</span> (15 min)</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr>\n                <td>OK</td>\n                <td>\n                    <uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success">\n                        <span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span>\n                    </uib-progressbar>\n                </td>\n                <td class="text-right">\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}\n                </td>\n                <td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}\n                </td>\n                <td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}\n                </td>\n                <td class="text-right">\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}\n                </td>\n            </tr>\n            <tr>\n                <td>Not Found</td>\n                <td>\n                    <uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success">\n                        <span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span>\n                    </uib-progressbar>\n                </td>\n                <td class="text-right">\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}\n                </td>\n                <td class="text-right">\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}\n                </td>\n                <td class="text-right">\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}\n                </td>\n                <td class="text-right">\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}\n                </td>\n            </tr>\n            <tr>\n                <td>Server error</td>\n                <td>\n                    <uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success">\n                        <span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span>\n                    </uib-progressbar>\n                </td>\n                <td class="text-right">\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}\n                </td>\n                <td class="text-right">\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}\n                </td>\n                <td class="text-right">\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}\n                </td>\n                <td class="text-right">\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <h3>Services statistics (time in millisecond)</h3>\n    <div class="table-responsive">\n        <table class="table table-striped">\n            <thead>\n            <tr>\n                <th>Service name</th>\n                <th class="text-right">Count</th>\n                <th class="text-right">Mean</th>\n                <th class="text-right">Min</th>\n                <th class="text-right">p50</th>\n                <th class="text-right">p75</th>\n                <th class="text-right">p95</th>\n                <th class="text-right">p99</th>\n                <th class="text-right">Max</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="(k, v) in vm.servicesStats">\n                <td>{{k}}</td>\n                <td class="text-right">{{v.count}}</td>\n                <td class="text-right">{{v.mean * 1000 | number:0}}</td>\n                <td class="text-right">{{v.min * 1000 | number:0}}</td>\n                <td class="text-right">{{v.p50 * 1000 | number:0}}</td>\n                <td class="text-right">{{v.p75 * 1000 | number:0}}</td>\n                <td class="text-right">{{v.p95 * 1000 | number:0}}</td>\n                <td class="text-right">{{v.p99 * 1000 | number:0}}</td>\n                <td class="text-right">{{v.max * 1000 | number:0}}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n    \n    <h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3>\n    <div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">\n        <table class="table table-striped">\n            <thead>\n                <tr>\n                    <th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th>\n                    <th class="text-right">Count</th>\n                    <th class="text-right">Mean</th>\n                    <th class="text-right">Min</th>\n                    <th class="text-right">p50</th>\n                    <th class="text-right">p75</th>\n                    <th class="text-right">p95</th>\n                    <th class="text-right">p99</th>\n                    <th class="text-right">Max</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>\n                        <div class="progress progress-striped">\n                            <uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success">\n                                <span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value  | number:0}}%</span>\n                            </uib-progressbar>\n                        </div>\n                    </td>\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td>\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td>\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td>\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td>\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td>\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td>\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td>\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump -->\n<div class="modal-header">\n    <button type="button" class="close" ng-click="vm.cancel()">&times;</button>\n    <h4 class="modal-title">Threads dump</h4>\n</div>\n<div class="modal-body pad">\n    <span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp;\n    <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp;\n    <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp;\n    <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp;\n    <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;\n    <div class="voffset2">&nbsp;</div>\n    Filter\n    <input type="text" ng-model="threadDumpFilter" class="form-control">\n    <div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter">\n        <h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}})\n            <a ng-click="show = !show">\n               <span ng-show="!show">Show StackTrace</span>\n               <span ng-show="show">Hide StackTrace</span>\n            </a>\n        </h5>\n        <div class="well" ng-show="show">\n            <div ng-repeat="(stK, stV) in v.stackTrace">\n                {{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}})\n                <span class="voffset1"></span>\n            </div>\n        </div>\n        <table class="table table-condensed">\n            <thead>\n                <tr>\n                    <th class="text-right">Blocked Time</th>\n                    <th class="text-right">Blocked Count</th>\n                    <th class="text-right">Waited Time</th>\n                    <th class="text-right">Waited Count</th>\n                    <th>Lock Name</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>{{v.blockedTime}}</td>\n                    <td>{{v.blockedCount}}</td>\n                    <td>{{v.waitedTime}}</td>\n                    <td>{{v.waitedCount}}</td>\n                    <td>{{v.lockName}}</td>\n                </tr>\n            </tbody>\n        </table>\n\n    </div>\n</div>\n<div class="modal-footer">\n    <button type="button" class="btn btn-default  pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button>\n</div>\n');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak>\n    <div class="row">\n        <div class="col-md-4">\n            <span class="hipster img-responsive img-rounded"></span>\n        </div>\n        <div class="col-md-8">\n            <h1>Error Page!</h1>\n\n            <div class="alert alert-danger">You are not authorized to access the page.\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak>\n    <div class="row">\n        <div class="col-md-12">\n            <h1>Error Page!</h1>\n\n            <div ng-show="errorMessage">\n                <div class="alert alert-danger">{{errorMessage}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation">\n    <div class="container">\n        <div class="navbar-header">\n            <button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()">\n                <span class="sr-only">Toggle navigation</span>\n                <span class="icon-bar"></span>\n                <span class="icon-bar"></span>\n                <span class="icon-bar"></span>\n            </button>\n            <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()">\n                <img class="logo-img" src="content/images/ornl_logo.png"/>\n                <span>Energy Savings and Moisture Transport Calculator</span> <span class="navbar-version">v{{VERSION}}</span>\n            </a>\n        </div>\n        <div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()">\n            <ul class="nav navbar-nav navbar-right">\n                <li ui-sref-active="active">\n                    <a ui-sref="home" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-home"></span>\n                        <span class="hidden-sm">Home</span>\n                    </a>\n                </li>\n                <li ui-sref-active="active" ng-switch-when="true">\n                    <a ui-sref="infiltration" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-leaf"></span>\n                        <span class="hidden-sm">Infiltration</span>\n                    </a>\n                </li>\n\n                <!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here -->\n                <li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-th-list"></span>\n                            <span class="hidden-sm">\n                                Entities\n                            </span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ui-sref-active="active" >\n                            <a ui-sref="map-location" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span >Map Location</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" >\n                            <a ui-sref="building" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span >Building</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" >\n                            <a ui-sref="building-type" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span >Building Type</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" >\n                            <a ui-sref="infiltration-result" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span >Infiltration Result</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" >\n                            <a ui-sref="infiltration-entry" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span >Infiltration Entry</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" >\n                            <a ui-sref="us-state" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span >Us State</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" >\n                            <a ui-sref="energy-calc" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span >Energy Calc</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" >\n                            <a ui-sref="raw-data" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span >Raw Data</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" >\n                            <a ui-sref="moisture-transfer" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span >Moisture Transfer</span>\n                            </a>\n                        </li>\n                        <!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here -->\n                    </ul>\n                </li>\n                <li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-user"></span>\n                            <span class="hidden-sm">\n                                Account\n                            </span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ui-sref-active="active" ng-switch-when="true">\n                            <a ui-sref="settings" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-wrench"></span>&nbsp;\n                                <span>Settings</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" ng-switch-when="true">\n                            <a ui-sref="password" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-lock"></span>&nbsp;\n                                <span>Password</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" ng-switch-when="true">\n                            <a href="" ng-click="vm.logout()" id="logout">\n                                <span class="glyphicon glyphicon-log-out"></span>&nbsp;\n                                <span>Sign out</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" ng-switch-when="false">\n                            <a href="" ng-click="vm.login()" id="login">\n                                <span class="glyphicon glyphicon-log-in"></span>&nbsp;\n                                <span>Sign in</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" ng-switch-when="false">\n                            <a ui-sref="register" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-plus-sign"></span>&nbsp;\n                                <span>Register</span>\n                            </a>\n                        </li>\n                    </ul>\n                </li>\n                <li ng-class="{active: vm.$state.includes(\'admin\')}"  ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-tower"></span>\n                            <span class="hidden-sm">Administration</span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ui-sref-active="active">\n                            <a ui-sref="user-management" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-user"></span>&nbsp;\n                                <span>User management</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-dashboard"></span>&nbsp;\n                                <span>Metrics</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-health" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-heart"></span>&nbsp;\n                                <span>Health</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-list-alt"></span>&nbsp;\n                                <span>Configuration</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="audits" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-bell"></span>&nbsp;\n                                <span>Audits</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="logs" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-tasks"></span>&nbsp;\n                                <span>Logs</span>\n                            </a>\n                        </li>\n                        <li ng-show="vm.swaggerEnabled" ui-sref-active="active">\n                            <a ui-sref="docs" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-book"></span>&nbsp;\n                                <span>API</span>\n                            </a>\n                        </li>\n                        <!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here -->\n                    </ul>\n                </li>\n            </ul>\n        </div>\n    </div>\n\n</nav>\n');
$templateCache.put('app/entities/building/building-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.building.id)">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title">Confirm delete operation</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <p>Are you sure you want to delete this Building?</p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/building/building-detail.html','\n<div>\n    <h2><span>Building</span> {{vm.building.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class="dl-horizontal jh-entity-details">\n        <dt><span>Sqft</span></dt>\n        <dd>\n            <span>{{vm.building.sqft}}</span>\n        </dd>\n        <dt><span>Basecase Leakage Rate</span></dt>\n        <dd>\n            <span>{{vm.building.basecaseLeakageRate}}</span>\n        </dd>\n        <dt><span>Retrofit Leakage Rate</span></dt>\n        <dd>\n            <span>{{vm.building.retrofitLeakageRate}}</span>\n        </dd>\n    </dl>\n\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\n    </button>\n\n    <button type="button" ui-sref="building-detail.edit({id:vm.building.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-xs hidden-sm"> Edit</span>\n    </button>\n</div>\n');
$templateCache.put('app/entities/building/building-dialog.html','\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myBuildingLabel">Create or edit a Building</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.building.id">\n            <label for="id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.building.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_sqft">Sqft</label>\n            <input type="number" class="form-control" name="sqft" id="field_sqft"\n                    ng-model="vm.building.sqft"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_basecaseLeakageRate">Basecase Leakage Rate</label>\n            <input type="number" class="form-control" name="basecaseLeakageRate" id="field_basecaseLeakageRate"\n                    ng-model="vm.building.basecaseLeakageRate"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_retrofitLeakageRate">Retrofit Leakage Rate</label>\n            <input type="number" class="form-control" name="retrofitLeakageRate" id="field_retrofitLeakageRate"\n                    ng-model="vm.building.retrofitLeakageRate"\n                     />\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/building/buildings.html','<div>\n    <h2>Buildings</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="building.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Create new Building\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr>\n                    <th><span>ID</span></th>\n                    <th><span>Sqft</span></th>\n                    <th><span>Basecase Leakage Rate</span></th>\n                    <th><span>Retrofit Leakage Rate</span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="building in vm.buildings track by building.id">\n                    <td><a ui-sref="building-detail({id:building.id})">{{building.id}}</a></td>\n                    <td>{{building.sqft}}</td>\n                    <td>{{building.basecaseLeakageRate}}</td>\n                    <td>{{building.retrofitLeakageRate}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="building-detail({id:building.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="building.edit({id:building.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="building.delete({id:building.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/entities/energy-calc/energy-calc-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.energyCalc.id)">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title">Confirm delete operation</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <p>Are you sure you want to delete this Energy Calc?</p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/energy-calc/energy-calc-detail.html','\n<div>\n    <h2><span>Energy Calc</span> {{vm.energyCalc.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class="dl-horizontal jh-entity-details">\n        <dt><span>X Electric</span></dt>\n        <dd>\n            <span>{{vm.energyCalc.xElectric}}</span>\n        </dd>\n        <dt><span>X 2 Electric</span></dt>\n        <dd>\n            <span>{{vm.energyCalc.x2Electric}}</span>\n        </dd>\n        <dt><span>X Gas</span></dt>\n        <dd>\n            <span>{{vm.energyCalc.xGas}}</span>\n        </dd>\n        <dt><span>X 2 Gas</span></dt>\n        <dd>\n            <span>{{vm.energyCalc.x2Gas}}</span>\n        </dd>\n        <dt><span>Description Text</span></dt>\n        <dd>\n            <span>{{vm.energyCalc.descriptionText}}</span>\n        </dd>\n        <dt><span>Map Location</span></dt>\n        <dd>\n            <a ui-sref="map-location-detail({id:vm.energyCalc.mapLocation.id})">{{vm.energyCalc.mapLocation.cityState}}</a>\n        </dd>\n        <dt><span>Building Type</span></dt>\n        <dd>\n            <a ui-sref="building-type-detail({id:vm.energyCalc.buildingType.id})">{{vm.energyCalc.buildingType.longName}}</a>\n        </dd>\n    </dl>\n\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\n    </button>\n\n    <button type="button" ui-sref="energy-calc-detail.edit({id:vm.energyCalc.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-xs hidden-sm"> Edit</span>\n    </button>\n</div>\n');
$templateCache.put('app/entities/energy-calc/energy-calc-dialog.html','\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myEnergyCalcLabel">Create or edit a Energy Calc</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.energyCalc.id">\n            <label for="id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.energyCalc.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_xElectric">X Electric</label>\n            <input type="number" class="form-control" name="xElectric" id="field_xElectric"\n                    ng-model="vm.energyCalc.xElectric"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_x2Electric">X 2 Electric</label>\n            <input type="number" class="form-control" name="x2Electric" id="field_x2Electric"\n                    ng-model="vm.energyCalc.x2Electric"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_xGas">X Gas</label>\n            <input type="number" class="form-control" name="xGas" id="field_xGas"\n                    ng-model="vm.energyCalc.xGas"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_x2Gas">X 2 Gas</label>\n            <input type="number" class="form-control" name="x2Gas" id="field_x2Gas"\n                    ng-model="vm.energyCalc.x2Gas"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_descriptionText">Description Text</label>\n            <input type="text" class="form-control" name="descriptionText" id="field_descriptionText"\n                    ng-model="vm.energyCalc.descriptionText"\n                     />\n        </div>\n\n        <div class="form-group">\n            <label for="field_mapLocation">Map Location</label>\n            <select class="form-control" id="field_mapLocation" name="mapLocation" ng-model="vm.energyCalc.mapLocation" ng-options="mapLocation as mapLocation.cityState for mapLocation in vm.maplocations track by mapLocation.id">\n                <option value=""></option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label for="field_buildingType">Building Type</label>\n            <select class="form-control" id="field_buildingType" name="buildingType" ng-model="vm.energyCalc.buildingType" ng-options="buildingType as buildingType.longName for buildingType in vm.buildingtypes track by buildingType.id">\n                <option value=""></option>\n            </select>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/energy-calc/energy-calcs.html','<div>\n    <h2>Energy Calcs</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="energy-calc.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Create new Energy Calc\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr>\n                    <th><span>ID</span></th>\n                    <th><span>X Electric</span></th>\n                    <th><span>X 2 Electric</span></th>\n                    <th><span>X Gas</span></th>\n                    <th><span>X 2 Gas</span></th>\n                    <th><span>Description Text</span></th>\n                    <th><span>Map Location</span></th>\n                    <th><span>Building Type</span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="energyCalc in vm.energyCalcs track by energyCalc.id">\n                    <td><a ui-sref="energy-calc-detail({id:energyCalc.id})">{{energyCalc.id}}</a></td>\n                    <td>{{energyCalc.xElectric}}</td>\n                    <td>{{energyCalc.x2Electric}}</td>\n                    <td>{{energyCalc.xGas}}</td>\n                    <td>{{energyCalc.x2Gas}}</td>\n                    <td>{{energyCalc.descriptionText}}</td>\n                    <td>\n                        <a ui-sref="map-location-detail({id:energyCalc.mapLocation.id})">{{energyCalc.mapLocation.cityState}}</a>\n                    </td>\n                    <td>\n                        <a ui-sref="building-type-detail({id:energyCalc.buildingType.id})">{{energyCalc.buildingType.longName}}</a>\n                    </td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="energy-calc-detail({id:energyCalc.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="energy-calc.edit({id:energyCalc.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="energy-calc.delete({id:energyCalc.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/entities/building-type/building-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.buildingType.id)">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title">Confirm delete operation</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <p>Are you sure you want to delete this Building Type?</p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/building-type/building-type-detail.html','\n<div>\n    <h2><span>Building Type</span> {{vm.buildingType.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class="dl-horizontal jh-entity-details">\n        <dt><span>Long Name</span></dt>\n        <dd>\n            <span>{{vm.buildingType.longName}}</span>\n        </dd>\n        <dt><span>Short Name</span></dt>\n        <dd>\n            <span>{{vm.buildingType.shortName}}</span>\n        </dd>\n        <dt><span>Sort Order</span></dt>\n        <dd>\n            <span>{{vm.buildingType.sortOrder}}</span>\n        </dd>\n        <dt><span>Leakage Rate</span></dt>\n        <dd>\n            <span>{{vm.buildingType.leakageRate}}</span>\n        </dd>\n        <dt><span>Alt Leakage Rate</span></dt>\n        <dd>\n            <span>{{vm.buildingType.altLeakageRate}}</span>\n        </dd>\n        <dt><span>Floor Area</span></dt>\n        <dd>\n            <span>{{vm.buildingType.floorArea}}</span>\n        </dd>\n        <dt><span>Description Text</span></dt>\n        <dd>\n            <span>{{vm.buildingType.descriptionText}}</span>\n        </dd>\n        <dt><span>Is Default</span></dt>\n        <dd>\n            <span>{{vm.buildingType.isDefault}}</span>\n        </dd>\n    </dl>\n\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\n    </button>\n\n    <button type="button" ui-sref="building-type-detail.edit({id:vm.buildingType.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-xs hidden-sm"> Edit</span>\n    </button>\n</div>\n');
$templateCache.put('app/entities/building-type/building-type-dialog.html','\n<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myBuildingTypeLabel">Create or edit a Building Type</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.buildingType.id">\n            <label for="id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.buildingType.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_longName">Long Name</label>\n            <input type="text" class="form-control" name="longName" id="field_longName"\n                    ng-model="vm.buildingType.longName"\n                    required />\n            <div ng-show="editForm.longName.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.longName.$error.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_shortName">Short Name</label>\n            <input type="text" class="form-control" name="shortName" id="field_shortName"\n                    ng-model="vm.buildingType.shortName"\n                    required />\n            <div ng-show="editForm.shortName.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.shortName.$error.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_sortOrder">Sort Order</label>\n            <input type="number" class="form-control" name="sortOrder" id="field_sortOrder"\n                    ng-model="vm.buildingType.sortOrder"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_leakageRate">Leakage Rate</label>\n            <input type="number" class="form-control" name="leakageRate" id="field_leakageRate"\n                    ng-model="vm.buildingType.leakageRate"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_altLeakageRate">Alt Leakage Rate</label>\n            <input type="number" class="form-control" name="altLeakageRate" id="field_altLeakageRate"\n                    ng-model="vm.buildingType.altLeakageRate"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_floorArea">Floor Area</label>\n            <input type="number" class="form-control" name="floorArea" id="field_floorArea"\n                    ng-model="vm.buildingType.floorArea"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_descriptionText">Description Text</label>\n            <input type="text" class="form-control" name="descriptionText" id="field_descriptionText"\n                    ng-model="vm.buildingType.descriptionText"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_isDefault">Is Default</label>\n            <input type="number" class="form-control" name="isDefault" id="field_isDefault"\n                    ng-model="vm.buildingType.isDefault"\n                     />\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/building-type/building-types.html','<div>\n    <h2>Building Types</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="building-type.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Create new Building Type\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr>\n                    <th><span>ID</span></th>\n                    <th><span>Long Name</span></th>\n                    <th><span>Short Name</span></th>\n                    <th><span>Sort Order</span></th>\n                    <th><span>Leakage Rate</span></th>\n                    <th><span>Alt Leakage Rate</span></th>\n                    <th><span>Floor Area</span></th>\n                    <th><span>Description Text</span></th>\n                    <th><span>Is Default</span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="buildingType in vm.buildingTypes track by buildingType.id">\n                    <td><a ui-sref="building-type-detail({id:buildingType.id})">{{buildingType.id}}</a></td>\n                    <td>{{buildingType.longName}}</td>\n                    <td>{{buildingType.shortName}}</td>\n                    <td>{{buildingType.sortOrder}}</td>\n                    <td>{{buildingType.leakageRate}}</td>\n                    <td>{{buildingType.altLeakageRate}}</td>\n                    <td>{{buildingType.floorArea}}</td>\n                    <td>{{buildingType.descriptionText}}</td>\n                    <td>{{buildingType.isDefault}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="building-type-detail({id:buildingType.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="building-type.edit({id:buildingType.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="building-type.delete({id:buildingType.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/entities/infiltration-entry/infiltration-entries.html','<div>\n    <h2>Infiltration Entries</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="infiltration-entry.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Create new Infiltration Entry\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr>\n                    <th><span>ID</span></th>\n                    <th><span>Area</span></th>\n                    <th><span>Basecase Leakage</span></th>\n                    <th><span>Retrofitted Leakage</span></th>\n                    <th><span>Cost Electricity</span></th>\n                    <th><span>Cost Gas</span></th>\n                    <th><span>Area Unit</span></th>\n                    <th><span>Leakage Unit</span></th>\n                    <th><span>Gas Cost Units</span></th>\n                    <th><span>Description Text</span></th>\n                    <th><span>Infiltration Result</span></th>\n                    <th><span>Building Type</span></th>\n                    <th><span>Map Location</span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="infiltrationEntry in vm.infiltrationEntries track by infiltrationEntry.id">\n                    <td><a ui-sref="infiltration-entry-detail({id:infiltrationEntry.id})">{{infiltrationEntry.id}}</a></td>\n                    <td>{{infiltrationEntry.area}}</td>\n                    <td>{{infiltrationEntry.basecaseLeakage}}</td>\n                    <td>{{infiltrationEntry.retrofittedLeakage}}</td>\n                    <td>{{infiltrationEntry.costElectricity}}</td>\n                    <td>{{infiltrationEntry.costGas}}</td>\n                    <td>{{infiltrationEntry.areaUnit}}</td>\n                    <td>{{infiltrationEntry.leakageUnit}}</td>\n                    <td>{{infiltrationEntry.gasCostUnits}}</td>\n                    <td>{{infiltrationEntry.descriptionText}}</td>\n                    <td>\n                        <span ng-repeat="infiltrationResult in infiltrationEntry.infiltrationResults">\n                            <a class="form-control-static" ui-sref="infiltration-result-detail({id: infiltrationResult.id})">{{infiltrationResult.id}}</a>{{$last ? \'\' : \', \'}}\n                        </span>\n                    </td>\n                    <td>\n                        <a ui-sref="building-type-detail({id:infiltrationEntry.buildingType.id})">{{infiltrationEntry.buildingType.id}}</a>\n                    </td>\n                    <td>\n                        <a ui-sref="map-location-detail({id:infiltrationEntry.mapLocation.id})">{{infiltrationEntry.mapLocation.id}}</a>\n                    </td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="infiltration-entry-detail({id:infiltrationEntry.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="infiltration-entry.edit({id:infiltrationEntry.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="infiltration-entry.delete({id:infiltrationEntry.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/entities/infiltration-entry/infiltration-entry-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.infiltrationEntry.id)">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title">Confirm delete operation</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <p>Are you sure you want to delete this Infiltration Entry?</p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/infiltration-entry/infiltration-entry-detail.html','\n<div>\n    <h2><span>Infiltration Entry</span> {{vm.infiltrationEntry.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class="dl-horizontal jh-entity-details">\n        <dt><span>Area</span></dt>\n        <dd>\n            <span>{{vm.infiltrationEntry.area}}</span>\n        </dd>\n        <dt><span>Basecase Leakage</span></dt>\n        <dd>\n            <span>{{vm.infiltrationEntry.basecaseLeakage}}</span>\n        </dd>\n        <dt><span>Retrofitted Leakage</span></dt>\n        <dd>\n            <span>{{vm.infiltrationEntry.retrofittedLeakage}}</span>\n        </dd>\n        <dt><span>Cost Electricity</span></dt>\n        <dd>\n            <span>{{vm.infiltrationEntry.costElectricity}}</span>\n        </dd>\n        <dt><span>Cost Gas</span></dt>\n        <dd>\n            <span>{{vm.infiltrationEntry.costGas}}</span>\n        </dd>\n        <dt><span>Area Unit</span></dt>\n        <dd>\n            <span>{{vm.infiltrationEntry.areaUnit}}</span>\n        </dd>\n        <dt><span>Leakage Unit</span></dt>\n        <dd>\n            <span>{{vm.infiltrationEntry.leakageUnit}}</span>\n        </dd>\n        <dt><span>Gas Cost Units</span></dt>\n        <dd>\n            <span>{{vm.infiltrationEntry.gasCostUnits}}</span>\n        </dd>\n        <dt><span>Description Text</span></dt>\n        <dd>\n            <span>{{vm.infiltrationEntry.descriptionText}}</span>\n        </dd>\n        <dt><span>Infiltration Result</span></dt>\n        <dd>\n            <span ng-repeat="infiltrationResult in vm.infiltrationEntry.infiltrationResults">\n                <a ui-sref="infiltration-result-detail({id: infiltrationResult.id})">{{infiltrationResult.id}}</a>{{$last ? \'\' : \', \'}}\n            </span>\n        </dd>\n        <dt><span>Building Type</span></dt>\n        <dd>\n            <a ui-sref="building-type-detail({id:vm.infiltrationEntry.buildingType.id})">{{vm.infiltrationEntry.buildingType.id}}</a>\n        </dd>\n        <dt><span>Map Location</span></dt>\n        <dd>\n            <a ui-sref="map-location-detail({id:vm.infiltrationEntry.mapLocation.id})">{{vm.infiltrationEntry.mapLocation.id}}</a>\n        </dd>\n    </dl>\n\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\n    </button>\n\n    <button type="button" ui-sref="infiltration-entry-detail.edit({id:vm.infiltrationEntry.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-xs hidden-sm"> Edit</span>\n    </button>\n</div>\n');
$templateCache.put('app/entities/infiltration-entry/infiltration-entry-dialog.html','\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myInfiltrationEntryLabel">Create or edit a Infiltration Entry</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.infiltrationEntry.id">\n            <label for="id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.infiltrationEntry.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_area">Area</label>\n            <input type="number" class="form-control" name="area" id="field_area"\n                    ng-model="vm.infiltrationEntry.area"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_basecaseLeakage">Basecase Leakage</label>\n            <input type="number" class="form-control" name="basecaseLeakage" id="field_basecaseLeakage"\n                    ng-model="vm.infiltrationEntry.basecaseLeakage"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_retrofittedLeakage">Retrofitted Leakage</label>\n            <input type="number" class="form-control" name="retrofittedLeakage" id="field_retrofittedLeakage"\n                    ng-model="vm.infiltrationEntry.retrofittedLeakage"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_costElectricity">Cost Electricity</label>\n            <input type="number" class="form-control" name="costElectricity" id="field_costElectricity"\n                    ng-model="vm.infiltrationEntry.costElectricity"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_costGas">Cost Gas</label>\n            <input type="number" class="form-control" name="costGas" id="field_costGas"\n                    ng-model="vm.infiltrationEntry.costGas"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_areaUnit">Area Unit</label>\n            <select class="form-control" name="areaUnit" ng-model="vm.infiltrationEntry.areaUnit" id="field_areaUnit">\n                <option value="SQFT">SQFT</option>\n                <option value="M2">M2</option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_leakageUnit">Leakage Unit</label>\n            <select class="form-control" name="leakageUnit" ng-model="vm.infiltrationEntry.leakageUnit" id="field_leakageUnit">\n                <option value="LPERSECM2">LPERSECM2</option>\n                <option value="CFMSQFT">CFMSQFT</option>\n                <option value="ACH50" >ACH50</option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gasCostUnits">Gas Cost Units</label>\n            <select class="form-control" name="gasCostUnits" ng-model="vm.infiltrationEntry.gasCostUnits" id="field_gasCostUnits">\n                <option value="M3">M3</option>\n                <option value="FT3">FT3</option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_descriptionText">Description Text</label>\n            <input type="text" class="form-control" name="descriptionText" id="field_descriptionText"\n                    ng-model="vm.infiltrationEntry.descriptionText"\n                     />\n        </div>\n\n        <div class="form-group">\n            <label for="field_infiltrationResult">Infiltration Result</label>\n            <select class="form-control" id="field_infiltrationResult" multiple name="infiltrationResult" ng-model="vm.infiltrationEntry.infiltrationResults" ng-options="infiltrationResult as infiltrationResult.id for infiltrationResult in vm.infiltrationresults track by infiltrationResult.id"></select>\n        </div>\n        <div class="form-group">\n            <label for="field_buildingType">Building Type</label>\n            <select class="form-control" id="field_buildingType" name="buildingType" ng-model="vm.infiltrationEntry.buildingType" ng-options="buildingType as buildingType.id for buildingType in vm.buildingtypes track by buildingType.id">\n                <option value=""></option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label for="field_mapLocation">Map Location</label>\n            <select class="form-control" id="field_mapLocation" name="mapLocation" ng-model="vm.infiltrationEntry.mapLocation" ng-options="mapLocation as mapLocation.id for mapLocation in vm.maplocations track by mapLocation.id">\n                <option value=""></option>\n            </select>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/infiltration-result/infiltration-result-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.infiltrationResult.id)">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title">Confirm delete operation</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <p>Are you sure you want to delete this Infiltration Result?</p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/infiltration-result/infiltration-result-detail.html','\n<div>\n    <h2><span>Infiltration Result</span> {{vm.infiltrationResult.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class="dl-horizontal jh-entity-details">\n        <dt><span>Electric Use</span></dt>\n        <dd>\n            <span>{{vm.infiltrationResult.electricUse}}</span>\n        </dd>\n        <dt><span>Gas Use</span></dt>\n        <dd>\n            <span>{{vm.infiltrationResult.gasUse}}</span>\n        </dd>\n        <dt><span>Electric Cost Savings</span></dt>\n        <dd>\n            <span>{{vm.infiltrationResult.electricCostSavings}}</span>\n        </dd>\n        <dt><span>Gas Cost Savings</span></dt>\n        <dd>\n            <span>{{vm.infiltrationResult.gasCostSavings}}</span>\n        </dd>\n        <dt><span>Total Cost Savings</span></dt>\n        <dd>\n            <span>{{vm.infiltrationResult.totalCostSavings}}</span>\n        </dd>\n        <dt><span>Total Savings</span></dt>\n        <dd>\n            <span>{{vm.infiltrationResult.totalSavings}}</span>\n        </dd>\n        <dt><span>Electric Savings</span></dt>\n        <dd>\n            <span>{{vm.infiltrationResult.electricSavings}}</span>\n        </dd>\n        <dt><span>Gas Savings</span></dt>\n        <dd>\n            <span>{{vm.infiltrationResult.gasSavings}}</span>\n        </dd>\n        <dt><span>Description Text</span></dt>\n        <dd>\n            <span>{{vm.infiltrationResult.descriptionText}}</span>\n        </dd>\n    </dl>\n\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\n    </button>\n\n    <button type="button" ui-sref="infiltration-result-detail.edit({id:vm.infiltrationResult.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-xs hidden-sm"> Edit</span>\n    </button>\n</div>\n');
$templateCache.put('app/entities/infiltration-result/infiltration-result-dialog.html','\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myInfiltrationResultLabel">Create or edit a Infiltration Result</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.infiltrationResult.id">\n            <label for="id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.infiltrationResult.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_electricUse">Electric Use</label>\n            <input type="number" class="form-control" name="electricUse" id="field_electricUse"\n                    ng-model="vm.infiltrationResult.electricUse"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gasUse">Gas Use</label>\n            <input type="number" class="form-control" name="gasUse" id="field_gasUse"\n                    ng-model="vm.infiltrationResult.gasUse"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_electricCostSavings">Electric Cost Savings</label>\n            <input type="number" class="form-control" name="electricCostSavings" id="field_electricCostSavings"\n                    ng-model="vm.infiltrationResult.electricCostSavings"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gasCostSavings">Gas Cost Savings</label>\n            <input type="number" class="form-control" name="gasCostSavings" id="field_gasCostSavings"\n                    ng-model="vm.infiltrationResult.gasCostSavings"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_totalCostSavings">Total Cost Savings</label>\n            <input type="number" class="form-control" name="totalCostSavings" id="field_totalCostSavings"\n                    ng-model="vm.infiltrationResult.totalCostSavings"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_totalSavings">Total Savings</label>\n            <input type="number" class="form-control" name="totalSavings" id="field_totalSavings"\n                    ng-model="vm.infiltrationResult.totalSavings"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_electricSavings">Electric Savings</label>\n            <input type="number" class="form-control" name="electricSavings" id="field_electricSavings"\n                    ng-model="vm.infiltrationResult.electricSavings"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gasSavings">Gas Savings</label>\n            <input type="number" class="form-control" name="gasSavings" id="field_gasSavings"\n                    ng-model="vm.infiltrationResult.gasSavings"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_descriptionText">Description Text</label>\n            <input type="text" class="form-control" name="descriptionText" id="field_descriptionText"\n                    ng-model="vm.infiltrationResult.descriptionText"\n                     />\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/infiltration-result/infiltration-results.html','<div>\n    <h2>Infiltration Results</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="infiltration-result.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Create new Infiltration Result\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr>\n                    <th><span>ID</span></th>\n                    <th><span>Electric Use</span></th>\n                    <th><span>Gas Use</span></th>\n                    <th><span>Electric Cost Savings</span></th>\n                    <th><span>Gas Cost Savings</span></th>\n                    <th><span>Total Cost Savings</span></th>\n                    <th><span>Total Savings</span></th>\n                    <th><span>Electric Savings</span></th>\n                    <th><span>Gas Savings</span></th>\n                    <th><span>Description Text</span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="infiltrationResult in vm.infiltrationResults track by infiltrationResult.id">\n                    <td><a ui-sref="infiltration-result-detail({id:infiltrationResult.id})">{{infiltrationResult.id}}</a></td>\n                    <td>{{infiltrationResult.electricUse}}</td>\n                    <td>{{infiltrationResult.gasUse}}</td>\n                    <td>{{infiltrationResult.electricCostSavings}}</td>\n                    <td>{{infiltrationResult.gasCostSavings}}</td>\n                    <td>{{infiltrationResult.totalCostSavings}}</td>\n                    <td>{{infiltrationResult.totalSavings}}</td>\n                    <td>{{infiltrationResult.electricSavings}}</td>\n                    <td>{{infiltrationResult.gasSavings}}</td>\n                    <td>{{infiltrationResult.descriptionText}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="infiltration-result-detail({id:infiltrationResult.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="infiltration-result.edit({id:infiltrationResult.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="infiltration-result.delete({id:infiltrationResult.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/entities/map-location/map-location-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.mapLocation.id)">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title">Confirm delete operation</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <p>Are you sure you want to delete this Map Location?</p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/map-location/map-location-detail.html','\n<div>\n    <h2><span>Map Location</span> {{vm.mapLocation.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class="dl-horizontal jh-entity-details">\n        <dt><span>Country Id</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.countryId}}</span>\n        </dd>\n        <dt><span>Country</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.country}}</span>\n        </dd>\n        <dt><span>Country Abbrev</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.countryAbbrev}}</span>\n        </dd>\n        <dt><span>State Id</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.stateId}}</span>\n        </dd>\n        <dt><span>State Name</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.stateName}}</span>\n        </dd>\n        <dt><span>State Abbrev</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.stateAbbrev}}</span>\n        </dd>\n        <dt><span>City</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.city}}</span>\n        </dd>\n        <dt><span>Latitude</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.latitude}}</span>\n        </dd>\n        <dt><span>Longitude</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.longitude}}</span>\n        </dd>\n        <dt><span>Climate Zone Name</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.climateZoneName}}</span>\n        </dd>\n        <dt><span>Iecc Climate Type</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.ieccClimateType}}</span>\n        </dd>\n        <dt><span>Iecc Climate Zone</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.ieccClimateZone}}</span>\n        </dd>\n        <dt><span>Hdd 65</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.hdd65}}</span>\n        </dd>\n        <dt><span>Cdd 65</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.cdd65}}</span>\n        </dd>\n        <dt><span>City State</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.cityState}}</span>\n        </dd>\n        <dt><span>Combined Iecc</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.combinedIecc}}</span>\n        </dd>\n        <dt><span>Cz Number</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.czNumber}}</span>\n        </dd>\n        <dt><span>Cost Electricity</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.costElectricity}}</span>\n        </dd>\n        <dt><span>Cost Gas</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.costGas}}</span>\n        </dd>\n        <dt><span>Is Active</span></dt>\n        <dd>\n            <span>{{vm.mapLocation.isActive}}</span>\n        </dd>\n    </dl>\n\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\n    </button>\n\n    <button type="button" ui-sref="map-location-detail.edit({id:vm.mapLocation.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-xs hidden-sm"> Edit</span>\n    </button>\n</div>\n');
$templateCache.put('app/entities/map-location/map-location-dialog.html','\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myMapLocationLabel">Create or edit a Map Location</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.mapLocation.id">\n            <label for="id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.mapLocation.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_countryId">Country Id</label>\n            <input type="number" class="form-control" name="countryId" id="field_countryId"\n                    ng-model="vm.mapLocation.countryId"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_country">Country</label>\n            <input type="text" class="form-control" name="country" id="field_country"\n                    ng-model="vm.mapLocation.country"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_countryAbbrev">Country Abbrev</label>\n            <input type="text" class="form-control" name="countryAbbrev" id="field_countryAbbrev"\n                    ng-model="vm.mapLocation.countryAbbrev"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_stateId">State Id</label>\n            <input type="number" class="form-control" name="stateId" id="field_stateId"\n                    ng-model="vm.mapLocation.stateId"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_stateName">State Name</label>\n            <input type="text" class="form-control" name="stateName" id="field_stateName"\n                    ng-model="vm.mapLocation.stateName"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_stateAbbrev">State Abbrev</label>\n            <input type="text" class="form-control" name="stateAbbrev" id="field_stateAbbrev"\n                    ng-model="vm.mapLocation.stateAbbrev"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_city">City</label>\n            <input type="text" class="form-control" name="city" id="field_city"\n                    ng-model="vm.mapLocation.city"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_latitude">Latitude</label>\n            <input type="text" class="form-control" name="latitude" id="field_latitude"\n                    ng-model="vm.mapLocation.latitude"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_longitude">Longitude</label>\n            <input type="text" class="form-control" name="longitude" id="field_longitude"\n                    ng-model="vm.mapLocation.longitude"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_climateZoneName">Climate Zone Name</label>\n            <input type="text" class="form-control" name="climateZoneName" id="field_climateZoneName"\n                    ng-model="vm.mapLocation.climateZoneName"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_ieccClimateType">Iecc Climate Type</label>\n            <input type="text" class="form-control" name="ieccClimateType" id="field_ieccClimateType"\n                    ng-model="vm.mapLocation.ieccClimateType"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_ieccClimateZone">Iecc Climate Zone</label>\n            <input type="number" class="form-control" name="ieccClimateZone" id="field_ieccClimateZone"\n                    ng-model="vm.mapLocation.ieccClimateZone"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_hdd65">Hdd 65</label>\n            <input type="number" class="form-control" name="hdd65" id="field_hdd65"\n                    ng-model="vm.mapLocation.hdd65"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_cdd65">Cdd 65</label>\n            <input type="number" class="form-control" name="cdd65" id="field_cdd65"\n                    ng-model="vm.mapLocation.cdd65"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_cityState">City State</label>\n            <input type="text" class="form-control" name="cityState" id="field_cityState"\n                    ng-model="vm.mapLocation.cityState"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_combinedIecc">Combined Iecc</label>\n            <input type="text" class="form-control" name="combinedIecc" id="field_combinedIecc"\n                    ng-model="vm.mapLocation.combinedIecc"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_czNumber">Cz Number</label>\n            <input type="number" class="form-control" name="czNumber" id="field_czNumber"\n                    ng-model="vm.mapLocation.czNumber"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_costElectricity">Cost Electricity</label>\n            <input type="number" class="form-control" name="costElectricity" id="field_costElectricity"\n                    ng-model="vm.mapLocation.costElectricity"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_costGas">Cost Gas</label>\n            <input type="number" class="form-control" name="costGas" id="field_costGas"\n                    ng-model="vm.mapLocation.costGas"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_isActive">Is Active</label>\n            <input type="checkbox" class="form-control" name="isActive" id="field_isActive"\n                    ng-model="vm.mapLocation.isActive"\n                     />\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/map-location/map-locations.html','<div>\n    <h2>Map Locations</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="map-location.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Create new Map Location\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr>\n                    <th><span>ID</span></th>\n                    <th><span>Country Id</span></th>\n                    <th><span>Country</span></th>\n                    <th><span>Country Abbrev</span></th>\n                    <th><span>State Id</span></th>\n                    <th><span>State Name</span></th>\n                    <th><span>State Abbrev</span></th>\n                    <th><span>City</span></th>\n                    <th><span>Latitude</span></th>\n                    <th><span>Longitude</span></th>\n                    <th><span>Climate Zone Name</span></th>\n                    <th><span>Iecc Climate Type</span></th>\n                    <th><span>Iecc Climate Zone</span></th>\n                    <th><span>Hdd 65</span></th>\n                    <th><span>Cdd 65</span></th>\n                    <th><span>City State</span></th>\n                    <th><span>Combined Iecc</span></th>\n                    <th><span>Cz Number</span></th>\n                    <th><span>Cost Electricity</span></th>\n                    <th><span>Cost Gas</span></th>\n                    <th><span>Is Active</span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="mapLocation in vm.mapLocations track by mapLocation.id">\n                    <td><a ui-sref="map-location-detail({id:mapLocation.id})">{{mapLocation.id}}</a></td>\n                    <td>{{mapLocation.countryId}}</td>\n                    <td>{{mapLocation.country}}</td>\n                    <td>{{mapLocation.countryAbbrev}}</td>\n                    <td>{{mapLocation.stateId}}</td>\n                    <td>{{mapLocation.stateName}}</td>\n                    <td>{{mapLocation.stateAbbrev}}</td>\n                    <td>{{mapLocation.city}}</td>\n                    <td>{{mapLocation.latitude}}</td>\n                    <td>{{mapLocation.longitude}}</td>\n                    <td>{{mapLocation.climateZoneName}}</td>\n                    <td>{{mapLocation.ieccClimateType}}</td>\n                    <td>{{mapLocation.ieccClimateZone}}</td>\n                    <td>{{mapLocation.hdd65}}</td>\n                    <td>{{mapLocation.cdd65}}</td>\n                    <td>{{mapLocation.cityState}}</td>\n                    <td>{{mapLocation.combinedIecc}}</td>\n                    <td>{{mapLocation.czNumber}}</td>\n                    <td>{{mapLocation.costElectricity}}</td>\n                    <td>{{mapLocation.costGas}}</td>\n                    <td>{{mapLocation.isActive}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="map-location-detail({id:mapLocation.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="map-location.edit({id:mapLocation.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="map-location.delete({id:mapLocation.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/entities/moisture-transfer/moisture-transfer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.moistureTransfer.id)">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title">Confirm delete operation</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <p>Are you sure you want to delete this Moisture Transfer?</p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/moisture-transfer/moisture-transfer-detail.html','\n<div>\n    <h2><span>Moisture Transfer</span> {{vm.moistureTransfer.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class="dl-horizontal jh-entity-details">\n        <dt><span>Ex 2</span></dt>\n        <dd>\n            <span>{{vm.moistureTransfer.ex2}}</span>\n        </dd>\n        <dt><span>Ex</span></dt>\n        <dd>\n            <span>{{vm.moistureTransfer.ex}}</span>\n        </dd>\n        <dt><span>Econstant</span></dt>\n        <dd>\n            <span>{{vm.moistureTransfer.econstant}}</span>\n        </dd>\n        <dt><span>Building Type</span></dt>\n        <dd>\n            <a ui-sref="building-type-detail({id:vm.moistureTransfer.buildingType.id})">{{vm.moistureTransfer.buildingType.id}}</a>\n        </dd>\n        <dt><span>Map Location</span></dt>\n        <dd>\n            <a ui-sref="map-location-detail({id:vm.moistureTransfer.mapLocation.id})">{{vm.moistureTransfer.mapLocation.id}}</a>\n        </dd>\n    </dl>\n\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\n    </button>\n\n    <button type="button" ui-sref="moisture-transfer-detail.edit({id:vm.moistureTransfer.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-xs hidden-sm"> Edit</span>\n    </button>\n</div>\n');
$templateCache.put('app/entities/moisture-transfer/moisture-transfer-dialog.html','\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myMoistureTransferLabel">Create or edit a Moisture Transfer</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.moistureTransfer.id">\n            <label for="id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.moistureTransfer.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_ex2">Ex 2</label>\n            <input type="number" class="form-control" name="ex2" id="field_ex2"\n                    ng-model="vm.moistureTransfer.ex2"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_ex">Ex</label>\n            <input type="number" class="form-control" name="ex" id="field_ex"\n                    ng-model="vm.moistureTransfer.ex"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_econstant">Econstant</label>\n            <input type="number" class="form-control" name="econstant" id="field_econstant"\n                    ng-model="vm.moistureTransfer.econstant"\n                     />\n        </div>\n\n        <div class="form-group">\n            <label for="field_buildingType">Building Type</label>\n            <select class="form-control" id="field_buildingType" name="buildingType" ng-model="vm.moistureTransfer.buildingType" ng-options="buildingType as buildingType.id for buildingType in vm.buildingtypes track by buildingType.id">\n                <option value=""></option>\n            </select>\n        </div>\n        <div class="form-group">\n            <label for="field_mapLocation">Map Location</label>\n            <select class="form-control" id="field_mapLocation" name="mapLocation" ng-model="vm.moistureTransfer.mapLocation" ng-options="mapLocation as mapLocation.id for mapLocation in vm.maplocations track by mapLocation.id">\n                <option value=""></option>\n            </select>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/moisture-transfer/moisture-transfers.html','<div>\n    <h2>Moisture Transfers</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="moisture-transfer.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Create new Moisture Transfer\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr>\n                    <th><span>ID</span></th>\n                    <th><span>Ex 2</span></th>\n                    <th><span>Ex</span></th>\n                    <th><span>Econstant</span></th>\n                    <th><span>Building Type</span></th>\n                    <th><span>Map Location</span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="moistureTransfer in vm.moistureTransfers track by moistureTransfer.id">\n                    <td><a ui-sref="moisture-transfer-detail({id:moistureTransfer.id})">{{moistureTransfer.id}}</a></td>\n                    <td>{{moistureTransfer.ex2}}</td>\n                    <td>{{moistureTransfer.ex}}</td>\n                    <td>{{moistureTransfer.econstant}}</td>\n                    <td>\n                        <a ui-sref="building-type-detail({id:moistureTransfer.buildingType.id})">{{moistureTransfer.buildingType.id}}</a>\n                    </td>\n                    <td>\n                        <a ui-sref="map-location-detail({id:moistureTransfer.mapLocation.id})">{{moistureTransfer.mapLocation.id}}</a>\n                    </td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="moisture-transfer-detail({id:moistureTransfer.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="moisture-transfer.edit({id:moistureTransfer.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="moisture-transfer.delete({id:moistureTransfer.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/entities/raw-data/raw-data-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rawData.id)">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title">Confirm delete operation</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <p>Are you sure you want to delete this Raw Data?</p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/raw-data/raw-data-detail.html','\n<div>\n    <h2><span>Raw Data</span> {{vm.rawData.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class="dl-horizontal jh-entity-details">\n        <dt><span>Srnum</span></dt>\n        <dd>\n            <span>{{vm.rawData.srnum}}</span>\n        </dd>\n        <dt><span>Country</span></dt>\n        <dd>\n            <span>{{vm.rawData.country}}</span>\n        </dd>\n        <dt><span>State Name</span></dt>\n        <dd>\n            <span>{{vm.rawData.stateName}}</span>\n        </dd>\n        <dt><span>City</span></dt>\n        <dd>\n            <span>{{vm.rawData.city}}</span>\n        </dd>\n        <dt><span>Ebase</span></dt>\n        <dd>\n            <span>{{vm.rawData.ebase}}</span>\n        </dd>\n        <dt><span>Ebase 1</span></dt>\n        <dd>\n            <span>{{vm.rawData.ebase1}}</span>\n        </dd>\n        <dt><span>Ebase 2</span></dt>\n        <dd>\n            <span>{{vm.rawData.ebase2}}</span>\n        </dd>\n        <dt><span>Ebase 3</span></dt>\n        <dd>\n            <span>{{vm.rawData.ebase3}}</span>\n        </dd>\n        <dt><span>Gbase</span></dt>\n        <dd>\n            <span>{{vm.rawData.gbase}}</span>\n        </dd>\n        <dt><span>Gbase 1</span></dt>\n        <dd>\n            <span>{{vm.rawData.gbase1}}</span>\n        </dd>\n        <dt><span>Gbase 2</span></dt>\n        <dd>\n            <span>{{vm.rawData.gbase2}}</span>\n        </dd>\n        <dt><span>Gbase 3</span></dt>\n        <dd>\n            <span>{{vm.rawData.gbase3}}</span>\n        </dd>\n        <dt><span>Ex 2</span></dt>\n        <dd>\n            <span>{{vm.rawData.ex2}}</span>\n        </dd>\n        <dt><span>Ex</span></dt>\n        <dd>\n            <span>{{vm.rawData.ex}}</span>\n        </dd>\n        <dt><span>Gx 2</span></dt>\n        <dd>\n            <span>{{vm.rawData.gx2}}</span>\n        </dd>\n        <dt><span>Gx</span></dt>\n        <dd>\n            <span>{{vm.rawData.gx}}</span>\n        </dd>\n        <dt><span>Econstant</span></dt>\n        <dd>\n            <span>{{vm.rawData.econstant}}</span>\n        </dd>\n        <dt><span>Gconstant</span></dt>\n        <dd>\n            <span>{{vm.rawData.gconstant}}</span>\n        </dd>\n        <dt><span>Building Type</span></dt>\n        <dd>\n            <a ui-sref="building-type-detail({id:vm.rawData.buildingType.id})">{{vm.rawData.buildingType.id}}</a>\n        </dd>\n    </dl>\n\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\n    </button>\n\n    <button type="button" ui-sref="raw-data-detail.edit({id:vm.rawData.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-xs hidden-sm"> Edit</span>\n    </button>\n</div>\n');
$templateCache.put('app/entities/raw-data/raw-data-dialog.html','\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myRawDataLabel">Create or edit a Raw Data</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.rawData.id">\n            <label for="id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.rawData.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_srnum">Srnum</label>\n            <input type="number" class="form-control" name="srnum" id="field_srnum"\n                    ng-model="vm.rawData.srnum"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_country">Country</label>\n            <input type="text" class="form-control" name="country" id="field_country"\n                    ng-model="vm.rawData.country"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_stateName">State Name</label>\n            <input type="text" class="form-control" name="stateName" id="field_stateName"\n                    ng-model="vm.rawData.stateName"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_city">City</label>\n            <input type="text" class="form-control" name="city" id="field_city"\n                    ng-model="vm.rawData.city"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_ebase">Ebase</label>\n            <input type="number" class="form-control" name="ebase" id="field_ebase"\n                    ng-model="vm.rawData.ebase"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_ebase1">Ebase 1</label>\n            <input type="number" class="form-control" name="ebase1" id="field_ebase1"\n                    ng-model="vm.rawData.ebase1"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_ebase2">Ebase 2</label>\n            <input type="number" class="form-control" name="ebase2" id="field_ebase2"\n                    ng-model="vm.rawData.ebase2"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_ebase3">Ebase 3</label>\n            <input type="number" class="form-control" name="ebase3" id="field_ebase3"\n                    ng-model="vm.rawData.ebase3"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gbase">Gbase</label>\n            <input type="number" class="form-control" name="gbase" id="field_gbase"\n                    ng-model="vm.rawData.gbase"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gbase1">Gbase 1</label>\n            <input type="number" class="form-control" name="gbase1" id="field_gbase1"\n                    ng-model="vm.rawData.gbase1"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gbase2">Gbase 2</label>\n            <input type="number" class="form-control" name="gbase2" id="field_gbase2"\n                    ng-model="vm.rawData.gbase2"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gbase3">Gbase 3</label>\n            <input type="number" class="form-control" name="gbase3" id="field_gbase3"\n                    ng-model="vm.rawData.gbase3"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_ex2">Ex 2</label>\n            <input type="number" class="form-control" name="ex2" id="field_ex2"\n                    ng-model="vm.rawData.ex2"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_ex">Ex</label>\n            <input type="number" class="form-control" name="ex" id="field_ex"\n                    ng-model="vm.rawData.ex"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gx2">Gx 2</label>\n            <input type="number" class="form-control" name="gx2" id="field_gx2"\n                    ng-model="vm.rawData.gx2"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gx">Gx</label>\n            <input type="number" class="form-control" name="gx" id="field_gx"\n                    ng-model="vm.rawData.gx"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_econstant">Econstant</label>\n            <input type="number" class="form-control" name="econstant" id="field_econstant"\n                    ng-model="vm.rawData.econstant"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_gconstant">Gconstant</label>\n            <input type="number" class="form-control" name="gconstant" id="field_gconstant"\n                    ng-model="vm.rawData.gconstant"\n                     />\n        </div>\n\n        <div class="form-group">\n            <label for="field_buildingType">Building Type</label>\n            <select class="form-control" id="field_buildingType" name="buildingType" ng-model="vm.rawData.buildingType" ng-options="buildingType as buildingType.id for buildingType in vm.buildingtypes track by buildingType.id">\n                <option value=""></option>\n            </select>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/raw-data/raw-data.html','<div>\n    <h2>Raw Data</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="raw-data.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Create new Raw Data\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr>\n                    <th><span>ID</span></th>\n                    <th><span>Srnum</span></th>\n                    <th><span>Country</span></th>\n                    <th><span>State Name</span></th>\n                    <th><span>City</span></th>\n                    <th><span>Ebase</span></th>\n                    <th><span>Ebase 1</span></th>\n                    <th><span>Ebase 2</span></th>\n                    <th><span>Ebase 3</span></th>\n                    <th><span>Gbase</span></th>\n                    <th><span>Gbase 1</span></th>\n                    <th><span>Gbase 2</span></th>\n                    <th><span>Gbase 3</span></th>\n                    <th><span>Ex 2</span></th>\n                    <th><span>Ex</span></th>\n                    <th><span>Gx 2</span></th>\n                    <th><span>Gx</span></th>\n                    <th><span>Econstant</span></th>\n                    <th><span>Gconstant</span></th>\n                    <th><span>Building Type</span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="rawData in vm.rawData track by rawData.id">\n                    <td><a ui-sref="raw-data-detail({id:rawData.id})">{{rawData.id}}</a></td>\n                    <td>{{rawData.srnum}}</td>\n                    <td>{{rawData.country}}</td>\n                    <td>{{rawData.stateName}}</td>\n                    <td>{{rawData.city}}</td>\n                    <td>{{rawData.ebase}}</td>\n                    <td>{{rawData.ebase1}}</td>\n                    <td>{{rawData.ebase2}}</td>\n                    <td>{{rawData.ebase3}}</td>\n                    <td>{{rawData.gbase}}</td>\n                    <td>{{rawData.gbase1}}</td>\n                    <td>{{rawData.gbase2}}</td>\n                    <td>{{rawData.gbase3}}</td>\n                    <td>{{rawData.ex2}}</td>\n                    <td>{{rawData.ex}}</td>\n                    <td>{{rawData.gx2}}</td>\n                    <td>{{rawData.gx}}</td>\n                    <td>{{rawData.econstant}}</td>\n                    <td>{{rawData.gconstant}}</td>\n                    <td>\n                        <a ui-sref="building-type-detail({id:rawData.buildingType.id})">{{rawData.buildingType.id}}</a>\n                    </td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="raw-data-detail({id:rawData.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="raw-data.edit({id:rawData.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="raw-data.delete({id:rawData.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/entities/us-state/us-state-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.usState.id)">\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title">Confirm delete operation</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <p>Are you sure you want to delete this Us State?</p>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/us-state/us-state-detail.html','\n<div>\n    <h2><span>Us State</span> {{vm.usState.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class="dl-horizontal jh-entity-details">\n        <dt><span>State Id</span></dt>\n        <dd>\n            <span>{{vm.usState.stateId}}</span>\n        </dd>\n        <dt><span>State Name</span></dt>\n        <dd>\n            <span>{{vm.usState.stateName}}</span>\n        </dd>\n        <dt><span>State Abbrev</span></dt>\n        <dd>\n            <span>{{vm.usState.stateAbbrev}}</span>\n        </dd>\n    </dl>\n\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\n    </button>\n\n    <button type="button" ui-sref="us-state-detail.edit({id:vm.usState.id})" class="btn btn-primary">\n        <span class="glyphicon glyphicon-pencil"></span>\n        <span class="hidden-xs hidden-sm"> Edit</span>\n    </button>\n</div>\n');
$templateCache.put('app/entities/us-state/us-state-dialog.html','\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\n\n    <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.clear()">&times;</button>\n        <h4 class="modal-title" id="myUsStateLabel">Create or edit a Us State</h4>\n    </div>\n    <div class="modal-body">\n        <jhi-alert-error></jhi-alert-error>\n        <div class="form-group" ng-show="vm.usState.id">\n            <label for="id">ID</label>\n            <input type="text" class="form-control" id="id" name="id"\n                    ng-model="vm.usState.id" readonly />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_stateId">State Id</label>\n            <input type="number" class="form-control" name="stateId" id="field_stateId"\n                    ng-model="vm.usState.stateId"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_stateName">State Name</label>\n            <input type="text" class="form-control" name="stateName" id="field_stateName"\n                    ng-model="vm.usState.stateName"\n                     />\n        </div>\n        <div class="form-group">\n            <label class="control-label" for="field_stateAbbrev">State Abbrev</label>\n            <input type="text" class="form-control" name="stateAbbrev" id="field_stateAbbrev"\n                    ng-model="vm.usState.stateAbbrev"\n                     />\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\n        </button>\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\n        </button>\n    </div>\n</form>\n');
$templateCache.put('app/entities/us-state/us-states.html','<div>\n    <h2>Us States</h2>\n    <jhi-alert></jhi-alert>\n    <div class="container-fluid">\n        <div class="row">\n            <div class="col-xs-4 no-padding-left">\n                <button class="btn btn-primary" ui-sref="us-state.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Create new Us State\n                    </span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <br/>\n    <div class="table-responsive">\n        <table class="jh-table table table-striped">\n            <thead>\n                <tr>\n                    <th><span>ID</span></th>\n                    <th><span>State Id</span></th>\n                    <th><span>State Name</span></th>\n                    <th><span>State Abbrev</span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="usState in vm.usStates track by usState.id">\n                    <td><a ui-sref="us-state-detail({id:usState.id})">{{usState.id}}</a></td>\n                    <td>{{usState.stateId}}</td>\n                    <td>{{usState.stateName}}</td>\n                    <td>{{usState.stateAbbrev}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="us-state-detail({id:usState.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="us-state.edit({id:usState.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="us-state.delete({id:usState.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div>\n    <div class="row">\n        <div class="col-md-4 col-md-offset-4">\n            <h1>Reset password</h1>\n\n            <div class="alert alert-danger" ng-show="vm.keyMissing">\n                <strong>The password reset key is missing.</strong>\n            </div>\n\n            <div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing">\n                <p>Choose a new password</p>\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.error">\n                <p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p>\n            </div>\n\n            <div class="alert alert-success" ng-show="vm.success">\n                <p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p>\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.doNotMatch">\n                The password and its confirmation do not match!\n            </div>\n\n            <div ng-hide="vm.keyMissing">\n                <form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation>\n                    <div class="form-group">\n                        <label class="control-label" for="password">New password</label>\n                        <input type="password" class="form-control" id="password" name="password" placeholder="New password"\n                               ng-model="vm.resetAccount.password" ng-minlength=4 ng-maxlength=50 required>\n                        <div ng-show="form.password.$dirty && form.password.$invalid">\n                            <p class="help-block"\n                               ng-show="form.password.$error.required">\n                                Your password is required.\n                            </p>\n                            <p class="help-block"\n                               ng-show="form.password.$error.minlength">\n                                Your password is required to be at least 4 characters.\n                            </p>\n                            <p class="help-block"\n                               ng-show="form.password.$error.maxlength">\n                                Your password cannot be longer than 50 characters.\n                            </p>\n                        </div>\n                        <password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="control-label" for="confirmPassword">New password confirmation</label>\n                        <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password"\n                               ng-model="vm.confirmPassword" ng-minlength=4 ng-maxlength=50 required>\n                        <div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid">\n                            <p class="help-block"\n                               ng-show="form.confirmPassword.$error.required">\n                                Your password confirmation is required.\n                            </p>\n                            <p class="help-block"\n                               ng-show="form.confirmPassword.$error.minlength">\n                                Your password confirmation is required to be at least 4 characters.\n                            </p>\n                            <p class="help-block"\n                               ng-show="form.confirmPassword.$error.maxlength">\n                                Your password confirmation cannot be longer than 50 characters.\n                            </p>\n                        </div>\n                    </div>\n                    <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button>\n                </form>\n            </div>\n\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/account/reset/request/reset.request.html','<div>\n    <div class="row">\n        <div class="col-md-8 col-md-offset-2">\n            <h1>Reset your password</h1>\n\n            <div class="alert alert-danger" ng-show="vm.errorEmailNotExists">\n                <strong>E-Mail address isn\'t registered!</strong> Please check and try again.\n            </div>\n\n            <div class="alert alert-warning" ng-hide="vm.success">\n                <p>Enter the e-mail address you used to register.</p>\n            </div>\n\n            <div class="alert alert-success" ng-show="vm.success == \'OK\'">\n                <p>Check your e-mails for details on how to reset your password.</p>\n            </div>\n\n            <form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation>\n                <div class="form-group">\n                    <label class="control-label" for="email">E-mail</label>\n                    <input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail"\n                           ng-model="vm.resetAccount.email" ng-minlength=5 ng-maxlength=100 required>\n                    <div ng-show="form.email.$dirty && form.email.$invalid">\n                        <p class="help-block"\n                           ng-show="form.email.$error.required">\n                            Your e-mail is required.\n                        </p>\n                        <p class="help-block"\n                           ng-show="form.email.$error.email">\n                            Your e-mail is invalid.\n                        </p>\n                        <p class="help-block"\n                           ng-show="form.email.$error.minlength">\n                            Your e-mail is required to be at least 5 characters.\n                        </p>\n                        <p class="help-block"\n                           ng-show="form.email.$error.maxlength">\n                            Your e-mail cannot be longer than 100 characters.\n                        </p>\n                    </div>\n                </div>\n                <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button>\n            </form>\n\n        </div>\n    </div>\n</div>\n');}]);})();